// Hook para obtener traducciones por página
// Cada página puede tener sus propios textos en múltiples idiomas
import { useTranslation } from 'react-i18next';

export const getPageTexts = (pageName, lang = 'es') => {
  const texts = pageTranslations[pageName];
  if (!texts) return {};
  return texts[lang] || texts.es;
};

export const getCurrentLanguage = () => {
  const lang = localStorage.getItem('i18nextLng') || 'es';
  return lang.split('-')[0];
};

export const useLanguage = () => {
  const { i18n } = useTranslation();
  return (i18n.language || 'es').split('-')[0];
};

export const pageTranslations = {
  liftingFacial: {
    es: {
      title: 'Lifting y Rejuvenecimiento Facial',
      heroSubtitle: 'Recupera la firmeza y juventud de tu rostro con técnicas avanzadas de cirugía facial.',
      bookConsult: 'Reserva tu consulta con el Dr. Ángel Norro y recibe un plan de tratamiento personalizado.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reales de Lifting Facial',
      before: 'Antes',
      after: 'Después',
      preoperative: 'Preoperatorio',
      twoWeeks: '2 semanas',
      postoperative: 'Postoperatorio',
      neckLift: 'Lifting de Cuello',
      nextDayResult: 'Resultado al día siguiente de recibir el alta',
      nextDay: 'Al día siguiente (alta)',
      realCases: 'Casos reales - Resultados pueden variar según cada paciente',
      whatIs: '¿Qué es el Lifting Facial?',
      whatIsDesc1: 'El lifting facial o ritidectomía es una intervención quirúrgica que permite corregir los signos de envejecimiento del rostro y cuello, devolviendo un aspecto más joven y descansado.',
      whatIsDesc2: 'Esta técnica permite tensar la piel y los músculos faciales, eliminando el exceso de piel y reposicionando los tejidos para un resultado natural y duradero.',
      isForYou: '¿Es para ti el lifting facial?',
      sign1: 'Notas flacidez en mejillas y mandíbula.',
      sign2: 'Tienes surcos nasolabiales marcados.',
      sign3: 'Has perdido la definición del óvalo facial.',
      sign4: 'Presentas papada o exceso de piel en el cuello.',
      sign5: 'Deseas un aspecto más joven pero natural.',
      exclusiveProtocol: 'PROTOCOLO EXCLUSIVO',
      newlipTitle: 'Protocolo NewLip®',
      newlipDesc: 'El Dr. Ángel Norro es el creador del protocolo patentado NewLip®, una técnica exclusiva que aplica junto con el lifting facial para ofrecer resultados espectaculares con rejuvenecimiento profundo de la piel.',
      yearsExp: 'años de experiencia',
      patented: 'Protocolo patentado',
      naturalResults: 'Resultados naturales',
      benefits: 'Beneficios del Lifting Facial',
      benefitsDesc: 'El lifting facial ofrece resultados naturales y duraderos, devolviendo la armonía a tu rostro.',
      benefit1: 'Rejuvenece el aspecto facial entre 10-15 años.',
      benefit2: 'Resultados duraderos de 8 a 12 años.',
      benefit3: 'Mejora la definición del contorno facial.',
      benefit4: 'Elimina el exceso de piel y flacidez.',
      benefit5: 'Cicatrices discretas ocultas en líneas naturales.',
      doctorTitle: 'Experiencia y profesionalidad a tu servicio',
      doctorDesc1: 'Soy el doctor Ángel Norro, cirujano plástico con más de 30 años de experiencia en rejuvenecimiento facial.',
      doctorDesc2: 'Mi objetivo es conseguir resultados naturales que respeten la expresión y personalidad de cada paciente.',
      doctorDesc3: 'Utilizo las técnicas más avanzadas para garantizar una recuperación rápida y resultados duraderos.',
      ctaTitle: '¿Listo para rejuvenecer tu rostro?',
      ctaSubtitle: 'Contacta con nosotros para una consulta personalizada',
    },
    en: {
      title: 'Facelift and Facial Rejuvenation',
      heroSubtitle: 'Restore firmness and youth to your face with advanced facial surgery techniques.',
      bookConsult: 'Book your consultation with Dr. Ángel Norro and receive a personalized treatment plan.',
      requestConsult: 'REQUEST CONSULTATION',
      realResults: 'Real Facelift Results',
      before: 'Before',
      after: 'After',
      preoperative: 'Preoperative',
      twoWeeks: '2 weeks',
      postoperative: 'Postoperative',
      neckLift: 'Neck Lift',
      nextDayResult: 'Result the day after discharge',
      nextDay: 'Next day (discharge)',
      realCases: 'Real cases - Results may vary for each patient',
      whatIs: 'What is a Facelift?',
      whatIsDesc1: 'A facelift or rhytidectomy is a surgical procedure that corrects signs of aging in the face and neck, restoring a younger and more rested appearance.',
      whatIsDesc2: 'This technique tightens the skin and facial muscles, removing excess skin and repositioning tissues for a natural and long-lasting result.',
      isForYou: 'Is a facelift right for you?',
      sign1: 'You notice sagging in your cheeks and jawline.',
      sign2: 'You have pronounced nasolabial folds.',
      sign3: 'You have lost definition in your facial contour.',
      sign4: 'You have a double chin or excess neck skin.',
      sign5: 'You want a younger but natural appearance.',
      exclusiveProtocol: 'EXCLUSIVE PROTOCOL',
      newlipTitle: 'NewLip® Protocol',
      newlipDesc: 'Dr. Ángel Norro is the creator of the patented NewLip® protocol, an exclusive technique applied with facelifts to deliver spectacular results with deep skin rejuvenation.',
      yearsExp: 'years of experience',
      patented: 'Patented protocol',
      naturalResults: 'Natural results',
      benefits: 'Benefits of Facelift',
      benefitsDesc: 'A facelift offers natural and long-lasting results, restoring harmony to your face.',
      benefit1: 'Rejuvenates facial appearance by 10-15 years.',
      benefit2: 'Long-lasting results of 8 to 12 years.',
      benefit3: 'Improves facial contour definition.',
      benefit4: 'Removes excess skin and sagging.',
      benefit5: 'Discreet scars hidden in natural lines.',
      doctorTitle: 'Experience and professionalism at your service',
      doctorDesc1: 'I am Dr. Ángel Norro, plastic surgeon with over 30 years of experience in facial rejuvenation.',
      doctorDesc2: 'My goal is to achieve natural results that respect each patient\'s expression and personality.',
      doctorDesc3: 'I use the most advanced techniques to ensure rapid recovery and long-lasting results.',
      ctaTitle: 'Ready to rejuvenate your face?',
      ctaSubtitle: 'Contact us for a personalized consultation',
    },
    fr: {
      title: 'Lifting et Rajeunissement Facial',
      heroSubtitle: 'Retrouvez la fermeté et la jeunesse de votre visage avec des techniques avancées de chirurgie faciale.',
      bookConsult: 'Réservez votre consultation avec le Dr. Ángel Norro et recevez un plan de traitement personnalisé.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      realResults: 'Résultats réels de Lifting Facial',
      before: 'Avant',
      after: 'Après',
      preoperative: 'Préopératoire',
      twoWeeks: '2 semaines',
      postoperative: 'Postopératoire',
      neckLift: 'Lifting du Cou',
      nextDayResult: 'Résultat le lendemain de la sortie',
      nextDay: 'Lendemain (sortie)',
      realCases: 'Cas réels - Les résultats peuvent varier selon chaque patient',
      whatIs: 'Qu\'est-ce qu\'un Lifting Facial?',
      whatIsDesc1: 'Le lifting facial ou rhytidectomie est une intervention chirurgicale qui permet de corriger les signes de vieillissement du visage et du cou, redonnant un aspect plus jeune et reposé.',
      whatIsDesc2: 'Cette technique permet de retendre la peau et les muscles faciaux, en éliminant l\'excès de peau et en repositionnant les tissus pour un résultat naturel et durable.',
      isForYou: 'Le lifting facial est-il fait pour vous?',
      sign1: 'Vous remarquez un relâchement des joues et de la mâchoire.',
      sign2: 'Vous avez des sillons nasogéniens marqués.',
      sign3: 'Vous avez perdu la définition de l\'ovale du visage.',
      sign4: 'Vous présentez un double menton ou un excès de peau au cou.',
      sign5: 'Vous souhaitez un aspect plus jeune mais naturel.',
      exclusiveProtocol: 'PROTOCOLE EXCLUSIF',
      newlipTitle: 'Protocole NewLip®',
      newlipDesc: 'Le Dr. Ángel Norro est le créateur du protocole breveté NewLip®, une technique exclusive appliquée avec le lifting facial pour des résultats spectaculaires avec un rajeunissement cutané profond.',
      yearsExp: 'ans d\'expérience',
      patented: 'Protocole breveté',
      naturalResults: 'Résultats naturels',
      benefits: 'Avantages du Lifting Facial',
      benefitsDesc: 'Le lifting facial offre des résultats naturels et durables, redonnant l\'harmonie à votre visage.',
      benefit1: 'Rajeunit l\'aspect facial de 10 à 15 ans.',
      benefit2: 'Résultats durables de 8 à 12 ans.',
      benefit3: 'Améliore la définition du contour facial.',
      benefit4: 'Élimine l\'excès de peau et le relâchement.',
      benefit5: 'Cicatrices discrètes cachées dans les lignes naturelles.',
      doctorTitle: 'Expérience et professionnalisme à votre service',
      doctorDesc1: 'Je suis le Dr. Ángel Norro, chirurgien plasticien avec plus de 30 ans d\'expérience en rajeunissement facial.',
      doctorDesc2: 'Mon objectif est d\'obtenir des résultats naturels qui respectent l\'expression et la personnalité de chaque patient.',
      doctorDesc3: 'J\'utilise les techniques les plus avancées pour garantir une récupération rapide et des résultats durables.',
      ctaTitle: 'Prêt à rajeunir votre visage?',
      ctaSubtitle: 'Contactez-nous pour une consultation personnalisée',
    },
    pt: {
      title: 'Lifting e Rejuvenescimento Facial',
      heroSubtitle: 'Recupere a firmeza e juventude do seu rosto com técnicas avançadas de cirurgia facial.',
      bookConsult: 'Reserve sua consulta com o Dr. Ángel Norro e receba um plano de tratamento personalizado.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reais de Lifting Facial',
      before: 'Antes',
      after: 'Depois',
      preoperative: 'Pré-operatório',
      twoWeeks: '2 semanas',
      postoperative: 'Pós-operatório',
      neckLift: 'Lifting de Pescoço',
      nextDayResult: 'Resultado no dia seguinte à alta',
      nextDay: 'Dia seguinte (alta)',
      realCases: 'Casos reais - Resultados podem variar para cada paciente',
      whatIs: 'O que é o Lifting Facial?',
      whatIsDesc1: 'O lifting facial ou ritidectomia é uma intervenção cirúrgica que permite corrigir os sinais de envelhecimento do rosto e pescoço, devolvendo um aspecto mais jovem e descansado.',
      whatIsDesc2: 'Esta técnica permite esticar a pele e os músculos faciais, eliminando o excesso de pele e reposicionando os tecidos para um resultado natural e duradouro.',
      isForYou: 'O lifting facial é para você?',
      sign1: 'Você nota flacidez nas bochechas e mandíbula.',
      sign2: 'Você tem sulcos nasolabiais marcados.',
      sign3: 'Você perdeu a definição do contorno facial.',
      sign4: 'Você apresenta papada ou excesso de pele no pescoço.',
      sign5: 'Você deseja um aspecto mais jovem mas natural.',
      exclusiveProtocol: 'PROTOCOLO EXCLUSIVO',
      newlipTitle: 'Protocolo NewLip®',
      newlipDesc: 'O Dr. Ángel Norro é o criador do protocolo patenteado NewLip®, uma técnica exclusiva aplicada com o lifting facial para resultados espetaculares com rejuvenescimento profundo da pele.',
      yearsExp: 'anos de experiência',
      patented: 'Protocolo patenteado',
      naturalResults: 'Resultados naturais',
      benefits: 'Benefícios do Lifting Facial',
      benefitsDesc: 'O lifting facial oferece resultados naturais e duradouros, devolvendo a harmonia ao seu rosto.',
      benefit1: 'Rejuvenesce o aspecto facial entre 10-15 anos.',
      benefit2: 'Resultados duradouros de 8 a 12 anos.',
      benefit3: 'Melhora a definição do contorno facial.',
      benefit4: 'Elimina o excesso de pele e flacidez.',
      benefit5: 'Cicatrizes discretas escondidas em linhas naturais.',
      doctorTitle: 'Experiência e profissionalismo ao seu serviço',
      doctorDesc1: 'Sou o Dr. Ángel Norro, cirurgião plástico com mais de 30 anos de experiência em rejuvenescimento facial.',
      doctorDesc2: 'Meu objetivo é conseguir resultados naturais que respeitem a expressão e personalidade de cada paciente.',
      doctorDesc3: 'Utilizo as técnicas mais avançadas para garantir uma recuperação rápida e resultados duradouros.',
      ctaTitle: 'Pronto para rejuvenescer seu rosto?',
      ctaSubtitle: 'Entre em contato para uma consulta personalizada',
    },
  },
  
  rinoplastia: {
    es: {
      title: 'Rinoplastia',
      heroSubtitle: 'Armoniza tu perfil de forma natural con técnicas avanzadas de cirugía nasal.',
      description: 'La rinoplastia permite corregir tanto aspectos estéticos como funcionales de la nariz, mejorando la armonía facial.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reales de Rinoplastia',
      whatIs: '¿Qué es la Rinoplastia?',
      isForYou: '¿Es para ti la rinoplastia?',
      benefits: 'Beneficios de la Rinoplastia',
    },
    en: {
      title: 'Rhinoplasty',
      heroSubtitle: 'Harmonize your profile naturally with advanced nasal surgery techniques.',
      description: 'Rhinoplasty allows correction of both aesthetic and functional aspects of the nose, improving facial harmony.',
      requestConsult: 'REQUEST CONSULTATION',
      realResults: 'Real Rhinoplasty Results',
      whatIs: 'What is Rhinoplasty?',
      isForYou: 'Is rhinoplasty right for you?',
      benefits: 'Benefits of Rhinoplasty',
    },
    fr: {
      title: 'Rhinoplastie',
      heroSubtitle: 'Harmonisez votre profil naturellement avec des techniques avancées de chirurgie nasale.',
      description: 'La rhinoplastie permet de corriger les aspects esthétiques et fonctionnels du nez, améliorant l\'harmonie faciale.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      realResults: 'Résultats réels de Rhinoplastie',
      whatIs: 'Qu\'est-ce que la Rhinoplastie?',
      isForYou: 'La rhinoplastie est-elle faite pour vous?',
      benefits: 'Avantages de la Rhinoplastie',
    },
    pt: {
      title: 'Rinoplastia',
      heroSubtitle: 'Harmonize seu perfil naturalmente com técnicas avançadas de cirurgia nasal.',
      description: 'A rinoplastia permite corrigir aspectos estéticos e funcionais do nariz, melhorando a harmonia facial.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reais de Rinoplastia',
      whatIs: 'O que é a Rinoplastia?',
      isForYou: 'A rinoplastia é para você?',
      benefits: 'Benefícios da Rinoplastia',
    },
  },

  otoplastia: {
    es: {
      title: 'Otoplastia',
      heroSubtitle: 'Corrige las orejas prominentes con una técnica mínimamente invasiva.',
      description: 'La otoplastia permite corregir la forma, posición o proporción de las orejas, mejorando la armonía facial.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reales de Otoplastia',
    },
    en: {
      title: 'Otoplasty',
      heroSubtitle: 'Correct prominent ears with a minimally invasive technique.',
      description: 'Otoplasty allows correction of the shape, position or proportion of the ears, improving facial harmony.',
      requestConsult: 'REQUEST CONSULTATION',
      realResults: 'Real Otoplasty Results',
    },
    fr: {
      title: 'Otoplastie',
      heroSubtitle: 'Corrigez les oreilles décollées avec une technique peu invasive.',
      description: 'L\'otoplastie permet de corriger la forme, la position ou la proportion des oreilles, améliorant l\'harmonie faciale.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      realResults: 'Résultats réels d\'Otoplastie',
    },
    pt: {
      title: 'Otoplastia',
      heroSubtitle: 'Corrija as orelhas proeminentes com uma técnica minimamente invasiva.',
      description: 'A otoplastia permite corrigir a forma, posição ou proporção das orelhas, melhorando a harmonia facial.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reais de Otoplastia',
    },
  },

  cirugiaMamas: {
    es: {
      title: 'Cirugía de Mamas',
      heroSubtitle: 'Realza tu silueta de forma natural con técnicas personalizadas.',
      aumento: 'Aumento de Mamas',
      reduccion: 'Reducción Mamaria',
      mastopexia: 'Mastopexia (Elevación)',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reales',
      planification: 'Planificación',
    },
    en: {
      title: 'Breast Surgery',
      heroSubtitle: 'Enhance your silhouette naturally with personalized techniques.',
      aumento: 'Breast Augmentation',
      reduccion: 'Breast Reduction',
      mastopexia: 'Mastopexy (Lift)',
      requestConsult: 'REQUEST CONSULTATION',
      realResults: 'Real results',
      planification: 'Planning',
    },
    fr: {
      title: 'Chirurgie Mammaire',
      heroSubtitle: 'Sublimez votre silhouette naturellement avec des techniques personnalisées.',
      aumento: 'Augmentation Mammaire',
      reduccion: 'Réduction Mammaire',
      mastopexia: 'Mastopexie (Lifting)',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      realResults: 'Résultats réels',
      planification: 'Planification',
    },
    pt: {
      title: 'Cirurgia de Mamas',
      heroSubtitle: 'Realce sua silhueta naturalmente com técnicas personalizadas.',
      aumento: 'Aumento de Mamas',
      reduccion: 'Redução Mamária',
      mastopexia: 'Mastopexia (Elevação)',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reais',
      planification: 'Planejamento',
    },
  },

  ginecomastia: {
    es: {
      title: 'Ginecomastia',
      heroSubtitle: 'Recupera un torso masculino definido con resultados definitivos.',
      description: 'La ginecomastia es el aumento del tejido mamario en hombres. La cirugía permite recuperar un contorno pectoral masculino.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reales de Ginecomastia',
    },
    en: {
      title: 'Gynecomastia',
      heroSubtitle: 'Restore a defined masculine torso with definitive results.',
      description: 'Gynecomastia is the enlargement of breast tissue in men. Surgery allows restoration of a masculine chest contour.',
      requestConsult: 'REQUEST CONSULTATION',
      realResults: 'Real Gynecomastia Results',
    },
    fr: {
      title: 'Gynécomastie',
      heroSubtitle: 'Retrouvez un torse masculin défini avec des résultats définitifs.',
      description: 'La gynécomastie est l\'augmentation du tissu mammaire chez l\'homme. La chirurgie permet de retrouver un contour pectoral masculin.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      realResults: 'Résultats réels de Gynécomastie',
    },
    pt: {
      title: 'Ginecomastia',
      heroSubtitle: 'Recupere um torso masculino definido com resultados definitivos.',
      description: 'A ginecomastia é o aumento do tecido mamário em homens. A cirurgia permite recuperar um contorno peitoral masculino.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reais de Ginecomastia',
    },
  },

  abdominoplastia: {
    es: {
      title: 'Abdominoplastia',
      heroSubtitle: 'Consigue un abdomen firme y tonificado.',
      description: 'La abdominoplastia elimina el exceso de piel y grasa abdominal, reparando los músculos debilitados.',
      requestConsult: 'SOLICITAR CONSULTA',
    },
    en: {
      title: 'Abdominoplasty',
      heroSubtitle: 'Achieve a firm and toned abdomen.',
      description: 'Abdominoplasty removes excess abdominal skin and fat while repairing weakened muscles.',
      requestConsult: 'REQUEST CONSULTATION',
    },
    fr: {
      title: 'Abdominoplastie',
      heroSubtitle: 'Obtenez un abdomen ferme et tonique.',
      description: 'L\'abdominoplastie élimine l\'excès de peau et de graisse abdominale tout en réparant les muscles affaiblis.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
    },
    pt: {
      title: 'Abdominoplastia',
      heroSubtitle: 'Consiga um abdômen firme e tonificado.',
      description: 'A abdominoplastia remove o excesso de pele e gordura abdominal, reparando os músculos enfraquecidos.',
      requestConsult: 'SOLICITAR CONSULTA',
    },
  },

  liposuccion: {
    es: {
      title: 'Liposucción',
      heroSubtitle: 'Redefine tu contorno corporal con técnicas avanzadas.',
      description: 'La liposucción elimina los depósitos de grasa localizada que no responden a dieta ni ejercicio.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reales de Liposucción',
    },
    en: {
      title: 'Liposuction',
      heroSubtitle: 'Redefine your body contour with advanced techniques.',
      description: 'Liposuction removes localized fat deposits that do not respond to diet or exercise.',
      requestConsult: 'REQUEST CONSULTATION',
      realResults: 'Real Liposuction Results',
    },
    fr: {
      title: 'Liposuccion',
      heroSubtitle: 'Redéfinissez votre silhouette avec des techniques avancées.',
      description: 'La liposuccion élimine les dépôts de graisse localisée qui ne répondent pas au régime ni à l\'exercice.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      realResults: 'Résultats réels de Liposuccion',
    },
    pt: {
      title: 'Lipoaspiração',
      heroSubtitle: 'Redefina seu contorno corporal com técnicas avançadas.',
      description: 'A lipoaspiração remove os depósitos de gordura localizada que não respondem a dieta nem exercício.',
      requestConsult: 'SOLICITAR CONSULTA',
      realResults: 'Resultados reais de Lipoaspiração',
    },
  },

  rinomodelacion: {
    es: {
      title: 'Rinomodelación®',
      heroSubtitle: 'Mejora tu nariz sin cirugía. Resultados inmediatos.',
      description: 'La Rinomodelación® es una técnica exclusiva y marca registrada del Dr. Norro para corregir imperfecciones nasales sin quirófano.',
      requestConsult: 'SOLICITAR CONSULTA',
      registered: 'Marca Registrada OEPM',
    },
    en: {
      title: 'Rhinomodeling®',
      heroSubtitle: 'Improve your nose without surgery. Immediate results.',
      description: 'Rhinomodeling® is an exclusive technique and registered trademark of Dr. Norro to correct nasal imperfections without surgery.',
      requestConsult: 'REQUEST CONSULTATION',
      registered: 'OEPM Registered Trademark',
    },
    fr: {
      title: 'Rhinomodelage®',
      heroSubtitle: 'Améliorez votre nez sans chirurgie. Résultats immédiats.',
      description: 'Le Rhinomodelage® est une technique exclusive et marque déposée du Dr. Norro pour corriger les imperfections nasales sans chirurgie.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      registered: 'Marque Déposée OEPM',
    },
    pt: {
      title: 'Rinomodelação®',
      heroSubtitle: 'Melhore seu nariz sem cirurgia. Resultados imediatos.',
      description: 'A Rinomodelação® é uma técnica exclusiva e marca registrada do Dr. Norro para corrigir imperfeições nasais sem cirurgia.',
      requestConsult: 'SOLICITAR CONSULTA',
      registered: 'Marca Registrada OEPM',
    },
  },

  endolifting: {
    es: {
      title: 'Endolifting Láser',
      heroSubtitle: 'Rejuvenecimiento facial sin cicatrices visibles.',
      description: 'El endolifting utiliza tecnología láser para tensar la piel desde el interior, sin incisiones externas.',
      requestConsult: 'SOLICITAR CONSULTA',
    },
    en: {
      title: 'Laser Endolifting',
      heroSubtitle: 'Facial rejuvenation without visible scars.',
      description: 'Endolifting uses laser technology to tighten skin from the inside, without external incisions.',
      requestConsult: 'REQUEST CONSULTATION',
    },
    fr: {
      title: 'Endolifting Laser',
      heroSubtitle: 'Rajeunissement facial sans cicatrices visibles.',
      description: 'L\'endolifting utilise la technologie laser pour retendre la peau de l\'intérieur, sans incisions externes.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
    },
    pt: {
      title: 'Endolifting Laser',
      heroSubtitle: 'Rejuvenescimento facial sem cicatrizes visíveis.',
      description: 'O endolifting utiliza tecnologia laser para esticar a pele por dentro, sem incisões externas.',
      requestConsult: 'SOLICITAR CONSULTA',
    },
  },

  papada: {
    es: {
      title: 'Eliminación de Papada',
      heroSubtitle: 'Define tu perfil cervical de forma natural.',
      description: 'Diferentes técnicas para reducir el tejido submentoniano y conseguir un perfil más definido.',
      requestConsult: 'SOLICITAR CONSULTA',
    },
    en: {
      title: 'Jowl Removal',
      heroSubtitle: 'Define your cervical profile naturally.',
      description: 'Different techniques to reduce submental tissue and achieve a more defined profile.',
      requestConsult: 'REQUEST CONSULTATION',
    },
    fr: {
      title: 'Élimination du Double Menton',
      heroSubtitle: 'Définissez votre profil cervical naturellement.',
      description: 'Différentes techniques pour réduire le tissu sous-mentonnier et obtenir un profil plus défini.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
    },
    pt: {
      title: 'Eliminação de Papada',
      heroSubtitle: 'Defina seu perfil cervical naturalmente.',
      description: 'Diferentes técnicas para reduzir o tecido submentoniano e conseguir um perfil mais definido.',
      requestConsult: 'SOLICITAR CONSULTA',
    },
  },

  contacto: {
    es: {
      title: 'Contacto',
      heroTitle: 'El primer paso es una conversación',
      heroSubtitle: 'Consulta de valoración personalizada. Totalmente confidencial. Respondemos en menos de 24 horas.',
      clinicName: 'Espacio del Dr. Ángel Norro',
      schedule: 'Horario',
      scheduleValue: 'Lunes–Viernes: 9:00–20:00',
      saturday: 'Sábados: Con cita previa',
      languages: 'Idiomas',
      languagesValue: 'Español · English · Français · Português',
      phone: 'Teléfono',
      email: 'Email',
      whatsapp: 'WhatsApp',
      sendMessage: 'Enviar mensaje',
      address: 'Dirección',
      formTitle: 'Formulario de consulta',
      name: 'Nombre completo',
      emailField: 'Email',
      phoneField: 'Teléfono',
      country: 'País de residencia',
      procedure: 'Procedimiento de interés',
      referredBy: '¿Cómo nos conoció?',
      referredByOptions: ['Búsqueda en internet', 'Redes sociales', 'Recomendación personal', 'Clínica colaboradora', 'Prensa / Medios', 'Otro'],
      preferredContact: 'Medio preferido de contacto',
      preferredContactOptions: ['Email', 'WhatsApp', 'Teléfono'],
      contactSchedule: 'Horario de contacto',
      contactScheduleOptions: ['Mañana (9:00–13:00)', 'Tarde (13:00–17:00)', 'Última hora (17:00–20:00)', 'Indiferente'],
      city: 'Ciudad de residencia',
      message: 'Mensaje',
      privacy: 'Acepto la política de privacidad',
      send: 'Enviar consulta',
      sending: 'Enviando...',
      thankYou: 'Gracias por contactarnos',
      thankYouMessage: 'Nos pondremos en contacto con usted lo antes posible. Si su consulta es urgente, puede llamarnos directamente al +34 952 76 45 47.',
      sendAnother: 'Enviar otra consulta',
    },
    en: {
      title: 'Contact',
      heroTitle: 'The first step is a conversation',
      heroSubtitle: 'Personalized assessment consultation. Completely confidential. We respond within 24 hours.',
      clinicName: 'Dr. Ángel Norro\'s Practice',
      schedule: 'Hours',
      scheduleValue: 'Monday–Friday: 9:00 AM–8:00 PM',
      saturday: 'Saturdays: By appointment',
      languages: 'Languages',
      languagesValue: 'Spanish · English · French · Portuguese',
      phone: 'Phone',
      email: 'Email',
      whatsapp: 'WhatsApp',
      sendMessage: 'Send message',
      address: 'Address',
      formTitle: 'Consultation form',
      name: 'Full name',
      emailField: 'Email',
      phoneField: 'Phone',
      country: 'Country of residence',
      procedure: 'Procedure of interest',
      referredBy: 'How did you hear about us?',
      referredByOptions: ['Internet search', 'Social media', 'Personal recommendation', 'Partner clinic', 'Press / Media', 'Other'],
      preferredContact: 'Preferred contact method',
      preferredContactOptions: ['Email', 'WhatsApp', 'Phone'],
      contactSchedule: 'Preferred contact time',
      contactScheduleOptions: ['Morning (9:00–13:00)', 'Afternoon (13:00–17:00)', 'Late afternoon (17:00–20:00)', 'No preference'],
      city: 'City of residence',
      message: 'Message',
      privacy: 'I accept the privacy policy',
      send: 'Send inquiry',
      sending: 'Sending...',
      thankYou: 'Thank you for contacting us',
      thankYouMessage: 'We will get in touch with you as soon as possible. If your inquiry is urgent, you can call us directly at +34 952 76 45 47.',
      sendAnother: 'Send another inquiry',
    },
    fr: {
      title: 'Contact',
      heroTitle: 'La première étape est une conversation',
      heroSubtitle: 'Consultation d\'évaluation personnalisée. Totalement confidentielle. Nous répondons sous 24 heures.',
      clinicName: 'Cabinet du Dr. Ángel Norro',
      schedule: 'Horaires',
      scheduleValue: 'Lundi–Vendredi: 9:00–20:00',
      saturday: 'Samedis: Sur rendez-vous',
      languages: 'Langues',
      languagesValue: 'Espagnol · Anglais · Français · Portugais',
      phone: 'Téléphone',
      email: 'Email',
      whatsapp: 'WhatsApp',
      sendMessage: 'Envoyer un message',
      address: 'Adresse',
      formTitle: 'Formulaire de consultation',
      name: 'Nom complet',
      emailField: 'Email',
      phoneField: 'Téléphone',
      country: 'Pays de résidence',
      procedure: 'Procédure d\'intérêt',
      referredBy: 'Comment nous avez-vous connus ?',
      referredByOptions: ['Recherche internet', 'Réseaux sociaux', 'Recommandation personnelle', 'Clinique partenaire', 'Presse / Médias', 'Autre'],
      preferredContact: 'Moyen de contact préféré',
      preferredContactOptions: ['Email', 'WhatsApp', 'Téléphone'],
      contactSchedule: 'Horaire de contact',
      contactScheduleOptions: ['Matin (9:00–13:00)', 'Après-midi (13:00–17:00)', 'Fin d\'après-midi (17:00–20:00)', 'Indifférent'],
      city: 'Ville de résidence',
      message: 'Message',
      privacy: 'J\'accepte la politique de confidentialité',
      send: 'Envoyer la demande',
      sending: 'Envoi en cours...',
      thankYou: 'Merci de nous avoir contactés',
      thankYouMessage: 'Nous vous contacterons dans les plus brefs délais. Si votre demande est urgente, vous pouvez nous appeler directement au +34 952 76 45 47.',
      sendAnother: 'Envoyer une autre demande',
    },
    pt: {
      title: 'Contato',
      heroTitle: 'O primeiro passo é uma conversa',
      heroSubtitle: 'Consulta de avaliação personalizada. Totalmente confidencial. Respondemos em menos de 24 horas.',
      clinicName: 'Consultório do Dr. Ángel Norro',
      schedule: 'Horário',
      scheduleValue: 'Segunda–Sexta: 9:00–20:00',
      saturday: 'Sábados: Com agendamento',
      languages: 'Idiomas',
      languagesValue: 'Espanhol · Inglês · Francês · Português',
      phone: 'Telefone',
      email: 'Email',
      whatsapp: 'WhatsApp',
      sendMessage: 'Enviar mensagem',
      address: 'Endereço',
      formTitle: 'Formulário de consulta',
      name: 'Nome completo',
      emailField: 'Email',
      phoneField: 'Telefone',
      country: 'País de residência',
      procedure: 'Procedimento de interesse',
      referredBy: 'Como nos conheceu?',
      referredByOptions: ['Pesquisa na internet', 'Redes sociais', 'Recomendação pessoal', 'Clínica parceira', 'Imprensa / Media', 'Outro'],
      preferredContact: 'Meio de contacto preferido',
      preferredContactOptions: ['Email', 'WhatsApp', 'Telefone'],
      contactSchedule: 'Horário de contacto',
      contactScheduleOptions: ['Manhã (9:00–13:00)', 'Tarde (13:00–17:00)', 'Fim de tarde (17:00–20:00)', 'Indiferente'],
      city: 'Cidade de residência',
      message: 'Mensagem',
      privacy: 'Aceito a política de privacidade',
      send: 'Enviar consulta',
      sending: 'Enviando...',
      thankYou: 'Obrigado por entrar em contato',
      thankYouMessage: 'Entraremos em contacto consigo o mais breve possível. Se a sua consulta é urgente, pode ligar-nos diretamente para o +34 952 76 45 47.',
      sendAnother: 'Enviar outra consulta',
    },
  },

  elDoctor: {
    es: {
      title: 'El Dr. Norro',
      heroTitle: 'Dr. Ángel Norro Ruiz',
      heroSubtitle: 'Más de 35 años dedicados a la excelencia en cirugía plástica, estética y reparadora.',
      biography: 'Biografía',
      philosophy: 'Filosofía',
      trademarks: 'Marcas Registradas',
      presentations: 'Ponencias y Conferencias',
      credentials: 'Credenciales',
    },
    en: {
      title: 'Dr. Norro',
      heroTitle: 'Dr. Ángel Norro Ruiz',
      heroSubtitle: 'Over 35 years dedicated to excellence in plastic, aesthetic and reconstructive surgery.',
      biography: 'Biography',
      philosophy: 'Philosophy',
      trademarks: 'Trademarks',
      presentations: 'Lectures and Conferences',
      credentials: 'Credentials',
    },
    fr: {
      title: 'Le Dr. Norro',
      heroTitle: 'Dr. Ángel Norro Ruiz',
      heroSubtitle: 'Plus de 35 ans dédiés à l\'excellence en chirurgie plastique, esthétique et réparatrice.',
      biography: 'Biographie',
      philosophy: 'Philosophie',
      trademarks: 'Marques Déposées',
      presentations: 'Conférences et Présentations',
      credentials: 'Accréditations',
    },
    pt: {
      title: 'O Dr. Norro',
      heroTitle: 'Dr. Ángel Norro Ruiz',
      heroSubtitle: 'Mais de 35 anos dedicados à excelência em cirurgia plástica, estética e reparadora.',
      biography: 'Biografia',
      philosophy: 'Filosofia',
      trademarks: 'Marcas Registradas',
      presentations: 'Palestras e Conferências',
      credentials: 'Credenciais',
    },
  },

  // Endolifting page translations
  endolifting: {
    es: {
      badge: 'MÍNIMAMENTE INVASIVO',
      title: 'Endolifting Láser',
      heroDesc1: 'Rejuvenecimiento facial y corporal con <strong>tecnología láser de última generación</strong>. Resultados visibles sin cirugía tradicional.',
      heroDesc2: 'Un tratamiento <strong>mínimamente invasivo</strong> con recuperación rápida y resultados naturales.',
      requestConsult: 'SOLICITAR CONSULTA',
      resultsTitle: 'Resultados del Endolifting Láser',
      comingSoon: 'Próximamente: Casos de antes y después',
      whatIsTitle: '¿Qué es el Endolifting Láser?',
      whatIsDesc1: 'El <strong>Endolifting Láser</strong> es un tratamiento de rejuvenecimiento que utiliza energía láser para estimular la producción de colágeno y tensar la piel desde el interior, sin necesidad de cirugía tradicional.',
      whatIsDesc2: 'Es un procedimiento <strong>mínimamente invasivo</strong> que permite tratar la flacidez facial y corporal con tiempos de recuperación muy reducidos.',
      isForYou: '¿Es para ti el Endolifting?',
      sign1: 'Notas <strong>flacidez leve a moderada</strong> en rostro o cuerpo.',
      sign2: 'Buscas un tratamiento <strong>sin cirugía</strong> tradicional.',
      sign3: 'Deseas una <strong>recuperación rápida</strong> sin largos periodos de baja.',
      sign4: 'Quieres <strong>resultados naturales</strong> y progresivos.',
      advantagesTitle: 'Ventajas del Endolifting Láser',
      adv1Title: 'Mínimamente Invasivo',
      adv1Desc: 'Sin cortes ni suturas. Solo pequeñas punciones.',
      adv2Title: 'Recuperación Rápida',
      adv2Desc: 'Incorporación a la vida normal en pocos días.',
      adv3Title: 'Anestesia Local',
      adv3Desc: 'Procedimiento ambulatorio sin anestesia general.',
      adv4Title: 'Resultados Naturales',
      adv4Desc: 'Mejora progresiva que respeta tu expresión facial.',
      zonesTitle: 'Zonas de Tratamiento',
      zones: ['Rostro', 'Elevación de Cejas', 'Cuello', 'Papada', 'Brazos', 'Abdomen', 'Muslos', 'Rodillas', 'Glúteos'],
      doctorTitle: 'Tecnología de vanguardia en manos expertas',
      doctorDesc1: 'El Dr. Ángel Norro aplica el <strong>Endolifting Láser</strong> con más de 30 años de experiencia en rejuvenecimiento facial y corporal.',
      doctorDesc2: 'Combinamos la <strong>tecnología láser más avanzada</strong> con técnicas personalizadas para cada paciente.',
      doctorDesc3: 'Cada tratamiento se diseña de forma individual para obtener los <strong>mejores resultados posibles</strong> con la máxima seguridad.',
      ctaTitle: '¿Interesado en el Endolifting Láser?',
      ctaDesc: 'Solicita tu consulta personalizada y descubre si este tratamiento es para ti',
    },
    en: {
      badge: 'MINIMALLY INVASIVE',
      title: 'Laser Endolifting',
      heroDesc1: 'Facial and body rejuvenation with <strong>state-of-the-art laser technology</strong>. Visible results without traditional surgery.',
      heroDesc2: 'A <strong>minimally invasive</strong> treatment with quick recovery and natural results.',
      requestConsult: 'REQUEST CONSULTATION',
      resultsTitle: 'Laser Endolifting Results',
      comingSoon: 'Coming soon: Before and after cases',
      whatIsTitle: 'What is Laser Endolifting?',
      whatIsDesc1: '<strong>Laser Endolifting</strong> is a rejuvenation treatment that uses laser energy to stimulate collagen production and tighten skin from within, without traditional surgery.',
      whatIsDesc2: 'It is a <strong>minimally invasive</strong> procedure that treats facial and body sagging with very short recovery times.',
      isForYou: 'Is Endolifting right for you?',
      sign1: 'You notice <strong>mild to moderate sagging</strong> on face or body.',
      sign2: 'You seek a treatment <strong>without traditional surgery</strong>.',
      sign3: 'You want a <strong>quick recovery</strong> without long downtime.',
      sign4: 'You want <strong>natural, progressive results</strong>.',
      advantagesTitle: 'Advantages of Laser Endolifting',
      adv1Title: 'Minimally Invasive',
      adv1Desc: 'No cuts or sutures. Only small punctures.',
      adv2Title: 'Quick Recovery',
      adv2Desc: 'Return to normal life in a few days.',
      adv3Title: 'Local Anesthesia',
      adv3Desc: 'Outpatient procedure without general anesthesia.',
      adv4Title: 'Natural Results',
      adv4Desc: 'Progressive improvement that respects your facial expression.',
      zonesTitle: 'Treatment Areas',
      zones: ['Face', 'Brow Lift', 'Neck', 'Jowl', 'Arms', 'Abdomen', 'Thighs', 'Knees', 'Buttocks'],
      doctorTitle: 'Cutting-edge technology in expert hands',
      doctorDesc1: 'Dr. Ángel Norro applies <strong>Laser Endolifting</strong> with over 30 years of experience in facial and body rejuvenation.',
      doctorDesc2: 'We combine the <strong>most advanced laser technology</strong> with personalized techniques for each patient.',
      doctorDesc3: 'Each treatment is individually designed to achieve the <strong>best possible results</strong> with maximum safety.',
      ctaTitle: 'Interested in Laser Endolifting?',
      ctaDesc: 'Request your personalized consultation and discover if this treatment is for you',
    },
    fr: {
      badge: 'MINIMALEMENT INVASIF',
      title: 'Endolifting Laser',
      heroDesc1: 'Rajeunissement facial et corporel avec <strong>technologie laser de dernière génération</strong>. Résultats visibles sans chirurgie traditionnelle.',
      heroDesc2: 'Un traitement <strong>minimalement invasif</strong> avec récupération rapide et résultats naturels.',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      resultsTitle: 'Résultats de l\'Endolifting Laser',
      comingSoon: 'Prochainement: Cas avant et après',
      whatIsTitle: 'Qu\'est-ce que l\'Endolifting Laser?',
      whatIsDesc1: 'L\'<strong>Endolifting Laser</strong> est un traitement de rajeunissement qui utilise l\'énergie laser pour stimuler la production de collagène et retendre la peau de l\'intérieur, sans chirurgie traditionnelle.',
      whatIsDesc2: 'C\'est une procédure <strong>minimalement invasive</strong> qui traite le relâchement facial et corporel avec des temps de récupération très courts.',
      isForYou: 'L\'Endolifting est-il fait pour vous?',
      sign1: 'Vous remarquez un <strong>relâchement léger à modéré</strong> du visage ou du corps.',
      sign2: 'Vous cherchez un traitement <strong>sans chirurgie traditionnelle</strong>.',
      sign3: 'Vous souhaitez une <strong>récupération rapide</strong> sans longues périodes d\'arrêt.',
      sign4: 'Vous voulez des <strong>résultats naturels et progressifs</strong>.',
      advantagesTitle: 'Avantages de l\'Endolifting Laser',
      adv1Title: 'Minimalement Invasif',
      adv1Desc: 'Pas de coupures ni de sutures. Seulement de petites ponctions.',
      adv2Title: 'Récupération Rapide',
      adv2Desc: 'Retour à la vie normale en quelques jours.',
      adv3Title: 'Anesthésie Locale',
      adv3Desc: 'Procédure ambulatoire sans anesthésie générale.',
      adv4Title: 'Résultats Naturels',
      adv4Desc: 'Amélioration progressive qui respecte votre expression faciale.',
      zonesTitle: 'Zones de Traitement',
      zones: ['Visage', 'Lifting des Sourcils', 'Cou', 'Double Menton', 'Bras', 'Abdomen', 'Cuisses', 'Genoux', 'Fessiers'],
      doctorTitle: 'Technologie de pointe entre des mains expertes',
      doctorDesc1: 'Le Dr. Ángel Norro applique l\'<strong>Endolifting Laser</strong> avec plus de 30 ans d\'expérience en rajeunissement facial et corporel.',
      doctorDesc2: 'Nous combinons la <strong>technologie laser la plus avancée</strong> avec des techniques personnalisées pour chaque patient.',
      doctorDesc3: 'Chaque traitement est conçu individuellement pour obtenir les <strong>meilleurs résultats possibles</strong> avec une sécurité maximale.',
      ctaTitle: 'Intéressé par l\'Endolifting Laser?',
      ctaDesc: 'Demandez votre consultation personnalisée et découvrez si ce traitement vous convient',
    },
    pt: {
      badge: 'MINIMAMENTE INVASIVO',
      title: 'Endolifting Laser',
      heroDesc1: 'Rejuvenescimento facial e corporal com <strong>tecnologia laser de última geração</strong>. Resultados visíveis sem cirurgia tradicional.',
      heroDesc2: 'Um tratamento <strong>minimamente invasivo</strong> com recuperação rápida e resultados naturais.',
      requestConsult: 'SOLICITAR CONSULTA',
      resultsTitle: 'Resultados do Endolifting Laser',
      comingSoon: 'Em breve: Casos de antes e depois',
      whatIsTitle: 'O que é o Endolifting Laser?',
      whatIsDesc1: 'O <strong>Endolifting Laser</strong> é um tratamento de rejuvenescimento que utiliza energia laser para estimular a produção de colágeno e esticar a pele por dentro, sem cirurgia tradicional.',
      whatIsDesc2: 'É um procedimento <strong>minimamente invasivo</strong> que trata a flacidez facial e corporal com tempos de recuperação muito reduzidos.',
      isForYou: 'O Endolifting é para você?',
      sign1: 'Você nota <strong>flacidez leve a moderada</strong> no rosto ou corpo.',
      sign2: 'Você busca um tratamento <strong>sem cirurgia tradicional</strong>.',
      sign3: 'Você deseja uma <strong>recuperação rápida</strong> sem longos períodos de afastamento.',
      sign4: 'Você quer <strong>resultados naturais e progressivos</strong>.',
      advantagesTitle: 'Vantagens do Endolifting Laser',
      adv1Title: 'Minimamente Invasivo',
      adv1Desc: 'Sem cortes nem suturas. Apenas pequenas punções.',
      adv2Title: 'Recuperação Rápida',
      adv2Desc: 'Retorno à vida normal em poucos dias.',
      adv3Title: 'Anestesia Local',
      adv3Desc: 'Procedimento ambulatorial sem anestesia geral.',
      adv4Title: 'Resultados Naturais',
      adv4Desc: 'Melhora progressiva que respeita sua expressão facial.',
      zonesTitle: 'Zonas de Tratamento',
      zones: ['Rosto', 'Elevação de Sobrancelhas', 'Pescoço', 'Papada', 'Braços', 'Abdômen', 'Coxas', 'Joelhos', 'Glúteos'],
      doctorTitle: 'Tecnologia de ponta em mãos especializadas',
      doctorDesc1: 'O Dr. Ángel Norro aplica o <strong>Endolifting Laser</strong> com mais de 30 anos de experiência em rejuvenescimento facial e corporal.',
      doctorDesc2: 'Combinamos a <strong>tecnologia laser mais avançada</strong> com técnicas personalizadas para cada paciente.',
      doctorDesc3: 'Cada tratamento é projetado individualmente para obter os <strong>melhores resultados possíveis</strong> com máxima segurança.',
      ctaTitle: 'Interessado no Endolifting Laser?',
      ctaDesc: 'Solicite sua consulta personalizada e descubra se este tratamento é para você',
    },
  },

  // Papada page translations
  papada: {
    es: {
      category: 'Medicina Estética',
      title: 'Eliminación de Papada',
      heroDesc: 'Técnica no quirúrgica o mínimamente invasiva para eliminar la grasa submentoniana. Lipólisis con inyectables o lipolaser cervical con resultados visibles en 4-6 semanas.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      techniquesTitle: 'Técnicas',
      techniquesSubtitle: 'Opciones de tratamiento',
      techniques: [
        { title: 'Lipólisis Inyectable', desc: 'Inyecciones de ácido desoxicólico que destruyen las células grasas de forma permanente. Tratamiento ambulatorio sin cirugía.' },
        { title: 'Lipolaser Cervical', desc: 'Técnica mínimamente invasiva con láser que licua la grasa y estimula la retracción cutánea.' },
        { title: 'Tratamiento Combinado', desc: 'En algunos casos se combina con endolifting cervical para optimizar el tensado de la piel.' },
      ],
      benefitsTitle: 'Beneficios',
      benefitsSubtitle: 'Ventajas del tratamiento',
      benefits: [
        'Perfil cervical definido',
        'Técnica no quirúrgica o mínimamente invasiva',
        'Resultados visibles en 4-6 semanas',
        'Sin cicatrices visibles',
        'Recuperación rápida',
        'Combinable con otros tratamientos faciales',
      ],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada. Sin compromiso.',
      contact: 'Contactar',
    },
    en: {
      category: 'Aesthetic Medicine',
      title: 'Jowl Removal',
      heroDesc: 'Non-surgical or minimally invasive technique to eliminate submental fat. Injectable lipolysis or cervical lipolaser with visible results in 4-6 weeks.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      techniquesTitle: 'Techniques',
      techniquesSubtitle: 'Treatment options',
      techniques: [
        { title: 'Injectable Lipolysis', desc: 'Deoxycholic acid injections that permanently destroy fat cells. Outpatient treatment without surgery.' },
        { title: 'Cervical Lipolaser', desc: 'Minimally invasive technique with laser that liquefies fat and stimulates skin retraction.' },
        { title: 'Combined Treatment', desc: 'In some cases combined with cervical endolifting to optimize skin tightening.' },
      ],
      benefitsTitle: 'Benefits',
      benefitsSubtitle: 'Treatment advantages',
      benefits: [
        'Defined cervical profile',
        'Non-surgical or minimally invasive technique',
        'Visible results in 4-6 weeks',
        'No visible scars',
        'Quick recovery',
        'Combinable with other facial treatments',
      ],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation. No obligation.',
      contact: 'Contact',
    },
    fr: {
      category: 'Médecine Esthétique',
      title: 'Élimination du Double Menton',
      heroDesc: 'Technique non chirurgicale ou minimalement invasive pour éliminer la graisse sous-mentonnière. Lipolyse injectable ou lipolaser cervical avec résultats visibles en 4-6 semaines.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      techniquesTitle: 'Techniques',
      techniquesSubtitle: 'Options de traitement',
      techniques: [
        { title: 'Lipolyse Injectable', desc: 'Injections d\'acide désoxycholique qui détruisent les cellules graisseuses de façon permanente. Traitement ambulatoire sans chirurgie.' },
        { title: 'Lipolaser Cervical', desc: 'Technique minimalement invasive au laser qui liquéfie la graisse et stimule la rétraction cutanée.' },
        { title: 'Traitement Combiné', desc: 'Dans certains cas combiné avec endolifting cervical pour optimiser le raffermissement de la peau.' },
      ],
      benefitsTitle: 'Avantages',
      benefitsSubtitle: 'Avantages du traitement',
      benefits: [
        'Profil cervical défini',
        'Technique non chirurgicale ou minimalement invasive',
        'Résultats visibles en 4-6 semaines',
        'Pas de cicatrices visibles',
        'Récupération rapide',
        'Combinable avec d\'autres traitements faciaux',
      ],
      ctaTitle: 'Vous souhaitez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée. Sans engagement.',
      contact: 'Contacter',
    },
    pt: {
      category: 'Medicina Estética',
      title: 'Eliminação de Papada',
      heroDesc: 'Técnica não cirúrgica ou minimamente invasiva para eliminar a gordura submentoniana. Lipólise injetável ou lipolaser cervical com resultados visíveis em 4-6 semanas.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      techniquesTitle: 'Técnicas',
      techniquesSubtitle: 'Opções de tratamento',
      techniques: [
        { title: 'Lipólise Injetável', desc: 'Injeções de ácido desoxicólico que destroem as células de gordura permanentemente. Tratamento ambulatorial sem cirurgia.' },
        { title: 'Lipolaser Cervical', desc: 'Técnica minimamente invasiva com laser que liquefaz a gordura e estimula a retração cutânea.' },
        { title: 'Tratamento Combinado', desc: 'Em alguns casos combinado com endolifting cervical para otimizar o estiramento da pele.' },
      ],
      benefitsTitle: 'Benefícios',
      benefitsSubtitle: 'Vantagens do tratamento',
      benefits: [
        'Perfil cervical definido',
        'Técnica não cirúrgica ou minimamente invasiva',
        'Resultados visíveis em 4-6 semanas',
        'Sem cicatrizes visíveis',
        'Recuperação rápida',
        'Combinável com outros tratamentos faciais',
      ],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada. Sem compromisso.',
      contact: 'Contatar',
    },
  },

  // Rinomodelacion page translations
  rinomodelacion: {
    es: {
      title: 'RINOMODELACIÓN',
      heroSubtitle: 'Mejora tu imagen sin cirugía',
      heroDesc: 'La rinoplastia sin cirugía - Resultados inmediatos y permanentes',
      requestStudy: 'SOLICITE SU ESTUDIO PERSONALIZADO',
      menuItems: ['Inicio', 'Secciones', '¿Qué es?', 'Dr. Norro', 'Contacto'],
      sectionsTitle: 'Rinomodelación',
      sectionsSubtitle: 'Toda la información sobre rinoplastia sin cirugía con el Dr. Ángel Ruiz Norro',
      sections: [
        { title: 'Rinomodelación ¿Qué es?', desc: 'Todo sobre el procedimiento' },
        { title: 'Resultados Antes y Después', desc: 'Galería de casos reales' },
        { title: 'Dr. Ángel Ruiz Norro', desc: 'Conozca al especialista' },
        { title: 'Preguntas Frecuentes', desc: 'Resolvemos tus dudas' },
        { title: 'Contacto', desc: 'Solicite su valoración' },
      ],
      whatIsTitle: 'RINOMODELACIÓN ¿Qué es?',
      whatIsDesc: 'La rinomodelación es un procedimiento estético no quirúrgico revolucionario que permite corregir imperfecciones de la nariz mediante la aplicación estratégica de rellenos dérmicos de última generación.',
      advantagesTitle: 'Ventajas de la Rinomodelación',
      adv1Title: 'Resultados Inmediatos',
      adv1Desc: 'Los cambios son visibles al instante',
      adv2Title: 'Sin Cirugía',
      adv2Desc: 'Procedimiento ambulatorio sin anestesia general',
      adv3Title: 'Recuperación Inmediata',
      adv3Desc: 'Vuelve a tu rutina el mismo día',
      adv4Title: 'Resultados Duraderos',
      adv4Desc: 'Efectos permanentes o de larga duración',
      learnMore: 'Saber más sobre Rinomodelación',
      resultsTitle: 'RESULTADOS de Rinomodelación',
      resultsSubtitle: 'Fotos de Antes y Después',
      casesTitle: 'Casos Reales Documentados',
      casesDesc: 'Más de 25 años de experiencia y miles de casos exitosos',
      viewGallery: 'Ver galería de resultados',
      doctorTitle: 'Dr. Ángel Ruiz Norro',
      doctorQuote: '"Considero esta técnica de las más extraordinarias entre las que he ido conociendo y practicando a lo largo de más de 25 años. Un gran avance."',
      doctorExp1: '✓ Más de 30 años de experiencia',
      doctorExp1Desc: 'En cirugía estética y medicina estética',
      doctorExp2: '✓ Pionero en España',
      doctorExp2Desc: 'Realizando rinomodelación desde 2007',
      meetDoctor: 'Conocer al Dr. Norro',
      contactTitle: 'Consulta de Valoración Personalizada',
      clinicName: 'Clínica Estética Alameda de Marbella',
      address: 'Dirección',
      requestConsult: 'SOLICITAR CONSULTA',
    },
    en: {
      title: 'RHINOMODELING',
      heroSubtitle: 'Improve your image without surgery',
      heroDesc: 'Non-surgical rhinoplasty - Immediate and permanent results',
      requestStudy: 'REQUEST YOUR PERSONALIZED STUDY',
      menuItems: ['Home', 'Sections', 'What is it?', 'Dr. Norro', 'Contact'],
      sectionsTitle: 'Rhinomodeling',
      sectionsSubtitle: 'All information about non-surgical rhinoplasty with Dr. Ángel Ruiz Norro',
      sections: [
        { title: 'Rhinomodeling: What is it?', desc: 'Everything about the procedure' },
        { title: 'Before and After Results', desc: 'Gallery of real cases' },
        { title: 'Dr. Ángel Ruiz Norro', desc: 'Meet the specialist' },
        { title: 'Frequently Asked Questions', desc: 'We answer your questions' },
        { title: 'Contact', desc: 'Request your assessment' },
      ],
      whatIsTitle: 'RHINOMODELING: What is it?',
      whatIsDesc: 'Rhinomodeling is a revolutionary non-surgical aesthetic procedure that corrects nose imperfections through strategic application of state-of-the-art dermal fillers.',
      advantagesTitle: 'Advantages of Rhinomodeling',
      adv1Title: 'Immediate Results',
      adv1Desc: 'Changes are visible instantly',
      adv2Title: 'No Surgery',
      adv2Desc: 'Outpatient procedure without general anesthesia',
      adv3Title: 'Immediate Recovery',
      adv3Desc: 'Return to your routine the same day',
      adv4Title: 'Long-lasting Results',
      adv4Desc: 'Permanent or long-lasting effects',
      learnMore: 'Learn more about Rhinomodeling',
      resultsTitle: 'Rhinomodeling RESULTS',
      resultsSubtitle: 'Before and After Photos',
      casesTitle: 'Documented Real Cases',
      casesDesc: 'Over 25 years of experience and thousands of successful cases',
      viewGallery: 'View results gallery',
      doctorTitle: 'Dr. Ángel Ruiz Norro',
      doctorQuote: '"I consider this technique one of the most extraordinary among those I have learned and practiced over more than 25 years. A great advancement."',
      doctorExp1: '✓ Over 30 years of experience',
      doctorExp1Desc: 'In aesthetic surgery and aesthetic medicine',
      doctorExp2: '✓ Pioneer in Spain',
      doctorExp2Desc: 'Performing rhinomodeling since 2007',
      meetDoctor: 'Meet Dr. Norro',
      contactTitle: 'Personalized Assessment Consultation',
      clinicName: 'Alameda Aesthetic Clinic of Marbella',
      address: 'Address',
      requestConsult: 'REQUEST CONSULTATION',
    },
    fr: {
      title: 'RHINOMODELAGE',
      heroSubtitle: 'Améliorez votre image sans chirurgie',
      heroDesc: 'Rhinoplastie sans chirurgie - Résultats immédiats et permanents',
      requestStudy: 'DEMANDEZ VOTRE ÉTUDE PERSONNALISÉE',
      menuItems: ['Accueil', 'Sections', 'Qu\'est-ce que c\'est?', 'Dr. Norro', 'Contact'],
      sectionsTitle: 'Rhinomodelage',
      sectionsSubtitle: 'Toutes les informations sur la rhinoplastie sans chirurgie avec le Dr. Ángel Ruiz Norro',
      sections: [
        { title: 'Rhinomodelage: Qu\'est-ce que c\'est?', desc: 'Tout sur la procédure' },
        { title: 'Résultats Avant et Après', desc: 'Galerie de cas réels' },
        { title: 'Dr. Ángel Ruiz Norro', desc: 'Rencontrez le spécialiste' },
        { title: 'Questions Fréquentes', desc: 'Nous répondons à vos questions' },
        { title: 'Contact', desc: 'Demandez votre évaluation' },
      ],
      whatIsTitle: 'RHINOMODELAGE: Qu\'est-ce que c\'est?',
      whatIsDesc: 'Le rhinomodelage est une procédure esthétique non chirurgicale révolutionnaire qui corrige les imperfections du nez par l\'application stratégique de comblement dermique de dernière génération.',
      advantagesTitle: 'Avantages du Rhinomodelage',
      adv1Title: 'Résultats Immédiats',
      adv1Desc: 'Les changements sont visibles instantanément',
      adv2Title: 'Sans Chirurgie',
      adv2Desc: 'Procédure ambulatoire sans anesthésie générale',
      adv3Title: 'Récupération Immédiate',
      adv3Desc: 'Retour à votre routine le jour même',
      adv4Title: 'Résultats Durables',
      adv4Desc: 'Effets permanents ou de longue durée',
      learnMore: 'En savoir plus sur le Rhinomodelage',
      resultsTitle: 'RÉSULTATS du Rhinomodelage',
      resultsSubtitle: 'Photos Avant et Après',
      casesTitle: 'Cas Réels Documentés',
      casesDesc: 'Plus de 25 ans d\'expérience et des milliers de cas réussis',
      viewGallery: 'Voir la galerie de résultats',
      doctorTitle: 'Dr. Ángel Ruiz Norro',
      doctorQuote: '"Je considère cette technique comme l\'une des plus extraordinaires parmi celles que j\'ai apprises et pratiquées au cours de plus de 25 ans. Une grande avancée."',
      doctorExp1: '✓ Plus de 30 ans d\'expérience',
      doctorExp1Desc: 'En chirurgie esthétique et médecine esthétique',
      doctorExp2: '✓ Pionnier en Espagne',
      doctorExp2Desc: 'Pratiquant le rhinomodelage depuis 2007',
      meetDoctor: 'Rencontrer le Dr. Norro',
      contactTitle: 'Consultation d\'Évaluation Personnalisée',
      clinicName: 'Clinique Esthétique Alameda de Marbella',
      address: 'Adresse',
      requestConsult: 'DEMANDER UNE CONSULTATION',
    },
    pt: {
      title: 'RINOMODELAÇÃO',
      heroSubtitle: 'Melhore sua imagem sem cirurgia',
      heroDesc: 'Rinoplastia sem cirurgia - Resultados imediatos e permanentes',
      requestStudy: 'SOLICITE SEU ESTUDO PERSONALIZADO',
      menuItems: ['Início', 'Seções', 'O que é?', 'Dr. Norro', 'Contato'],
      sectionsTitle: 'Rinomodelação',
      sectionsSubtitle: 'Toda a informação sobre rinoplastia sem cirurgia com o Dr. Ángel Ruiz Norro',
      sections: [
        { title: 'Rinomodelação: O que é?', desc: 'Tudo sobre o procedimento' },
        { title: 'Resultados Antes e Depois', desc: 'Galeria de casos reais' },
        { title: 'Dr. Ángel Ruiz Norro', desc: 'Conheça o especialista' },
        { title: 'Perguntas Frequentes', desc: 'Respondemos suas dúvidas' },
        { title: 'Contato', desc: 'Solicite sua avaliação' },
      ],
      whatIsTitle: 'RINOMODELAÇÃO: O que é?',
      whatIsDesc: 'A rinomodelação é um procedimento estético não cirúrgico revolucionário que corrige imperfeições do nariz através da aplicação estratégica de preenchimentos dérmicos de última geração.',
      advantagesTitle: 'Vantagens da Rinomodelação',
      adv1Title: 'Resultados Imediatos',
      adv1Desc: 'As mudanças são visíveis instantaneamente',
      adv2Title: 'Sem Cirurgia',
      adv2Desc: 'Procedimento ambulatorial sem anestesia geral',
      adv3Title: 'Recuperação Imediata',
      adv3Desc: 'Volte à sua rotina no mesmo dia',
      adv4Title: 'Resultados Duradouros',
      adv4Desc: 'Efeitos permanentes ou de longa duração',
      learnMore: 'Saiba mais sobre Rinomodelação',
      resultsTitle: 'RESULTADOS da Rinomodelação',
      resultsSubtitle: 'Fotos de Antes e Depois',
      casesTitle: 'Casos Reais Documentados',
      casesDesc: 'Mais de 25 anos de experiência e milhares de casos bem-sucedidos',
      viewGallery: 'Ver galeria de resultados',
      doctorTitle: 'Dr. Ángel Ruiz Norro',
      doctorQuote: '"Considero esta técnica uma das mais extraordinárias entre as que conheci e pratiquei ao longo de mais de 25 anos. Um grande avanço."',
      doctorExp1: '✓ Mais de 30 anos de experiência',
      doctorExp1Desc: 'Em cirurgia estética e medicina estética',
      doctorExp2: '✓ Pioneiro na Espanha',
      doctorExp2Desc: 'Realizando rinomodelação desde 2007',
      meetDoctor: 'Conhecer o Dr. Norro',
      contactTitle: 'Consulta de Avaliação Personalizada',
      clinicName: 'Clínica Estética Alameda de Marbella',
      address: 'Endereço',
      requestConsult: 'SOLICITAR CONSULTA',
    },
  },

  // CirugiaPostbariatrica page translations
  cirugiaPostbariatrica: {
    es: {
      category: 'Cirugía Plástica Avanzada',
      heroTitle1: 'La nueva silueta que',
      heroTitle2: 'su esfuerzo merece',
      heroDesc: 'Tras una pérdida de peso significativa, el organismo conserva excesos de piel y tejido que ningún ejercicio puede eliminar. La cirugía postbariátrica restituye la armonía corporal y completa la transformación iniciada con la cirugía bariátrica.',
      requestAssessment: 'Solicitar valoración',
      resultsTitle: 'Resultados — Antes y Después',
      realCase: 'Caso real — Paciente del Dr. Norro',
      resultCaption: 'Reducción de más de 40 kg — Resultado a 18 meses',
      stats: [
        { value: '+35', label: 'Años de experiencia clínica' },
        { value: '6', label: 'Procedimientos corporales disponibles' },
        { value: '18', label: 'Meses mínimos post-bariátrica recomendados' },
        { value: '100%', label: 'Plan quirúrgico individualizado' },
      ],
      contextTitle: '01 — Contexto',
      contextSubtitle: 'Más allá del peso perdido',
      proceduresTitle: '02 — Procedimientos',
      proceduresSubtitle: 'Restauración integral del contorno corporal',
      procedures: [
        { num: '01', title: 'Dermolipectomía abdominal', desc: 'Resección del delantal abdominal y plicatura de la musculatura abdominal cuando existe diástasis.', tags: ['Abdominoplastia', 'Panniculectomía'] },
        { num: '02', title: 'Body lift inferior', desc: 'Resección circunferencial del exceso de piel en la zona inferior del tronco.', tags: ['Lifting circumferencial'] },
        { num: '03', title: 'Braquioplastia', desc: 'Resección del exceso cutáneo de la cara interna del brazo.', tags: ['Brazo', 'Axila'] },
        { num: '04', title: 'Lifting de muslos', desc: 'Corrección de la piel redundante en cara interna y/o anterolateral del muslo.', tags: ['Cruroplastia', 'Thigh lift'] },
        { num: '05', title: 'Mastopexia y aumento mamario', desc: 'La pérdida de peso produce ptosis y deflación mamaria en la mujer.', tags: ['Ginecomastia en varones'] },
        { num: '06', title: 'Lifting facial y cervical', desc: 'La ptosis del tercio inferior facial y el exceso de piel cervical.', tags: ['Cuello', 'Papada', 'Óvalo facial'] },
      ],
      methodologyTitle: '03 — Metodología',
      methodologySubtitle: 'Proceso quirúrgico estructurado',
      methodology: [
        { num: '01', title: 'Primera consulta y evaluación integral', desc: 'Exploración clínica completa, análisis del historial bariátrico.' },
        { num: '02', title: 'Planificación quirúrgica secuenciada', desc: 'Diseño del plan por etapas cuando se combinan múltiples zonas.' },
        { num: '03', title: 'Intervención y hospitalización', desc: 'Cirugía bajo anestesia general o sedación consciente según el caso.' },
        { num: '04', title: 'Seguimiento y resultado definitivo', desc: 'Controles postoperatorios protocolizados a 1, 3, 6 y 12 meses.' },
      ],
      candidateTitle: '04 — Candidato ideal',
      candidateSubtitle: 'Perfil del paciente',
      criteriaIntro: 'Para obtener los mejores resultados con la máxima seguridad, el candidato óptimo debe cumplir los siguientes criterios:',
      criteria: [
        'Pérdida de peso estabilizada durante un mínimo de 12–18 meses',
        'IMC igual o inferior a 32 kg/m² en el momento de la cirugía',
        'Estado nutricional óptimo: proteínas, hierro, vitamina D y B12 dentro de rangos normales',
        'No fumador activo (mínimo 6 semanas de abstinencia preoperatoria)',
        'Ausencia de patología no controlada (diabetes, HTA, coagulopatía)',
        'Expectativas realistas y motivación fundamentalmente funcional y de calidad de vida',
        'Comprensión de la naturaleza cicatricial de los procedimientos',
      ],
      ctaTitle: '¿Quiere dar el paso definitivo hacia su nueva imagen?',
      ctaDesc: 'Solicite una consulta de valoración con el Dr. Norro para diseñar un plan quirúrgico personalizado.',
    },
    en: {
      category: 'Advanced Plastic Surgery',
      heroTitle1: 'The new silhouette that',
      heroTitle2: 'your effort deserves',
      heroDesc: 'After significant weight loss, the body retains excess skin and tissue that no exercise can eliminate. Post-bariatric surgery restores body harmony and completes the transformation started with bariatric surgery.',
      requestAssessment: 'Request assessment',
      resultsTitle: 'Results — Before and After',
      realCase: 'Real case — Dr. Norro\'s patient',
      resultCaption: 'Reduction of over 40 kg — Result at 18 months',
      stats: [
        { value: '+35', label: 'Years of clinical experience' },
        { value: '6', label: 'Body procedures available' },
        { value: '18', label: 'Minimum months post-bariatric recommended' },
        { value: '100%', label: 'Individualized surgical plan' },
      ],
      contextTitle: '01 — Context',
      contextSubtitle: 'Beyond the lost weight',
      proceduresTitle: '02 — Procedures',
      proceduresSubtitle: 'Comprehensive body contour restoration',
      procedures: [
        { num: '01', title: 'Abdominal dermolipectomy', desc: 'Resection of the abdominal apron and plication of abdominal muscles when diastasis exists.', tags: ['Abdominoplasty', 'Panniculectomy'] },
        { num: '02', title: 'Lower body lift', desc: 'Circumferential resection of excess skin in the lower trunk area.', tags: ['Circumferential lift'] },
        { num: '03', title: 'Brachioplasty', desc: 'Resection of excess skin on the inner arm.', tags: ['Arm', 'Armpit'] },
        { num: '04', title: 'Thigh lift', desc: 'Correction of redundant skin on the inner and/or anterolateral thigh.', tags: ['Cruroplasty', 'Thigh lift'] },
        { num: '05', title: 'Mastopexy and breast augmentation', desc: 'Weight loss produces ptosis and breast deflation in women.', tags: ['Gynecomastia in men'] },
        { num: '06', title: 'Facial and cervical lift', desc: 'Ptosis of the lower third of the face and excess cervical skin.', tags: ['Neck', 'Jowl', 'Facial contour'] },
      ],
      methodologyTitle: '03 — Methodology',
      methodologySubtitle: 'Structured surgical process',
      methodology: [
        { num: '01', title: 'Initial consultation and comprehensive evaluation', desc: 'Complete clinical examination, bariatric history analysis.' },
        { num: '02', title: 'Sequenced surgical planning', desc: 'Staged plan design when multiple areas are combined.' },
        { num: '03', title: 'Surgery and hospitalization', desc: 'Surgery under general anesthesia or conscious sedation as appropriate.' },
        { num: '04', title: 'Follow-up and final result', desc: 'Protocolized postoperative controls at 1, 3, 6 and 12 months.' },
      ],
      candidateTitle: '04 — Ideal candidate',
      candidateSubtitle: 'Patient profile',
      criteriaIntro: 'To achieve the best results with maximum safety, the optimal candidate must meet the following criteria:',
      criteria: [
        'Weight loss stabilized for a minimum of 12-18 months',
        'BMI equal to or less than 32 kg/m² at the time of surgery',
        'Optimal nutritional status: proteins, iron, vitamin D and B12 within normal ranges',
        'Non-active smoker (minimum 6 weeks preoperative abstinence)',
        'Absence of uncontrolled pathology (diabetes, hypertension, coagulopathy)',
        'Realistic expectations and fundamentally functional motivation and quality of life',
        'Understanding of the scarring nature of procedures',
      ],
      ctaTitle: 'Ready to take the definitive step towards your new image?',
      ctaDesc: 'Request an assessment consultation with Dr. Norro to design a personalized surgical plan.',
    },
    fr: {
      category: 'Chirurgie Plastique Avancée',
      heroTitle1: 'La nouvelle silhouette que',
      heroTitle2: 'votre effort mérite',
      heroDesc: 'Après une perte de poids significative, le corps conserve des excès de peau et de tissu qu\'aucun exercice ne peut éliminer. La chirurgie post-bariatrique restaure l\'harmonie corporelle et complète la transformation initiée par la chirurgie bariatrique.',
      requestAssessment: 'Demander une évaluation',
      resultsTitle: 'Résultats — Avant et Après',
      realCase: 'Cas réel — Patient du Dr. Norro',
      resultCaption: 'Réduction de plus de 40 kg — Résultat à 18 mois',
      stats: [
        { value: '+35', label: 'Années d\'expérience clinique' },
        { value: '6', label: 'Procédures corporelles disponibles' },
        { value: '18', label: 'Mois minimum post-bariatrique recommandés' },
        { value: '100%', label: 'Plan chirurgical individualisé' },
      ],
      contextTitle: '01 — Contexte',
      contextSubtitle: 'Au-delà du poids perdu',
      proceduresTitle: '02 — Procédures',
      proceduresSubtitle: 'Restauration complète du contour corporel',
      procedures: [
        { num: '01', title: 'Dermolipectomie abdominale', desc: 'Résection du tablier abdominal et plicature de la musculature abdominale.', tags: ['Abdominoplastie', 'Panniculectomie'] },
        { num: '02', title: 'Body lift inférieur', desc: 'Résection circonférentielle de l\'excès de peau dans la zone inférieure du tronc.', tags: ['Lifting circonférentiel'] },
        { num: '03', title: 'Brachioplastie', desc: 'Résection de l\'excès cutané de la face interne du bras.', tags: ['Bras', 'Aisselle'] },
        { num: '04', title: 'Lifting des cuisses', desc: 'Correction de la peau redondante sur la face interne et/ou antérolatérale de la cuisse.', tags: ['Cruroplastie', 'Thigh lift'] },
        { num: '05', title: 'Mastopexie et augmentation mammaire', desc: 'La perte de poids produit une ptose et une déflation mammaire chez la femme.', tags: ['Gynécomastie chez l\'homme'] },
        { num: '06', title: 'Lifting facial et cervical', desc: 'Ptose du tiers inférieur du visage et excès de peau cervicale.', tags: ['Cou', 'Double menton', 'Ovale facial'] },
      ],
      methodologyTitle: '03 — Méthodologie',
      methodologySubtitle: 'Processus chirurgical structuré',
      methodology: [
        { num: '01', title: 'Première consultation et évaluation complète', desc: 'Examen clinique complet, analyse de l\'historique bariatrique.' },
        { num: '02', title: 'Planification chirurgicale séquencée', desc: 'Conception du plan par étapes lorsque plusieurs zones sont combinées.' },
        { num: '03', title: 'Intervention et hospitalisation', desc: 'Chirurgie sous anesthésie générale ou sédation consciente selon le cas.' },
        { num: '04', title: 'Suivi et résultat définitif', desc: 'Contrôles postopératoires protocolisés à 1, 3, 6 et 12 mois.' },
      ],
      candidateTitle: '04 — Candidat idéal',
      candidateSubtitle: 'Profil du patient',
      criteriaIntro: 'Pour obtenir les meilleurs résultats avec une sécurité maximale, le candidat optimal doit répondre aux critères suivants:',
      criteria: [
        'Perte de poids stabilisée pendant un minimum de 12-18 mois',
        'IMC égal ou inférieur à 32 kg/m² au moment de la chirurgie',
        'État nutritionnel optimal: protéines, fer, vitamine D et B12 dans les limites normales',
        'Non-fumeur actif (minimum 6 semaines d\'abstinence préopératoire)',
        'Absence de pathologie non contrôlée (diabète, HTA, coagulopathie)',
        'Attentes réalistes et motivation fondamentalement fonctionnelle et de qualité de vie',
        'Compréhension de la nature cicatricielle des procédures',
      ],
      ctaTitle: 'Prêt à franchir le pas définitif vers votre nouvelle image?',
      ctaDesc: 'Demandez une consultation d\'évaluation avec le Dr. Norro pour concevoir un plan chirurgical personnalisé.',
    },
    pt: {
      category: 'Cirurgia Plástica Avançada',
      heroTitle1: 'A nova silhueta que',
      heroTitle2: 'seu esforço merece',
      heroDesc: 'Após uma perda de peso significativa, o corpo conserva excessos de pele e tecido que nenhum exercício pode eliminar. A cirurgia pós-bariátrica restaura a harmonia corporal e completa a transformação iniciada com a cirurgia bariátrica.',
      requestAssessment: 'Solicitar avaliação',
      resultsTitle: 'Resultados — Antes e Depois',
      realCase: 'Caso real — Paciente do Dr. Norro',
      resultCaption: 'Redução de mais de 40 kg — Resultado aos 18 meses',
      stats: [
        { value: '+35', label: 'Anos de experiência clínica' },
        { value: '6', label: 'Procedimentos corporais disponíveis' },
        { value: '18', label: 'Meses mínimos pós-bariátrica recomendados' },
        { value: '100%', label: 'Plano cirúrgico individualizado' },
      ],
      contextTitle: '01 — Contexto',
      contextSubtitle: 'Além do peso perdido',
      proceduresTitle: '02 — Procedimentos',
      proceduresSubtitle: 'Restauração integral do contorno corporal',
      procedures: [
        { num: '01', title: 'Dermolipectomia abdominal', desc: 'Ressecção do avental abdominal e plicatura da musculatura abdominal.', tags: ['Abdominoplastia', 'Paniculectomia'] },
        { num: '02', title: 'Body lift inferior', desc: 'Ressecção circunferencial do excesso de pele na zona inferior do tronco.', tags: ['Lifting circunferencial'] },
        { num: '03', title: 'Braquioplastia', desc: 'Ressecção do excesso cutâneo da face interna do braço.', tags: ['Braço', 'Axila'] },
        { num: '04', title: 'Lifting de coxas', desc: 'Correção da pele redundante na face interna e/ou anterolateral da coxa.', tags: ['Cruroplastia', 'Thigh lift'] },
        { num: '05', title: 'Mastopexia e aumento mamário', desc: 'A perda de peso produz ptose e deflação mamária na mulher.', tags: ['Ginecomastia em homens'] },
        { num: '06', title: 'Lifting facial e cervical', desc: 'Ptose do terço inferior facial e excesso de pele cervical.', tags: ['Pescoço', 'Papada', 'Contorno facial'] },
      ],
      methodologyTitle: '03 — Metodologia',
      methodologySubtitle: 'Processo cirúrgico estruturado',
      methodology: [
        { num: '01', title: 'Primeira consulta e avaliação integral', desc: 'Exame clínico completo, análise do histórico bariátrico.' },
        { num: '02', title: 'Planejamento cirúrgico sequenciado', desc: 'Desenho do plano por etapas quando se combinam múltiplas zonas.' },
        { num: '03', title: 'Intervenção e hospitalização', desc: 'Cirurgia sob anestesia geral ou sedação consciente conforme o caso.' },
        { num: '04', title: 'Acompanhamento e resultado definitivo', desc: 'Controles pós-operatórios protocolizados em 1, 3, 6 e 12 meses.' },
      ],
      candidateTitle: '04 — Candidato ideal',
      candidateSubtitle: 'Perfil do paciente',
      criteriaIntro: 'Para obter os melhores resultados com máxima segurança, o candidato ideal deve cumprir os seguintes critérios:',
      criteria: [
        'Perda de peso estabilizada por um mínimo de 12-18 meses',
        'IMC igual ou inferior a 32 kg/m² no momento da cirurgia',
        'Estado nutricional ótimo: proteínas, ferro, vitamina D e B12 dentro dos valores normais',
        'Não fumante ativo (mínimo 6 semanas de abstinência pré-operatória)',
        'Ausência de patologia não controlada (diabetes, HTA, coagulopatia)',
        'Expectativas realistas e motivação fundamentalmente funcional e de qualidade de vida',
        'Compreensão da natureza cicatricial dos procedimentos',
      ],
      ctaTitle: 'Pronto para dar o passo definitivo em direção à sua nova imagem?',
      ctaDesc: 'Solicite uma consulta de avaliação com o Dr. Norro para desenhar um plano cirúrgico personalizado.',
    },
  },

  // ArmonizacionFacial page translations
  armonizacionFacial: {
    es: {
      category: 'Medicina Estética',
      title: 'Armonización Facial',
      heroDesc: 'Restauración del equilibrio facial mediante tratamientos personalizados. Fillers de ácido hialurónico, estimuladores de colágeno y neuromoduladores para recuperar volumen y definición.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      treatmentsTitle: 'Tratamientos',
      treatmentsSubtitle: 'Opciones de tratamiento',
      treatments: [
        { title: 'Ácido Hialurónico', desc: 'Relleno dérmico para restaurar volumen en pómulos, labios, mentón y ojeras. Resultados inmediatos y naturales.' },
        { title: 'Estimuladores de Colágeno', desc: 'Inductores de colágeno como hidroxiapatita cálcica o PLLA para regeneración progresiva del tejido.' },
        { title: 'Neuromoduladores', desc: 'Toxina botulínica para suavizar líneas de expresión en frente, entrecejo y patas de gallo.' },
      ],
      areasTitle: 'Áreas de Tratamiento',
      areasSubtitle: 'Zonas que podemos mejorar',
      areas: [
        'Pómulos y mejillas',
        'Surcos nasogenianos',
        'Código de barras (labio superior)',
        'Volumen labial',
        'Líneas de marioneta',
        'Definición del mentón',
        'Corrección de ojeras',
        'Líneas de expresión',
      ],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada. Sin compromiso.',
      contact: 'Contactar',
    },
    en: {
      category: 'Aesthetic Medicine',
      title: 'Facial Harmonization',
      heroDesc: 'Restoration of facial balance through personalized treatments. Hyaluronic acid fillers, collagen stimulators and neuromodulators to restore volume and definition.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      treatmentsTitle: 'Treatments',
      treatmentsSubtitle: 'Treatment options',
      treatments: [
        { title: 'Hyaluronic Acid', desc: 'Dermal filler to restore volume in cheekbones, lips, chin and dark circles. Immediate and natural results.' },
        { title: 'Collagen Stimulators', desc: 'Collagen inducers such as calcium hydroxyapatite or PLLA for progressive tissue regeneration.' },
        { title: 'Neuromodulators', desc: 'Botulinum toxin to soften expression lines on forehead, frown lines and crow\'s feet.' },
      ],
      areasTitle: 'Treatment Areas',
      areasSubtitle: 'Areas we can improve',
      areas: [
        'Cheekbones and cheeks',
        'Nasolabial folds',
        'Barcode lines (upper lip)',
        'Lip volume',
        'Marionette lines',
        'Chin definition',
        'Dark circle correction',
        'Expression lines',
      ],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation. No obligation.',
      contact: 'Contact',
    },
    fr: {
      category: 'Médecine Esthétique',
      title: 'Harmonisation Faciale',
      heroDesc: 'Restauration de l\'équilibre facial par des traitements personnalisés. Fillers d\'acide hyaluronique, stimulateurs de collagène et neuromodulateurs pour restaurer volume et définition.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      treatmentsTitle: 'Traitements',
      treatmentsSubtitle: 'Options de traitement',
      treatments: [
        { title: 'Acide Hyaluronique', desc: 'Comblement dermique pour restaurer le volume des pommettes, lèvres, menton et cernes. Résultats immédiats et naturels.' },
        { title: 'Stimulateurs de Collagène', desc: 'Inducteurs de collagène comme l\'hydroxyapatite de calcium ou PLLA pour une régénération progressive des tissus.' },
        { title: 'Neuromodulateurs', desc: 'Toxine botulique pour adoucir les rides d\'expression du front, rides du lion et pattes d\'oie.' },
      ],
      areasTitle: 'Zones de Traitement',
      areasSubtitle: 'Zones que nous pouvons améliorer',
      areas: [
        'Pommettes et joues',
        'Sillons nasogéniens',
        'Code-barres (lèvre supérieure)',
        'Volume labial',
        'Rides de la marionnette',
        'Définition du menton',
        'Correction des cernes',
        'Rides d\'expression',
      ],
      ctaTitle: 'Vous souhaitez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée. Sans engagement.',
      contact: 'Contacter',
    },
    pt: {
      category: 'Medicina Estética',
      title: 'Harmonização Facial',
      heroDesc: 'Restauração do equilíbrio facial através de tratamentos personalizados. Preenchedores de ácido hialurônico, estimuladores de colágeno e neuromoduladores para restaurar volume e definição.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      treatmentsTitle: 'Tratamentos',
      treatmentsSubtitle: 'Opções de tratamento',
      treatments: [
        { title: 'Ácido Hialurônico', desc: 'Preenchimento dérmico para restaurar volume em maçãs do rosto, lábios, queixo e olheiras. Resultados imediatos e naturais.' },
        { title: 'Estimuladores de Colágeno', desc: 'Indutores de colágeno como hidroxiapatita de cálcio ou PLLA para regeneração progressiva dos tecidos.' },
        { title: 'Neuromoduladores', desc: 'Toxina botulínica para suavizar linhas de expressão na testa, glabela e pés de galinha.' },
      ],
      areasTitle: 'Áreas de Tratamento',
      areasSubtitle: 'Zonas que podemos melhorar',
      areas: [
        'Maçãs do rosto e bochechas',
        'Sulcos nasogenianos',
        'Código de barras (lábio superior)',
        'Volume labial',
        'Linhas de marionete',
        'Definição do queixo',
        'Correção de olheiras',
        'Linhas de expressão',
      ],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada. Sem compromisso.',
      contact: 'Contatar',
    },
  },

  // ElevacionCejas page translations
  elevacionCejas: {
    es: {
      category: 'Cirugía Facial',
      title: 'Elevación de Cejas',
      heroDesc: 'Rejuvenecimiento del tercio superior facial mediante lifting de cejas. Técnicas mínimamente invasivas para una mirada más abierta y expresiva.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      techniquesTitle: 'Técnicas',
      techniquesSubtitle: 'Opciones de tratamiento',
      techniques: [
        { title: 'Lifting Temporal', desc: 'Elevación de la cola de la ceja mediante incisiones mínimas en el cuero cabelludo. Efecto natural y duradero.' },
        { title: 'Endolifting con Láser', desc: 'Técnica mínimamente invasiva con láser para elevar las cejas sin cicatrices visibles.' },
        { title: 'Neuromoduladores', desc: 'Toxina botulínica para elevar la cola de la ceja y abrir la mirada. Tratamiento no quirúrgico.' },
      ],
      benefitsTitle: 'Beneficios',
      benefitsSubtitle: 'Ventajas del tratamiento',
      benefits: [
        'Mirada más abierta y juvenil',
        'Corrección de la ptosis de cejas',
        'Reducción de arrugas frontales',
        'Resultados naturales',
        'Recuperación rápida',
        'Mejora del contorno del ojo',
      ],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada. Sin compromiso.',
      contact: 'Contactar',
    },
    en: {
      category: 'Facial Surgery',
      title: 'Brow Lift',
      heroDesc: 'Rejuvenation of the upper third of the face through brow lift. Minimally invasive techniques for a more open and expressive look.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      techniquesTitle: 'Techniques',
      techniquesSubtitle: 'Treatment options',
      techniques: [
        { title: 'Temporal Lift', desc: 'Elevation of the brow tail through minimal incisions in the scalp. Natural and lasting effect.' },
        { title: 'Laser Endolifting', desc: 'Minimally invasive technique with laser to lift eyebrows without visible scars.' },
        { title: 'Neuromodulators', desc: 'Botulinum toxin to lift the brow tail and open the look. Non-surgical treatment.' },
      ],
      benefitsTitle: 'Benefits',
      benefitsSubtitle: 'Treatment advantages',
      benefits: [
        'More open and youthful look',
        'Correction of brow ptosis',
        'Reduction of forehead wrinkles',
        'Natural results',
        'Quick recovery',
        'Improved eye contour',
      ],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation. No obligation.',
      contact: 'Contact',
    },
    fr: {
      category: 'Chirurgie Faciale',
      title: 'Lifting des Sourcils',
      heroDesc: 'Rajeunissement du tiers supérieur du visage par lifting des sourcils. Techniques minimalement invasives pour un regard plus ouvert et expressif.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      techniquesTitle: 'Techniques',
      techniquesSubtitle: 'Options de traitement',
      techniques: [
        { title: 'Lifting Temporal', desc: 'Élévation de la queue du sourcil par incisions minimales dans le cuir chevelu. Effet naturel et durable.' },
        { title: 'Endolifting au Laser', desc: 'Technique minimalement invasive au laser pour relever les sourcils sans cicatrices visibles.' },
        { title: 'Neuromodulateurs', desc: 'Toxine botulique pour relever la queue du sourcil et ouvrir le regard. Traitement non chirurgical.' },
      ],
      benefitsTitle: 'Avantages',
      benefitsSubtitle: 'Avantages du traitement',
      benefits: [
        'Regard plus ouvert et jeune',
        'Correction de la ptose des sourcils',
        'Réduction des rides frontales',
        'Résultats naturels',
        'Récupération rapide',
        'Amélioration du contour de l\'œil',
      ],
      ctaTitle: 'Vous souhaitez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée. Sans engagement.',
      contact: 'Contacter',
    },
    pt: {
      category: 'Cirurgia Facial',
      title: 'Elevação de Sobrancelhas',
      heroDesc: 'Rejuvenescimento do terço superior facial através de lifting de sobrancelhas. Técnicas minimamente invasivas para um olhar mais aberto e expressivo.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      techniquesTitle: 'Técnicas',
      techniquesSubtitle: 'Opções de tratamento',
      techniques: [
        { title: 'Lifting Temporal', desc: 'Elevação da cauda da sobrancelha através de incisões mínimas no couro cabeludo. Efeito natural e duradouro.' },
        { title: 'Endolifting com Laser', desc: 'Técnica minimamente invasiva com laser para elevar as sobrancelhas sem cicatrizes visíveis.' },
        { title: 'Neuromoduladores', desc: 'Toxina botulínica para elevar a cauda da sobrancelha e abrir o olhar. Tratamento não cirúrgico.' },
      ],
      benefitsTitle: 'Benefícios',
      benefitsSubtitle: 'Vantagens do tratamento',
      benefits: [
        'Olhar mais aberto e jovem',
        'Correção da ptose de sobrancelhas',
        'Redução de rugas frontais',
        'Resultados naturais',
        'Recuperação rápida',
        'Melhora do contorno do olho',
      ],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada. Sem compromisso.',
      contact: 'Contatar',
    },
  },

  // OjerasSinCirugia page translations
  ojerasSinCirugia: {
    es: {
      category: 'Medicina Estética',
      title: 'Ojeras sin Cirugía',
      heroDesc: 'Tratamiento no quirúrgico del surco nasoyugal y las ojeras. Relleno con ácido hialurónico de alta cohesividad y/o PRP para una mirada descansada y rejuvenecida.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      benefitsTitle: 'Beneficios',
      benefitsSubtitle: 'Ventajas del tratamiento',
      benefits: [
        'Tratamiento sin cirugía ni hospitalización',
        'Resultados inmediatos y naturales',
        'Mínimo tiempo de recuperación',
        'Relleno con ácido hialurónico de alta cohesividad',
        'Combinable con PRP para regeneración',
        'Sesión de 30-45 minutos',
      ],
      indicationsTitle: 'Indicaciones',
      indicationsSubtitle: '¿Para quién está indicado?',
      indications: [
        'Surco nasoyugal marcado (ojera profunda)',
        'Pérdida de volumen en el párpado inferior',
        'Ojeras oscuras por transparencia vascular',
        'Aspecto cansado crónico',
      ],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada. Sin compromiso.',
      contact: 'Contactar',
    },
    en: {
      category: 'Aesthetic Medicine',
      title: 'Non-Surgical Dark Circles',
      heroDesc: 'Non-surgical treatment of the tear trough and dark circles. Filler with high cohesivity hyaluronic acid and/or PRP for a rested and rejuvenated look.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      benefitsTitle: 'Benefits',
      benefitsSubtitle: 'Treatment advantages',
      benefits: [
        'Treatment without surgery or hospitalization',
        'Immediate and natural results',
        'Minimal recovery time',
        'High cohesivity hyaluronic acid filler',
        'Combinable with PRP for regeneration',
        '30-45 minute session',
      ],
      indicationsTitle: 'Indications',
      indicationsSubtitle: 'Who is it for?',
      indications: [
        'Marked tear trough (deep dark circles)',
        'Volume loss in the lower eyelid',
        'Dark circles due to vascular transparency',
        'Chronic tired appearance',
      ],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation. No obligation.',
      contact: 'Contact',
    },
    fr: {
      category: 'Médecine Esthétique',
      title: 'Cernes sans Chirurgie',
      heroDesc: 'Traitement non chirurgical du sillon lacrymal et des cernes. Comblement avec acide hyaluronique haute cohésivité et/ou PRP pour un regard reposé et rajeuni.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      benefitsTitle: 'Avantages',
      benefitsSubtitle: 'Avantages du traitement',
      benefits: [
        'Traitement sans chirurgie ni hospitalisation',
        'Résultats immédiats et naturels',
        'Temps de récupération minimal',
        'Comblement avec acide hyaluronique haute cohésivité',
        'Combinable avec PRP pour régénération',
        'Séance de 30-45 minutes',
      ],
      indicationsTitle: 'Indications',
      indicationsSubtitle: 'Pour qui est-ce indiqué?',
      indications: [
        'Sillon lacrymal marqué (cerne profond)',
        'Perte de volume de la paupière inférieure',
        'Cernes sombres par transparence vasculaire',
        'Aspect fatigué chronique',
      ],
      ctaTitle: 'Vous souhaitez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée. Sans engagement.',
      contact: 'Contacter',
    },
    pt: {
      category: 'Medicina Estética',
      title: 'Olheiras sem Cirurgia',
      heroDesc: 'Tratamento não cirúrgico do sulco nasojugal e olheiras. Preenchimento com ácido hialurônico de alta coesividade e/ou PRP para um olhar descansado e rejuvenescido.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      benefitsTitle: 'Benefícios',
      benefitsSubtitle: 'Vantagens do tratamento',
      benefits: [
        'Tratamento sem cirurgia nem hospitalização',
        'Resultados imediatos e naturais',
        'Tempo mínimo de recuperação',
        'Preenchimento com ácido hialurônico de alta coesividade',
        'Combinável com PRP para regeneração',
        'Sessão de 30-45 minutos',
      ],
      indicationsTitle: 'Indicações',
      indicationsSubtitle: 'Para quem é indicado?',
      indications: [
        'Sulco nasojugal marcado (olheira profunda)',
        'Perda de volume na pálpebra inferior',
        'Olheiras escuras por transparência vascular',
        'Aspecto cansado crônico',
      ],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada. Sem compromisso.',
      contact: 'Contatar',
    },
  },

  // MedicinaIntegrativa page translations
  medicinaIntegrativa: {
    es: {
      category: 'Medicina Estética y Bienestar',
      title: 'Medicina Integrativa',
      heroDesc: 'IV Drips con vitaminas, antioxidantes y minerales. Reposición hormonal bioidéntica. Enfoque de medicina de precisión y bienestar integral para optimizar tu salud y longevidad.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      servicesTitle: 'Servicios',
      servicesSubtitle: 'Áreas de tratamiento',
      services: [
        { title: 'IV Drips', desc: 'Terapia intravenosa de vitaminas, antioxidantes y minerales para energía, detox y rejuvenecimiento celular.' },
        { title: 'Reposición Hormonal', desc: 'Hormonas bioidénticas para equilibrio hormonal óptimo. Menopausia, andropausia y optimización.' },
        { title: 'Medicina de Precisión', desc: 'Protocolos personalizados basados en analíticas avanzadas. Longevidad y bienestar integral.' },
      ],
      dripsTitle: 'IV Drips',
      dripsSubtitle: 'Protocolos disponibles',
      drips: [
        { name: 'Energy Boost', desc: 'Complejo vitamínico B + minerales para energía' },
        { name: 'Detox & Glow', desc: 'Antioxidantes + glutation para piel radiante' },
        { name: 'Immunity Plus', desc: 'Vitamina C alta dosis + zinc para inmunidad' },
        { name: 'Recovery', desc: 'Aminoacidos + electrolitos post-esfuerzo' },
        { name: 'Anti-Aging', desc: 'NAD+ y precursores para longevidad celular' },
        { name: 'Personalizado', desc: 'Fórmula adaptada a tus necesidades' },
      ],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada. Sin compromiso.',
      contact: 'Contactar',
    },
    en: {
      category: 'Aesthetic Medicine & Wellness',
      title: 'Integrative Medicine',
      heroDesc: 'IV Drips with vitamins, antioxidants and minerals. Bioidentical hormone replacement. Precision medicine and holistic wellness approach to optimize your health and longevity.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      servicesTitle: 'Services',
      servicesSubtitle: 'Treatment areas',
      services: [
        { title: 'IV Drips', desc: 'Intravenous therapy with vitamins, antioxidants and minerals for energy, detox and cellular rejuvenation.' },
        { title: 'Hormone Replacement', desc: 'Bioidentical hormones for optimal hormonal balance. Menopause, andropause and optimization.' },
        { title: 'Precision Medicine', desc: 'Personalized protocols based on advanced analytics. Longevity and holistic wellness.' },
      ],
      dripsTitle: 'IV Drips',
      dripsSubtitle: 'Available protocols',
      drips: [
        { name: 'Energy Boost', desc: 'Vitamin B complex + minerals for energy' },
        { name: 'Detox & Glow', desc: 'Antioxidants + glutathione for radiant skin' },
        { name: 'Immunity Plus', desc: 'High dose Vitamin C + zinc for immunity' },
        { name: 'Recovery', desc: 'Amino acids + electrolytes post-effort' },
        { name: 'Anti-Aging', desc: 'NAD+ and precursors for cellular longevity' },
        { name: 'Personalized', desc: 'Formula adapted to your needs' },
      ],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation. No obligation.',
      contact: 'Contact',
    },
    fr: {
      category: 'Médecine Esthétique et Bien-être',
      title: 'Médecine Intégrative',
      heroDesc: 'IV Drips avec vitamines, antioxydants et minéraux. Remplacement hormonal bio-identique. Approche de médecine de précision et bien-être intégral pour optimiser votre santé et longévité.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      servicesTitle: 'Services',
      servicesSubtitle: 'Domaines de traitement',
      services: [
        { title: 'IV Drips', desc: 'Thérapie intraveineuse de vitamines, antioxydants et minéraux pour énergie, détox et rajeunissement cellulaire.' },
        { title: 'Remplacement Hormonal', desc: 'Hormones bio-identiques pour équilibre hormonal optimal. Ménopause, andropause et optimisation.' },
        { title: 'Médecine de Précision', desc: 'Protocoles personnalisés basés sur analyses avancées. Longévité et bien-être intégral.' },
      ],
      dripsTitle: 'IV Drips',
      dripsSubtitle: 'Protocoles disponibles',
      drips: [
        { name: 'Energy Boost', desc: 'Complexe vitaminique B + minéraux pour énergie' },
        { name: 'Detox & Glow', desc: 'Antioxydants + glutathion pour peau radieuse' },
        { name: 'Immunity Plus', desc: 'Vitamine C haute dose + zinc pour immunité' },
        { name: 'Recovery', desc: 'Acides aminés + électrolytes post-effort' },
        { name: 'Anti-Aging', desc: 'NAD+ et précurseurs pour longévité cellulaire' },
        { name: 'Personnalisé', desc: 'Formule adaptée à vos besoins' },
      ],
      ctaTitle: 'Vous souhaitez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée. Sans engagement.',
      contact: 'Contacter',
    },
    pt: {
      category: 'Medicina Estética e Bem-estar',
      title: 'Medicina Integrativa',
      heroDesc: 'IV Drips com vitaminas, antioxidantes e minerais. Reposição hormonal bioidêntica. Abordagem de medicina de precisão e bem-estar integral para otimizar sua saúde e longevidade.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      servicesTitle: 'Serviços',
      servicesSubtitle: 'Áreas de tratamento',
      services: [
        { title: 'IV Drips', desc: 'Terapia intravenosa de vitaminas, antioxidantes e minerais para energia, detox e rejuvenescimento celular.' },
        { title: 'Reposição Hormonal', desc: 'Hormônios bioidênticos para equilíbrio hormonal ótimo. Menopausa, andropausa e otimização.' },
        { title: 'Medicina de Precisão', desc: 'Protocolos personalizados baseados em análises avançadas. Longevidade e bem-estar integral.' },
      ],
      dripsTitle: 'IV Drips',
      dripsSubtitle: 'Protocolos disponíveis',
      drips: [
        { name: 'Energy Boost', desc: 'Complexo vitamínico B + minerais para energia' },
        { name: 'Detox & Glow', desc: 'Antioxidantes + glutationa para pele radiante' },
        { name: 'Immunity Plus', desc: 'Vitamina C alta dose + zinco para imunidade' },
        { name: 'Recovery', desc: 'Aminoácidos + eletrólitos pós-esforço' },
        { name: 'Anti-Aging', desc: 'NAD+ e precursores para longevidade celular' },
        { name: 'Personalizado', desc: 'Fórmula adaptada às suas necessidades' },
      ],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada. Sem compromisso.',
      contact: 'Contatar',
    },
  },

  // CirugiaDermatologica page translations
  cirugiaDermatologica: {
    es: {
      category: 'Cirugía Reparadora',
      title: 'Cirugía Dermatológica',
      heroDesc: 'Resección de lesiones cutáneas benignas y malignas con técnicas de cirugía plástica para minimizar la cicatriz. Márgenes oncológicos y análisis histopatológico de cada pieza.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      lesionsTitle: 'Tratamos',
      lesionsSubtitle: 'Tipos de lesiones',
      lesions: [
        { type: 'Lesiones Benignas', examples: ['Nevus (lunares)', 'Quistes epidérmicos', 'Fibromas', 'Lipomas', 'Queratosis seborreicas'] },
        { type: 'Lesiones Malignas', examples: ['Carcinoma basocelular', 'Carcinoma espinocelular', 'Melanoma', 'Queratosis actínicas'] },
      ],
      advantagesTitle: 'Ventajas',
      advantagesSubtitle: 'Nuestro enfoque',
      advantages: [
        'Resección con márgenes oncológicos cuando es necesario',
        'Cierre con técnicas de cirugía plástica',
        'Mínima cicatriz visible',
        'Análisis histopatológico de todas las piezas',
        'Seguimiento postoperatorio personalizado',
      ],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada. Sin compromiso.',
      contact: 'Contactar',
    },
    en: {
      category: 'Reconstructive Surgery',
      title: 'Dermatological Surgery',
      heroDesc: 'Resection of benign and malignant skin lesions with plastic surgery techniques to minimize scarring. Oncological margins and histopathological analysis of each specimen.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      lesionsTitle: 'We Treat',
      lesionsSubtitle: 'Types of lesions',
      lesions: [
        { type: 'Benign Lesions', examples: ['Nevi (moles)', 'Epidermal cysts', 'Fibromas', 'Lipomas', 'Seborrheic keratoses'] },
        { type: 'Malignant Lesions', examples: ['Basal cell carcinoma', 'Squamous cell carcinoma', 'Melanoma', 'Actinic keratoses'] },
      ],
      advantagesTitle: 'Advantages',
      advantagesSubtitle: 'Our approach',
      advantages: [
        'Resection with oncological margins when necessary',
        'Closure with plastic surgery techniques',
        'Minimal visible scarring',
        'Histopathological analysis of all specimens',
        'Personalized postoperative follow-up',
      ],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation. No obligation.',
      contact: 'Contact',
    },
    fr: {
      category: 'Chirurgie Réparatrice',
      title: 'Chirurgie Dermatologique',
      heroDesc: 'Résection de lésions cutanées bénignes et malignes avec techniques de chirurgie plastique pour minimiser la cicatrice. Marges oncologiques et analyse histopathologique de chaque pièce.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      lesionsTitle: 'Nous Traitons',
      lesionsSubtitle: 'Types de lésions',
      lesions: [
        { type: 'Lésions Bénignes', examples: ['Nævi (grains de beauté)', 'Kystes épidermiques', 'Fibromes', 'Lipomes', 'Kératoses séborrhéiques'] },
        { type: 'Lésions Malignes', examples: ['Carcinome basocellulaire', 'Carcinome spinocellulaire', 'Mélanome', 'Kératoses actiniques'] },
      ],
      advantagesTitle: 'Avantages',
      advantagesSubtitle: 'Notre approche',
      advantages: [
        'Résection avec marges oncologiques si nécessaire',
        'Fermeture avec techniques de chirurgie plastique',
        'Cicatrice visible minimale',
        'Analyse histopathologique de toutes les pièces',
        'Suivi postopératoire personnalisé',
      ],
      ctaTitle: 'Vous souhaitez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée. Sans engagement.',
      contact: 'Contacter',
    },
    pt: {
      category: 'Cirurgia Reparadora',
      title: 'Cirurgia Dermatológica',
      heroDesc: 'Ressecção de lesões cutâneas benignas e malignas com técnicas de cirurgia plástica para minimizar a cicatriz. Margens oncológicas e análise histopatológica de cada peça.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      lesionsTitle: 'Tratamos',
      lesionsSubtitle: 'Tipos de lesões',
      lesions: [
        { type: 'Lesões Benignas', examples: ['Nevos (sinais)', 'Cistos epidérmicos', 'Fibromas', 'Lipomas', 'Queratoses seborreicas'] },
        { type: 'Lesões Malignas', examples: ['Carcinoma basocelular', 'Carcinoma espinocelular', 'Melanoma', 'Queratoses actínicas'] },
      ],
      advantagesTitle: 'Vantagens',
      advantagesSubtitle: 'Nossa abordagem',
      advantages: [
        'Ressecção com margens oncológicas quando necessário',
        'Fechamento com técnicas de cirurgia plástica',
        'Cicatriz visível mínima',
        'Análise histopatológica de todas as peças',
        'Acompanhamento pós-operatório personalizado',
      ],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada. Sem compromisso.',
      contact: 'Contatar',
    },
  },

  // CirugiasSecundarias page translations
  cirugiasSecundarias: {
    es: {
      category: 'Cirugía Reparadora',
      title: 'Cirugía Plástica Secundaria',
      heroDesc: 'Revisión y mejora de resultados de cirugías estéticas previas realizadas en otras clínicas. Corrección de complicaciones, asimetrías y resultados insatisfactorios.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      casesTitle: 'Casos',
      casesSubtitle: 'Qué podemos corregir',
      cases: [
        { title: 'Rinoplastia Secundaria', desc: 'Corrección de resultados insatisfactorios en cirugía de nariz previa.' },
        { title: 'Mamoplastia Secundaria', desc: 'Revisión de aumento, reducción o mastopexia con resultados subóptimos.' },
        { title: 'Blefaroplastia Secundaria', desc: 'Corrección de exceso de resección o asimetrías palpebrales.' },
        { title: 'Abdominoplastia Secundaria', desc: 'Mejora de cicatrices, contorno o corrección de complicaciones.' },
      ],
      approachTitle: 'Enfoque',
      approachSubtitle: 'Nuestro proceso',
      approach: [
        'Análisis detallado del procedimiento previo',
        'Evaluación de las limitaciones del caso',
        'Expectativas realistas basadas en cada situación',
        'Planificación quirúrgica conservadora',
        'Seguimiento postoperatorio exhaustivo',
      ],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada. Sin compromiso.',
      contact: 'Contactar',
    },
    en: {
      category: 'Reconstructive Surgery',
      title: 'Secondary Plastic Surgery',
      heroDesc: 'Revision and improvement of results from previous aesthetic surgeries performed at other clinics. Correction of complications, asymmetries and unsatisfactory results.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      casesTitle: 'Cases',
      casesSubtitle: 'What we can correct',
      cases: [
        { title: 'Secondary Rhinoplasty', desc: 'Correction of unsatisfactory results in previous nose surgery.' },
        { title: 'Secondary Mammoplasty', desc: 'Revision of augmentation, reduction or mastopexy with suboptimal results.' },
        { title: 'Secondary Blepharoplasty', desc: 'Correction of over-resection or eyelid asymmetries.' },
        { title: 'Secondary Abdominoplasty', desc: 'Improvement of scars, contour or correction of complications.' },
      ],
      approachTitle: 'Approach',
      approachSubtitle: 'Our process',
      approach: [
        'Detailed analysis of previous procedure',
        'Evaluation of case limitations',
        'Realistic expectations based on each situation',
        'Conservative surgical planning',
        'Comprehensive postoperative follow-up',
      ],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation. No obligation.',
      contact: 'Contact',
    },
    fr: {
      category: 'Chirurgie Réparatrice',
      title: 'Chirurgie Plastique Secondaire',
      heroDesc: 'Révision et amélioration des résultats de chirurgies esthétiques précédentes réalisées dans d\'autres cliniques. Correction de complications, asymétries et résultats insatisfaisants.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      casesTitle: 'Cas',
      casesSubtitle: 'Ce que nous pouvons corriger',
      cases: [
        { title: 'Rhinoplastie Secondaire', desc: 'Correction de résultats insatisfaisants d\'une chirurgie nasale précédente.' },
        { title: 'Mammoplastie Secondaire', desc: 'Révision d\'augmentation, réduction ou mastopexie avec résultats sous-optimaux.' },
        { title: 'Blépharoplastie Secondaire', desc: 'Correction d\'excès de résection ou asymétries palpébrales.' },
        { title: 'Abdominoplastie Secondaire', desc: 'Amélioration des cicatrices, contour ou correction de complications.' },
      ],
      approachTitle: 'Approche',
      approachSubtitle: 'Notre processus',
      approach: [
        'Analyse détaillée de la procédure précédente',
        'Évaluation des limitations du cas',
        'Attentes réalistes basées sur chaque situation',
        'Planification chirurgicale conservatrice',
        'Suivi postopératoire exhaustif',
      ],
      ctaTitle: 'Vous souhaitez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée. Sans engagement.',
      contact: 'Contacter',
    },
    pt: {
      category: 'Cirurgia Reparadora',
      title: 'Cirurgia Plástica Secundária',
      heroDesc: 'Revisão e melhoria de resultados de cirurgias estéticas anteriores realizadas em outras clínicas. Correção de complicações, assimetrias e resultados insatisfatórios.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      casesTitle: 'Casos',
      casesSubtitle: 'O que podemos corrigir',
      cases: [
        { title: 'Rinoplastia Secundária', desc: 'Correção de resultados insatisfatórios em cirurgia de nariz anterior.' },
        { title: 'Mamoplastia Secundária', desc: 'Revisão de aumento, redução ou mastopexia com resultados subótimos.' },
        { title: 'Blefaroplastia Secundária', desc: 'Correção de excesso de ressecção ou assimetrias palpebrais.' },
        { title: 'Abdominoplastia Secundária', desc: 'Melhoria de cicatrizes, contorno ou correção de complicações.' },
      ],
      approachTitle: 'Abordagem',
      approachSubtitle: 'Nosso processo',
      approach: [
        'Análise detalhada do procedimento anterior',
        'Avaliação das limitações do caso',
        'Expectativas realistas baseadas em cada situação',
        'Planejamento cirúrgico conservador',
        'Acompanhamento pós-operatório exaustivo',
      ],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada. Sem compromisso.',
      contact: 'Contatar',
    },
  },

  // GinecoEstetica page translations
  ginecoEstetica: {
    es: {
      title: 'Gineco Estética y Salud Íntima',
      subtitle: 'Servicios especializados en colaboración con la <strong>Dra. Susana Varela Elias</strong>',
      requestConsult: 'SOLICITAR CONSULTA',
      doctorName: 'Dra. Susana Varela Elias',
      credentials: [
        'Médica Cirujana (Universidad de Córdoba - Argentina)',
        'Especialista en Ginecología (Universidad de Córdoba - Argentina)',
        'Médica Cirujana (Ministerio de Educación y Ciencia - España)',
        'Especialista en Obstetricia y Ginecología (Ministerio de Educación y Ciencia - España)',
        'Experta en Ginecoestética (Universidad Juan Carlos I - España)',
        'Experta en Menopausia (AEEM-SEGO)',
        'Máster en Medicina Estética (TECH)',
        'Máster en Hormonas, Nutrición y Wellness (AIU)',
        'Speaker V-Lift PRO INTIMATE',
      ],
      consultTitle: 'Consultas',
      consults: [
        'Consulta de Terapia Hormonal Bioidéntica Personalizada',
        'Menopausia',
        'Andropausia',
        'Transgénero',
        'Consulta de Ginecología Estética, Regenerativa y Funcional',
        'Cirugía de Armonización Genital',
        'Cirugía post parto (vaginoplastia, perineoplastia)',
        'Incontinencia de orina',
      ],
      regenerativeTitle: 'Tratamientos Regenerativos Íntimos',
      regenerative: [
        { name: 'Síndrome genitourinario de la Menopausia', desc: '' },
        { name: 'Sequedad vaginal', desc: '' },
        { name: 'Atrofia genital', desc: '' },
        { name: 'Laxitud Vaginal', desc: '' },
        { name: 'Incontinencia de orina', desc: '' },
        { name: 'Liquen Escleroso Vulvar', desc: '' },
        { name: 'Dispareunia, vulvodinia, hipertono de músculos del suelo pélvico', desc: '' },
        { name: 'Disfunción sexual orgásmica', desc: '' },
        { name: 'Tratamientos asociados a cirugía reconstructiva genital (heridas, dehiscencias, fístulas)', desc: '' },
        { name: 'Tratamientos vulvovaginales en pacientes Oncológicas', desc: '' },
        { name: 'Aplicación de Factores de Crecimiento autólogos, heterólogos', desc: '' },
        { name: 'Ácido Hialurónico (Cellular Matrix)', desc: '' },
        { name: 'Toxina Botulínica', desc: '' },
        { name: 'Exosomas + Péptidos + HA', desc: '' },
      ],
      surgeryTitle: 'Cirugía Ginecoestética',
      surgery: [
        'Labioplastia',
        'Perineoplastia',
        'Vaginoplastia',
        'Himenoplastia',
        'Clitoropexia',
        'Hoodoplastia',
        'Armonización Genital Avanzada (Cirugía, Cellular Matrix, Exosomas)',
      ],
      ctaTitle: '¿Interesada en nuestros servicios?',
      ctaDesc: 'Solicita tu consulta personalizada con la Dra. Susana Varela Elias',
    },
    en: {
      title: 'Gynecological Aesthetics and Intimate Health',
      subtitle: 'Specialized services in collaboration with <strong>Dr. Susana Varela Elias</strong>',
      requestConsult: 'REQUEST CONSULTATION',
      doctorName: 'Dr. Susana Varela Elias',
      credentials: [
        'Medical Surgeon (University of Córdoba - Argentina)',
        'Specialist in Gynecology (University of Córdoba - Argentina)',
        'Medical Surgeon (Ministry of Education and Science - Spain)',
        'Specialist in Obstetrics and Gynecology (Ministry of Education and Science - Spain)',
        'Expert in Gynecological Aesthetics (Juan Carlos I University - Spain)',
        'Expert in Menopause (AEEM-SEGO)',
        'Master in Aesthetic Medicine (TECH)',
        'Master in Hormones, Nutrition and Wellness (AIU)',
        'Speaker V-Lift PRO INTIMATE',
      ],
      consultTitle: 'Consultations',
      consults: [
        'Personalized Bioidentical Hormonal Therapy Consultation',
        'Menopause',
        'Andropause',
        'Transgender',
        'Aesthetic, Regenerative and Functional Gynecology Consultation',
        'Genital Harmonization Surgery',
        'Postpartum Surgery (vaginoplasty, perineoplasty)',
        'Urinary incontinence',
      ],
      regenerativeTitle: 'Intimate Regenerative Treatments',
      regenerative: [
        { name: 'Genitourinary Syndrome of Menopause', desc: '' },
        { name: 'Vaginal dryness', desc: '' },
        { name: 'Genital atrophy', desc: '' },
        { name: 'Vaginal laxity', desc: '' },
        { name: 'Urinary incontinence', desc: '' },
        { name: 'Vulvar Lichen Sclerosus', desc: '' },
        { name: 'Dyspareunia, vulvodynia, pelvic floor muscle hypertonia', desc: '' },
        { name: 'Orgasmic sexual dysfunction', desc: '' },
        { name: 'Treatments associated with genital reconstructive surgery (wounds, dehiscence, fistulas)', desc: '' },
        { name: 'Vulvovaginal treatments in Oncological patients', desc: '' },
        { name: 'Application of autologous and heterologous Growth Factors', desc: '' },
        { name: 'Hyaluronic Acid (Cellular Matrix)', desc: '' },
        { name: 'Botulinum Toxin', desc: '' },
        { name: 'Exosomes + Peptides + HA', desc: '' },
      ],
      surgeryTitle: 'Gynecological Aesthetic Surgery',
      surgery: [
        'Labiaplasty',
        'Perineoplasty',
        'Vaginoplasty',
        'Hymenoplasty',
        'Clitoropexy',
        'Hoodoplasty',
        'Advanced Genital Harmonization (Surgery, Cellular Matrix, Exosomes)',
      ],
      ctaTitle: 'Interested in our services?',
      ctaDesc: 'Request your personalized consultation with Dr. Susana Varela Elias',
    },
    fr: {
      title: 'Gynéco-Esthétique et Santé Intime',
      subtitle: 'Services spécialisés en collaboration avec <strong>Dr. Susana Varela Elias</strong>',
      requestConsult: 'DEMANDER UNE CONSULTATION',
      doctorName: 'Dr. Susana Varela Elias',
      credentials: [
        'Médecin Chirurgien (Université de Córdoba - Argentine)',
        'Spécialiste en Gynécologie (Université de Córdoba - Argentine)',
        'Médecin Chirurgien (Ministère de l\'Éducation et des Sciences - Espagne)',
        'Spécialiste en Obstétrique et Gynécologie (Ministère de l\'Éducation et des Sciences - Espagne)',
        'Experte en Gynéco-Esthétique (Université Juan Carlos I - Espagne)',
        'Experte en Ménopause (AEEM-SEGO)',
        'Master en Médecine Esthétique (TECH)',
        'Master en Hormones, Nutrition et Wellness (AIU)',
        'Speaker V-Lift PRO INTIMATE',
      ],
      consultTitle: 'Consultations',
      consults: [
        'Consultation de Thérapie Hormonale Bio-identique Personnalisée',
        'Ménopause',
        'Andropause',
        'Transgenre',
        'Consultation de Gynécologie Esthétique, Régénérative et Fonctionnelle',
        'Chirurgie d\'Harmonisation Génitale',
        'Chirurgie post-partum (vaginoplastie, périnéoplastie)',
        'Incontinence urinaire',
      ],
      regenerativeTitle: 'Traitements Régénératifs Intimes',
      regenerative: [
        { name: 'Syndrome génito-urinaire de la Ménopause', desc: '' },
        { name: 'Sécheresse vaginale', desc: '' },
        { name: 'Atrophie génitale', desc: '' },
        { name: 'Laxité Vaginale', desc: '' },
        { name: 'Incontinence urinaire', desc: '' },
        { name: 'Lichen Scléreux Vulvaire', desc: '' },
        { name: 'Dyspareunie, vulvodynie, hypertonie des muscles du plancher pelvien', desc: '' },
        { name: 'Dysfonction sexuelle orgasmique', desc: '' },
        { name: 'Traitements associés à la chirurgie reconstructive génitale (plaies, déhiscences, fistules)', desc: '' },
        { name: 'Traitements vulvo-vaginaux chez les patientes Oncologiques', desc: '' },
        { name: 'Application de Facteurs de Croissance autologues, hétérologues', desc: '' },
        { name: 'Acide Hyaluronique (Cellular Matrix)', desc: '' },
        { name: 'Toxine Botulique', desc: '' },
        { name: 'Exosomes + Peptides + HA', desc: '' },
      ],
      surgeryTitle: 'Chirurgie Gynéco-Esthétique',
      surgery: [
        'Labioplastie',
        'Périnéoplastie',
        'Vaginoplastie',
        'Hyménoplastie',
        'Clitoropexie',
        'Hoodoplastie',
        'Harmonisation Génitale Avancée (Chirurgie, Cellular Matrix, Exosomes)',
      ],
      ctaTitle: 'Intéressée par nos services?',
      ctaDesc: 'Demandez votre consultation personnalisée avec le Dr. Susana Varela Elias',
    },
    pt: {
      title: 'Gineco Estética e Saúde Íntima',
      subtitle: 'Serviços especializados em colaboração com a <strong>Dra. Susana Varela Elias</strong>',
      requestConsult: 'SOLICITAR CONSULTA',
      doctorName: 'Dra. Susana Varela Elias',
      credentials: [
        'Médica Cirurgiã (Universidade de Córdoba - Argentina)',
        'Especialista em Ginecologia (Universidade de Córdoba - Argentina)',
        'Médica Cirurgiã (Ministério da Educação e Ciência - Espanha)',
        'Especialista em Obstetrícia e Ginecologia (Ministério da Educação e Ciência - Espanha)',
        'Especialista em Gineco-Estética (Universidade Juan Carlos I - Espanha)',
        'Especialista em Menopausa (AEEM-SEGO)',
        'Mestrado em Medicina Estética (TECH)',
        'Mestrado em Hormônios, Nutrição e Wellness (AIU)',
        'Speaker V-Lift PRO INTIMATE',
      ],
      consultTitle: 'Consultas',
      consults: [
        'Consulta de Terapia Hormonal Bioidêntica Personalizada',
        'Menopausa',
        'Andropausa',
        'Transgênero',
        'Consulta de Ginecologia Estética, Regenerativa e Funcional',
        'Cirurgia de Harmonização Genital',
        'Cirurgia pós-parto (vaginoplastia, perineoplastia)',
        'Incontinência urinária',
      ],
      regenerativeTitle: 'Tratamentos Regenerativos Íntimos',
      regenerative: [
        { name: 'Síndrome geniturinária da Menopausa', desc: '' },
        { name: 'Secura vaginal', desc: '' },
        { name: 'Atrofia genital', desc: '' },
        { name: 'Laxidez Vaginal', desc: '' },
        { name: 'Incontinência urinária', desc: '' },
        { name: 'Líquen Escleroso Vulvar', desc: '' },
        { name: 'Dispareunia, vulvodinia, hipertonia dos músculos do assoalho pélvico', desc: '' },
        { name: 'Disfunção sexual orgásmica', desc: '' },
        { name: 'Tratamentos associados a cirurgia reconstrutiva genital (feridas, deiscências, fístulas)', desc: '' },
        { name: 'Tratamentos vulvovaginais em pacientes Oncológicas', desc: '' },
        { name: 'Aplicação de Fatores de Crescimento autólogos, heterólogos', desc: '' },
        { name: 'Ácido Hialurônico (Cellular Matrix)', desc: '' },
        { name: 'Toxina Botulínica', desc: '' },
        { name: 'Exosomas + Peptídeos + HA', desc: '' },
      ],
      surgeryTitle: 'Cirurgia Gineco-Estética',
      surgery: [
        'Labioplastia',
        'Perineoplastia',
        'Vaginoplastia',
        'Himenoplastia',
        'Clitoropexia',
        'Hoodoplastia',
        'Harmonização Genital Avançada (Cirurgia, Cellular Matrix, Exosomas)',
      ],
      ctaTitle: 'Interessada em nossos serviços?',
      ctaDesc: 'Solicite sua consulta personalizada com a Dra. Susana Varela Elias',
    },
  },

  // ClinicaAlameda page translations
  clinicaAlameda: {
    es: {
      clinicName: 'Clínica Estética Alameda',
      centerMarbella: 'Centro de Marbella',
      address: 'Dirección',
      phone: 'Teléfono',
      schedule: 'Horario',
      scheduleWeekdays: 'Lunes a Viernes: 10:00 - 14:00 y 16:00 - 20:00',
      scheduleSaturday: 'Sábados: Con cita previa',
      howToGet: 'Cómo llegar',
      call: 'Llamar',
      locationTitle: 'Ubicación',
      locationSubtitle: 'Una ubicación privilegiada',
      locationDesc: 'La Clínica Estética Alameda es una de las clínicas favoritas del Dr. Ángel Norro, situada en el corazón de Marbella.',
      avenueName: 'Avenida del Mar',
      avenueDesc: 'Conocida como la <strong>"Avenida de las Estatuas"</strong>, alberga una exposición permanente de <strong>esculturas en bronce de Salvador Dalí</strong>. Es lugar habitual de celebraciones, encuentros y mercadillos.',
      historicCenter: 'Centro Histórico',
      historicCenterDesc: 'A pocos metros del <strong>Casco Antiguo de Marbella</strong>, con sus calles empedradas, la emblemática <strong>Plaza de los Naranjos</strong> y una amplia oferta gastronómica y cultural.',
      parking: 'Aparcamiento',
      parkingDesc: 'La clínica dispone de <strong>Parking Indigo a 30 metros</strong> del edificio.',
      parkingName: 'Parking Indigo Alameda',
      parkingLocation: 'Plaza de la Victoria • 24 horas',
      parkingRate: 'Tarifa aproximada',
      parkingPrice: '1,80 € / hora • Máx. 15 € / día',
      hotelsTitle: 'Alojamiento',
      hotelsSubtitle: 'Hoteles recomendados',
      hotelsDesc: 'Si viaja desde fuera de Marbella, estos hoteles se encuentran a poca distancia de la clínica y ofrecen una excelente relación calidad-precio.',
      ctaTitle: 'Contacto',
      ctaSubtitle: 'Solicite su cita',
      ctaDesc: 'Contacte con nosotros para programar su consulta en la Clínica Estética Alameda',
    },
    en: {
      clinicName: 'Alameda Aesthetic Clinic',
      centerMarbella: 'Marbella Center',
      address: 'Address',
      phone: 'Phone',
      schedule: 'Schedule',
      scheduleWeekdays: 'Monday to Friday: 10:00 AM - 2:00 PM and 4:00 PM - 8:00 PM',
      scheduleSaturday: 'Saturdays: By appointment',
      howToGet: 'How to get there',
      call: 'Call',
      locationTitle: 'Location',
      locationSubtitle: 'A privileged location',
      locationDesc: 'The Alameda Aesthetic Clinic is one of Dr. Ángel Norro\'s favorite clinics, located in the heart of Marbella.',
      avenueName: 'Avenida del Mar',
      avenueDesc: 'Known as the <strong>"Avenue of Statues"</strong>, it houses a permanent exhibition of <strong>Salvador Dalí bronze sculptures</strong>. It is a regular place for celebrations, gatherings and markets.',
      historicCenter: 'Historic Center',
      historicCenterDesc: 'A few meters from the <strong>Old Town of Marbella</strong>, with its cobblestone streets, the iconic <strong>Plaza de los Naranjos</strong> and a wide gastronomic and cultural offer.',
      parking: 'Parking',
      parkingDesc: 'The clinic has <strong>Indigo Parking 30 meters</strong> from the building.',
      parkingName: 'Parking Indigo Alameda',
      parkingLocation: 'Plaza de la Victoria • 24 hours',
      parkingRate: 'Approximate rate',
      parkingPrice: '€1.80/hour • Max. €15/day',
      hotelsTitle: 'Accommodation',
      hotelsSubtitle: 'Recommended hotels',
      hotelsDesc: 'If you are traveling from outside Marbella, these hotels are close to the clinic and offer excellent value for money.',
      ctaTitle: 'Contact',
      ctaSubtitle: 'Request your appointment',
      ctaDesc: 'Contact us to schedule your consultation at the Alameda Aesthetic Clinic',
    },
    fr: {
      clinicName: 'Clinique Esthétique Alameda',
      centerMarbella: 'Centre de Marbella',
      address: 'Adresse',
      phone: 'Téléphone',
      schedule: 'Horaires',
      scheduleWeekdays: 'Lundi au Vendredi: 10h00 - 14h00 et 16h00 - 20h00',
      scheduleSaturday: 'Samedis: Sur rendez-vous',
      howToGet: 'Comment y arriver',
      call: 'Appeler',
      locationTitle: 'Emplacement',
      locationSubtitle: 'Un emplacement privilégié',
      locationDesc: 'La Clinique Esthétique Alameda est l\'une des cliniques préférées du Dr. Ángel Norro, située au cœur de Marbella.',
      avenueName: 'Avenida del Mar',
      avenueDesc: 'Connue comme <strong>"l\'Avenue des Statues"</strong>, elle abrite une exposition permanente de <strong>sculptures en bronze de Salvador Dalí</strong>. C\'est un lieu habituel de célébrations, rencontres et marchés.',
      historicCenter: 'Centre Historique',
      historicCenterDesc: 'À quelques mètres de la <strong>Vieille Ville de Marbella</strong>, avec ses rues pavées, l\'emblématique <strong>Plaza de los Naranjos</strong> et une large offre gastronomique et culturelle.',
      parking: 'Parking',
      parkingDesc: 'La clinique dispose du <strong>Parking Indigo à 30 mètres</strong> du bâtiment.',
      parkingName: 'Parking Indigo Alameda',
      parkingLocation: 'Plaza de la Victoria • 24 heures',
      parkingRate: 'Tarif approximatif',
      parkingPrice: '1,80 € / heure • Max. 15 € / jour',
      hotelsTitle: 'Hébergement',
      hotelsSubtitle: 'Hôtels recommandés',
      hotelsDesc: 'Si vous voyagez depuis l\'extérieur de Marbella, ces hôtels sont proches de la clinique et offrent un excellent rapport qualité-prix.',
      ctaTitle: 'Contact',
      ctaSubtitle: 'Demandez votre rendez-vous',
      ctaDesc: 'Contactez-nous pour programmer votre consultation à la Clinique Esthétique Alameda',
    },
    pt: {
      clinicName: 'Clínica Estética Alameda',
      centerMarbella: 'Centro de Marbella',
      address: 'Endereço',
      phone: 'Telefone',
      schedule: 'Horário',
      scheduleWeekdays: 'Segunda a Sexta: 10:00 - 14:00 e 16:00 - 20:00',
      scheduleSaturday: 'Sábados: Com agendamento',
      howToGet: 'Como chegar',
      call: 'Ligar',
      locationTitle: 'Localização',
      locationSubtitle: 'Uma localização privilegiada',
      locationDesc: 'A Clínica Estética Alameda é uma das clínicas favoritas do Dr. Ángel Norro, situada no coração de Marbella.',
      avenueName: 'Avenida del Mar',
      avenueDesc: 'Conhecida como a <strong>"Avenida das Estátuas"</strong>, abriga uma exposição permanente de <strong>esculturas em bronze de Salvador Dalí</strong>. É local habitual de celebrações, encontros e mercados.',
      historicCenter: 'Centro Histórico',
      historicCenterDesc: 'A poucos metros do <strong>Centro Antigo de Marbella</strong>, com suas ruas de paralelepípedos, a emblemática <strong>Plaza de los Naranjos</strong> e uma ampla oferta gastronômica e cultural.',
      parking: 'Estacionamento',
      parkingDesc: 'A clínica dispõe de <strong>Parking Indigo a 30 metros</strong> do edifício.',
      parkingName: 'Parking Indigo Alameda',
      parkingLocation: 'Plaza de la Victoria • 24 horas',
      parkingRate: 'Tarifa aproximada',
      parkingPrice: '€1,80 / hora • Máx. €15 / dia',
      hotelsTitle: 'Hospedagem',
      hotelsSubtitle: 'Hotéis recomendados',
      hotelsDesc: 'Se você está viajando de fora de Marbella, estes hotéis estão perto da clínica e oferecem excelente custo-benefício.',
      ctaTitle: 'Contato',
      ctaSubtitle: 'Solicite sua consulta',
      ctaDesc: 'Entre em contato para agendar sua consulta na Clínica Estética Alameda',
    },
  },

  // DondeAtendemos page translations
  dondeAtendemos: {
    es: {
      eyebrow: 'Ubicaciones',
      title: 'Donde le atendemos',
      subtitle: 'El Dr. Ángel Norro trabaja en diversos hospitales y clínicas de Marbella, ofreciendo atención personalizada en cada centro.',
      mainClinic: 'Clínica Principal',
      viewMore: 'Ver más información',
      hospitals: 'Hospitales',
      partnerClinics: 'Clínicas y Centros Colaboradores',
      note: '<strong>Nota:</strong> El Dr. Ángel Norro atiende en diferentes centros según el tipo de intervención y las necesidades del paciente. Para saber dónde será atendido, consulte en su cita previa.',
      ctaTitle: 'Contacto',
      ctaSubtitle: '¿Necesita una consulta?',
      ctaDesc: 'Contacte con nosotros y le indicaremos el centro más adecuado para su caso',
      viewAlameda: 'Ver Clínica Alameda',
    },
    en: {
      eyebrow: 'Locations',
      title: 'Where we see you',
      subtitle: 'Dr. Ángel Norro works in various hospitals and clinics in Marbella, offering personalized care at each center.',
      mainClinic: 'Main Clinic',
      viewMore: 'View more information',
      hospitals: 'Hospitals',
      partnerClinics: 'Partner Clinics',
      note: '<strong>Note:</strong> Dr. Ángel Norro sees patients at different centers depending on the type of intervention and patient needs. To find out where you will be seen, please ask at your appointment.',
      ctaTitle: 'Contact',
      ctaSubtitle: 'Need a consultation?',
      ctaDesc: 'Contact us and we will tell you the most suitable center for your case',
      viewAlameda: 'View Alameda Clinic',
    },
    fr: {
      eyebrow: 'Emplacements',
      title: 'Où nous vous recevons',
      subtitle: 'Le Dr. Ángel Norro travaille dans divers hôpitaux et cliniques de Marbella, offrant des soins personnalisés dans chaque centre.',
      mainClinic: 'Clinique Principale',
      viewMore: 'Voir plus d\'informations',
      hospitals: 'Hôpitaux',
      partnerClinics: 'Cliniques Partenaires',
      note: '<strong>Note:</strong> Le Dr. Ángel Norro reçoit dans différents centres selon le type d\'intervention et les besoins du patient. Pour savoir où vous serez reçu, veuillez demander lors de votre rendez-vous.',
      ctaTitle: 'Contact',
      ctaSubtitle: 'Besoin d\'une consultation?',
      ctaDesc: 'Contactez-nous et nous vous indiquerons le centre le plus adapté à votre cas',
      viewAlameda: 'Voir Clinique Alameda',
    },
    pt: {
      eyebrow: 'Localizações',
      title: 'Onde atendemos',
      subtitle: 'O Dr. Ángel Norro trabalha em diversos hospitais e clínicas de Marbella, oferecendo atendimento personalizado em cada centro.',
      mainClinic: 'Clínica Principal',
      viewMore: 'Ver mais informações',
      hospitals: 'Hospitais',
      partnerClinics: 'Clínicas Parceiras',
      note: '<strong>Nota:</strong> O Dr. Ángel Norro atende em diferentes centros conforme o tipo de intervenção e necessidades do paciente. Para saber onde será atendido, consulte em sua consulta prévia.',
      ctaTitle: 'Contato',
      ctaSubtitle: 'Precisa de uma consulta?',
      ctaDesc: 'Entre em contato e indicaremos o centro mais adequado para o seu caso',
      viewAlameda: 'Ver Clínica Alameda',
    },
  },

  // OjerasBolsas page translations
  ojerasBolsas: {
    es: {
      category: 'Cirugía Facial',
      title: 'Ojeras y Bolsas',
      heroDesc: 'Tratamiento integral del tercio periocular. Blefaroplastia inferior para eliminar bolsas de grasa y exceso de piel. Opciones quirúrgicas y no quirúrgicas según el diagnóstico.',
      requestAssessment: 'Solicitar Valoración',
      callNow: 'Llamar Ahora',
      optionsTitle: 'Opciones de Tratamiento',
      optionsSubtitle: 'Soluciones personalizadas',
      options: [
        { title: 'Blefaroplastia Inferior', desc: 'Cirugía para eliminar bolsas de grasa y exceso de piel del párpado inferior.' },
        { title: 'Relleno con Ácido Hialurónico', desc: 'Tratamiento no quirúrgico para ojeras hundidas y surco nasoyugal.' },
        { title: 'Tratamiento Combinado', desc: 'Combinación de técnicas quirúrgicas y no quirúrgicas para resultado óptimo.' },
      ],
      benefitsTitle: 'Beneficios',
      benefitsSubtitle: 'Resultados esperados',
      benefits: ['Mirada más descansada y juvenil', 'Eliminación de bolsas de grasa', 'Reducción de ojeras oscuras', 'Resultados duraderos', 'Recuperación rápida'],
      ctaTitle: '¿Desea más información?',
      ctaDesc: 'Solicite una consulta de valoración personalizada. Sin compromiso.',
      contact: 'Contactar',
    },
    en: {
      category: 'Facial Surgery',
      title: 'Dark Circles and Bags',
      heroDesc: 'Comprehensive treatment of the periocular area. Lower blepharoplasty to remove fat bags and excess skin. Surgical and non-surgical options based on diagnosis.',
      requestAssessment: 'Request Assessment',
      callNow: 'Call Now',
      optionsTitle: 'Treatment Options',
      optionsSubtitle: 'Personalized solutions',
      options: [
        { title: 'Lower Blepharoplasty', desc: 'Surgery to remove fat bags and excess skin from the lower eyelid.' },
        { title: 'Hyaluronic Acid Filler', desc: 'Non-surgical treatment for sunken dark circles and tear trough.' },
        { title: 'Combined Treatment', desc: 'Combination of surgical and non-surgical techniques for optimal results.' },
      ],
      benefitsTitle: 'Benefits',
      benefitsSubtitle: 'Expected results',
      benefits: ['More rested and youthful look', 'Elimination of fat bags', 'Reduction of dark circles', 'Long-lasting results', 'Quick recovery'],
      ctaTitle: 'Want more information?',
      ctaDesc: 'Request a personalized assessment consultation. No obligation.',
      contact: 'Contact',
    },
    fr: {
      category: 'Chirurgie Faciale',
      title: 'Cernes et Poches',
      heroDesc: 'Traitement complet de la région périoculaire. Blépharoplastie inférieure pour éliminer les poches de graisse et l\'excès de peau. Options chirurgicales et non chirurgicales selon le diagnostic.',
      requestAssessment: 'Demander une Évaluation',
      callNow: 'Appeler Maintenant',
      optionsTitle: 'Options de Traitement',
      optionsSubtitle: 'Solutions personnalisées',
      options: [
        { title: 'Blépharoplastie Inférieure', desc: 'Chirurgie pour éliminer les poches de graisse et l\'excès de peau de la paupière inférieure.' },
        { title: 'Comblement à l\'Acide Hyaluronique', desc: 'Traitement non chirurgical pour les cernes creux et le sillon lacrymal.' },
        { title: 'Traitement Combiné', desc: 'Combinaison de techniques chirurgicales et non chirurgicales pour un résultat optimal.' },
      ],
      benefitsTitle: 'Avantages',
      benefitsSubtitle: 'Résultats attendus',
      benefits: ['Regard plus reposé et jeune', 'Élimination des poches de graisse', 'Réduction des cernes sombres', 'Résultats durables', 'Récupération rapide'],
      ctaTitle: 'Vous souhaitez plus d\'informations?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée. Sans engagement.',
      contact: 'Contacter',
    },
    pt: {
      category: 'Cirurgia Facial',
      title: 'Olheiras e Bolsas',
      heroDesc: 'Tratamento integral da região periocular. Blefaroplastia inferior para eliminar bolsas de gordura e excesso de pele. Opções cirúrgicas e não cirúrgicas conforme o diagnóstico.',
      requestAssessment: 'Solicitar Avaliação',
      callNow: 'Ligar Agora',
      optionsTitle: 'Opções de Tratamento',
      optionsSubtitle: 'Soluções personalizadas',
      options: [
        { title: 'Blefaroplastia Inferior', desc: 'Cirurgia para eliminar bolsas de gordura e excesso de pele da pálpebra inferior.' },
        { title: 'Preenchimento com Ácido Hialurônico', desc: 'Tratamento não cirúrgico para olheiras fundas e sulco nasojugal.' },
        { title: 'Tratamento Combinado', desc: 'Combinação de técnicas cirúrgicas e não cirúrgicas para resultado ótimo.' },
      ],
      benefitsTitle: 'Benefícios',
      benefitsSubtitle: 'Resultados esperados',
      benefits: ['Olhar mais descansado e jovem', 'Eliminação de bolsas de gordura', 'Redução de olheiras escuras', 'Resultados duradouros', 'Recuperação rápida'],
      ctaTitle: 'Deseja mais informações?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada. Sem compromisso.',
      contact: 'Contatar',
    },
  },

  // Acreditaciones page translations
  acreditaciones: {
    es: {
      title: 'Acreditaciones y Membresías',
      subtitle: 'Formación, certificaciones y asociaciones profesionales del Dr. Ángel Norro',
      education: 'Formación Académica',
      societies: 'Sociedades Científicas',
      certifications: 'Certificaciones',
    },
    en: {
      title: 'Accreditations and Memberships',
      subtitle: 'Education, certifications and professional associations of Dr. Ángel Norro',
      education: 'Academic Education',
      societies: 'Scientific Societies',
      certifications: 'Certifications',
    },
    fr: {
      title: 'Accréditations et Adhésions',
      subtitle: 'Formation, certifications et associations professionnelles du Dr. Ángel Norro',
      education: 'Formation Académique',
      societies: 'Sociétés Scientifiques',
      certifications: 'Certifications',
    },
    pt: {
      title: 'Acreditações e Afiliações',
      subtitle: 'Formação, certificações e associações profissionais do Dr. Ángel Norro',
      education: 'Formação Acadêmica',
      societies: 'Sociedades Científicas',
      certifications: 'Certificações',
    },
  },

  // MapaSitio page translations
  mapaSitio: {
    es: {
      title: 'Mapa del Sitio',
      sections: {
        main: 'Páginas Principales',
        facial: 'Cirugía Facial',
        body: 'Cirugía Corporal',
        breast: 'Cirugía de Mamas',
        reconstructive: 'Cirugía Reparadora',
        medicine: 'Medicina Estética',
        other: 'Otras Páginas',
      },
    },
    en: {
      title: 'Site Map',
      sections: {
        main: 'Main Pages',
        facial: 'Facial Surgery',
        body: 'Body Surgery',
        breast: 'Breast Surgery',
        reconstructive: 'Reconstructive Surgery',
        medicine: 'Aesthetic Medicine',
        other: 'Other Pages',
      },
    },
    fr: {
      title: 'Plan du Site',
      sections: {
        main: 'Pages Principales',
        facial: 'Chirurgie Faciale',
        body: 'Chirurgie Corporelle',
        breast: 'Chirurgie Mammaire',
        reconstructive: 'Chirurgie Réparatrice',
        medicine: 'Médecine Esthétique',
        other: 'Autres Pages',
      },
    },
    pt: {
      title: 'Mapa do Site',
      sections: {
        main: 'Páginas Principais',
        facial: 'Cirurgia Facial',
        body: 'Cirurgia Corporal',
        breast: 'Cirurgia de Mamas',
        reconstructive: 'Cirurgia Reparadora',
        medicine: 'Medicina Estética',
        other: 'Outras Páginas',
      },
    },
  },

  // GuiasRecursos page translations
  guiasRecursos: {
    es: {
      heroEyebrow: 'Información para Pacientes',
      title: 'Guías y Recursos',
      heroDesc: 'Documentación detallada sobre cuidados pre y postoperatorios, protocolos de recuperación y recomendaciones para optimizar los resultados de su tratamiento.',
      blepharoplasty: 'Blefaroplastia',
      careGuide: 'Guía de Cuidados',
      preAndPost: 'Pre y Postoperatorio',
      careIntro: 'Instrucciones completas para antes y después de la cirugía de párpados.',
      downloadGuide: 'Descargar Guía Completa (PDF)',
      // Accordion 1: Before with sedation
      acc1Title: 'Antes del procedimiento de blefaroplastia con anestesia local y sedación',
      fastingTitle: 'Ayuno obligatorio',
      fastingDesc: 'No coma ni beba nada durante las 8–10 horas previas a la intervención.',
      fastingWater: 'Puede tomar medio vaso de agua o infusión clara (sin leche, azúcar ni espesantes) al menos 4 horas antes.',
      mustAccompanied: 'Deberá venir acompañado y no podrá conducir después de la cirugía.',
      avoid24h: 'Durante las 24 horas posteriores, evite manejar maquinaria, tomar decisiones importantes o firmar documentos.',
      someoneNearby: 'Asegúrese de que alguien permanezca con usted y pueda ser localizado por teléfono.',
      personalPrep: 'Preparación personal',
      comfyClothes: 'Use ropa cómoda con botones o cremallera (evite prendas que se pasen por la cabeza).',
      cleanFace: 'Acuda con la cara limpia, sin maquillaje, cremas ni joyas.',
      medications: 'Medicamentos',
      avoidNSAIDs: 'Evite antiinflamatorios (AINE) como ibuprofeno, aspirina o naproxeno durante los 10 días previos.',
      paracetamolOk: 'Si necesita aliviar molestias, puede tomar paracetamol de forma segura.',
      itemsAtHome: 'Artículos necesarios en casa',
      items: ['Lágrimas artificiales sin conservantes', 'Compresas o gafas de gel frío', 'Suero fisiológico estéril', 'Infusión de manzanilla', 'Gasas estériles', 'Paracetamol 500 mg', 'Povidona yodada (solución)', 'Cicapost® ISDIN o similar'],
      // Accordion 2: Before without sedation
      acc2Title: 'Antes del procedimiento de blefaroplastia con anestesia local sin sedación',
      noFastingTitle: 'No requiere ayuno',
      noFastingDesc: 'Al realizarse con anestesia local únicamente, puede desayunar o comer con normalidad.',
      arriveOnTime: 'Acuda puntualmente a la clínica teniendo en cuenta posibles retrasos.',
      informDoctor: 'Informe al médico sobre cualquier medicación habitual.',
      // Accordion 3: After procedure
      acc3Title: 'Después del procedimiento de blefaroplastia',
      firstDays: 'Primeros días en casa',
      coldCompress: 'Aplique compresas o gafas de gel frío 10–15 min cada 2 horas los primeros 3 días.',
      sleepElevated: 'Duerma con la cabeza ligeramente elevada durante 3–4 noches.',
      useTears: 'Use lágrimas artificiales sin conservantes varias veces al día.',
      cleanGently: 'Limpie suavemente con gasas empapadas en suero fisiológico o manzanilla fría.',
      slightBleeding: 'Un leve sangrado el primer día es normal.',
      medication: 'Medicación',
      paracetamol8h: 'Paracetamol 500 mg cada 8 horas si presenta molestias.',
      antibioticsIfPrescribed: 'Tome antibióticos solo si se le han prescrito.',
      contactImmediately: 'Contacte de inmediato si nota:',
      urgentSymptoms: ['Dolor persistente o intenso', 'Sangrado que no se detiene', 'Visión borrosa persistente'],
      followUp: 'Seguimiento',
      dailyPhoto: 'Envíe foto diaria por WhatsApp los primeros días.',
      stitchesRemoval: 'Los puntos se retiran al noveno día aproximadamente.',
      avoidOneWeek: 'Evite durante al menos una semana:',
      avoidItems: ['Esfuerzos físicos o ejercicio', 'Inclinarse o dormir boca abajo', 'Polvo, humo o contaminación', 'Uso prolongado de pantallas'],
      scarCare: 'Cuidado de la cicatriz',
      scarCream: 'Tras retirar puntos, aplique Cicapost® ISDIN 1–2 veces al día durante 2 meses.',
      avoidSun: 'Evite la exposición directa al sol sobre la cicatriz.',
      // Accordion 4: Dry Eye
      acc4Title: 'Cuidados y Tratamiento del Ojo Seco',
      dryEyeIntro1: 'El ojo seco es muy frecuente a partir de cierta edad (50–60 años), se presenta en casi la mitad de la población y es más frecuente en mujeres.',
      dryEyeIntro2: 'Tras cirugía de blefaroplastia, puede exacerbarse por lo que además de los cuidados habituales puede incorporar estos específicos.',
      dryEyeSymptoms: 'Después de una blefaroplastia es frecuente notar sequedad ocular, escozor, sensación de arenilla, lagrimeo reflejo o visión borrosa intermitente. Estos síntomas suelen ser temporales y mejoran siguiendo correctamente estas indicaciones.',
      whyOccurs: '¿Por qué ocurre?',
      whyReasons: ['Mayor evaporación de la lágrima', 'Parpadeo incompleto temporal', 'Inflamación leve de la superficie ocular'],
      notSerious: 'No es grave, pero requiere tratamiento y cuidados adecuados.',
      recommendedTreatment: 'Tratamiento Recomendado',
      tears: 'Lágrimas artificiales (tratamiento principal)',
      tearsDesc: 'Utilizar lágrimas artificiales SIN conservantes.',
      tearsDuringDay: 'Durante el día: Aplicar 1 gota en cada ojo cada 2–3 horas, aunque no note molestias.',
      tearsOptions: 'Opciones recomendadas (elegir una):',
      tearsTip: 'Si la sequedad empeora con pantallas o ambientes secos, son preferibles las fórmulas con trehalosa o componente lipídico, como Thealoz Duo®.',
      nightGel: 'Gel o pomada oftálmica nocturna',
      nightGelDesc: 'Aplicar antes de acostarse:',
      nightGelNote: 'Tras la aplicación la visión puede quedar borrosa durante unos minutos (normal).',
      rednessTitle: 'Enrojecimiento o escozor intenso',
      rednessDesc: 'En algunos casos el médico puede prescribir colirio antiinflamatorio durante pocos días.',
      rednessWarning: 'No utilizar colirios con corticoides sin indicación médica.',
      complementary: 'Medidas Complementarias Importantes',
      complementaryItems: ['Parpadear con frecuencia', 'Evitar viento, aire acondicionado directo y humo', 'Limitar el uso prolongado de pantallas', 'Usar humidificador ambiental si es posible', 'Gafas de sol envolventes en exteriores'],
      avoidEyeDrops: 'Evitar colirios para el ojo rojo, no usar lentes de contacto y no frotarse los ojos.',
      expectedEvolution: 'Evolución Esperable',
      progressiveImprovement: 'Mejoría progresiva',
      resolution8weeks: 'Resolución habitual en 8 semanas',
      consultUrgent: 'Consulte de forma preferente si aparece:',
      urgentEyeSymptoms: ['Dolor ocular', 'Visión borrosa persistente', 'Fotofobia intensa', 'Secreción amarilla o verdosa', 'Sensación intensa de cuerpo extraño que no mejora'],
      dryEyeReminder: 'Recuerde: el ojo seco tras blefaroplastia es frecuente y reversible si se siguen correctamente estas indicaciones.',
      // Contact Card
      anyQuestion: '¿Tiene alguna duda?',
      atYourService: 'Estamos a su disposición.',
      // Disclaimer
      disclaimerNote: 'Nota:',
      disclaimerText: 'Estas instrucciones generales se confirmarán y adaptarán según cada caso particular.',
      // Coming Soon
      inDevelopment: 'En Desarrollo',
      upcomingGuides: 'Próximas Guías',
      comingSoon: 'Próximamente',
      upcomingList: ['Rinoplastia', 'Lifting Facial', 'Cirugía de Mamas'],
      // CTA
      needMoreInfo: '¿Necesita más información?',
      dontHesitate: 'No dude en contactarnos.',
      contact: 'Contactar',
    },
    en: {
      heroEyebrow: 'Patient Information',
      title: 'Guides and Resources',
      heroDesc: 'Detailed documentation on pre and postoperative care, recovery protocols and recommendations to optimize your treatment results.',
      blepharoplasty: 'Blepharoplasty',
      careGuide: 'Care Guide',
      preAndPost: 'Pre and Postoperative',
      careIntro: 'Complete instructions for before and after eyelid surgery.',
      downloadGuide: 'Download Complete Guide (PDF)',
      acc1Title: 'Before blepharoplasty with local anesthesia and sedation',
      fastingTitle: 'Mandatory fasting',
      fastingDesc: 'Do not eat or drink anything for 8–10 hours before the procedure.',
      fastingWater: 'You may have half a glass of water or clear infusion (without milk, sugar or thickeners) at least 4 hours before.',
      mustAccompanied: 'You must come accompanied and will not be able to drive after surgery.',
      avoid24h: 'For 24 hours afterwards, avoid operating machinery, making important decisions or signing documents.',
      someoneNearby: 'Make sure someone stays with you and can be reached by phone.',
      personalPrep: 'Personal preparation',
      comfyClothes: 'Wear comfortable clothing with buttons or zippers (avoid garments that go over the head).',
      cleanFace: 'Come with a clean face, without makeup, creams or jewelry.',
      medications: 'Medications',
      avoidNSAIDs: 'Avoid anti-inflammatories (NSAIDs) such as ibuprofen, aspirin or naproxen for 10 days before.',
      paracetamolOk: 'If you need pain relief, you can safely take paracetamol.',
      itemsAtHome: 'Items needed at home',
      items: ['Preservative-free artificial tears', 'Cold gel compresses or glasses', 'Sterile saline solution', 'Chamomile infusion', 'Sterile gauze', 'Paracetamol 500 mg', 'Povidone-iodine (solution)', 'Cicapost® ISDIN or similar'],
      acc2Title: 'Before blepharoplasty with local anesthesia without sedation',
      noFastingTitle: 'No fasting required',
      noFastingDesc: 'As it is performed with local anesthesia only, you can have breakfast or eat normally.',
      arriveOnTime: 'Arrive punctually at the clinic, allowing for possible delays.',
      informDoctor: 'Inform the doctor about any regular medication.',
      acc3Title: 'After the blepharoplasty procedure',
      firstDays: 'First days at home',
      coldCompress: 'Apply cold gel compresses or glasses 10–15 min every 2 hours for the first 3 days.',
      sleepElevated: 'Sleep with your head slightly elevated for 3–4 nights.',
      useTears: 'Use preservative-free artificial tears several times a day.',
      cleanGently: 'Clean gently with gauze soaked in saline solution or cold chamomile.',
      slightBleeding: 'Slight bleeding on the first day is normal.',
      medication: 'Medication',
      paracetamol8h: 'Paracetamol 500 mg every 8 hours if you experience discomfort.',
      antibioticsIfPrescribed: 'Take antibiotics only if prescribed.',
      contactImmediately: 'Contact immediately if you notice:',
      urgentSymptoms: ['Persistent or intense pain', 'Bleeding that does not stop', 'Persistent blurred vision'],
      followUp: 'Follow-up',
      dailyPhoto: 'Send a daily photo via WhatsApp for the first few days.',
      stitchesRemoval: 'Stitches are removed approximately on the ninth day.',
      avoidOneWeek: 'Avoid for at least one week:',
      avoidItems: ['Physical exertion or exercise', 'Bending over or sleeping face down', 'Dust, smoke or pollution', 'Prolonged screen use'],
      scarCare: 'Scar care',
      scarCream: 'After stitch removal, apply Cicapost® ISDIN 1–2 times daily for 2 months.',
      avoidSun: 'Avoid direct sun exposure on the scar.',
      acc4Title: 'Dry Eye Care and Treatment',
      dryEyeIntro1: 'Dry eye is very common from a certain age (50–60 years), affecting nearly half the population and is more frequent in women.',
      dryEyeIntro2: 'After blepharoplasty surgery, it may worsen, so in addition to usual care, these specific measures can be incorporated.',
      dryEyeSymptoms: 'After blepharoplasty, it is common to notice eye dryness, stinging, gritty sensation, reflex tearing or intermittent blurred vision. These symptoms are usually temporary and improve by correctly following these instructions.',
      whyOccurs: 'Why does it occur?',
      whyReasons: ['Greater tear evaporation', 'Temporary incomplete blinking', 'Mild inflammation of the eye surface'],
      notSerious: 'It is not serious, but requires proper treatment and care.',
      recommendedTreatment: 'Recommended Treatment',
      tears: 'Artificial tears (main treatment)',
      tearsDesc: 'Use preservative-free artificial tears.',
      tearsDuringDay: 'During the day: Apply 1 drop in each eye every 2–3 hours, even if you feel no discomfort.',
      tearsOptions: 'Recommended options (choose one):',
      tearsTip: 'If dryness worsens with screens or dry environments, formulas with trehalose or lipid component are preferable, such as Thealoz Duo®.',
      nightGel: 'Night ophthalmic gel or ointment',
      nightGelDesc: 'Apply before bedtime:',
      nightGelNote: 'After application, vision may be blurry for a few minutes (normal).',
      rednessTitle: 'Intense redness or stinging',
      rednessDesc: 'In some cases, the doctor may prescribe anti-inflammatory eye drops for a few days.',
      rednessWarning: 'Do not use corticosteroid eye drops without medical indication.',
      complementary: 'Important Complementary Measures',
      complementaryItems: ['Blink frequently', 'Avoid wind, direct air conditioning and smoke', 'Limit prolonged screen use', 'Use a room humidifier if possible', 'Wraparound sunglasses outdoors'],
      avoidEyeDrops: 'Avoid redness-relieving eye drops, do not use contact lenses and do not rub your eyes.',
      expectedEvolution: 'Expected Evolution',
      progressiveImprovement: 'Progressive improvement',
      resolution8weeks: 'Usually resolves within 8 weeks',
      consultUrgent: 'Consult promptly if you experience:',
      urgentEyeSymptoms: ['Eye pain', 'Persistent blurred vision', 'Intense photophobia', 'Yellow or green discharge', 'Intense foreign body sensation that does not improve'],
      dryEyeReminder: 'Remember: dry eye after blepharoplasty is common and reversible if these instructions are followed correctly.',
      anyQuestion: 'Do you have any questions?',
      atYourService: 'We are at your disposal.',
      disclaimerNote: 'Note:',
      disclaimerText: 'These general instructions will be confirmed and adapted according to each particular case.',
      inDevelopment: 'In Development',
      upcomingGuides: 'Upcoming Guides',
      comingSoon: 'Coming soon',
      upcomingList: ['Rhinoplasty', 'Facelift', 'Breast Surgery'],
      needMoreInfo: 'Need more information?',
      dontHesitate: 'Do not hesitate to contact us.',
      contact: 'Contact',
    },
    fr: {
      heroEyebrow: 'Information pour les Patients',
      title: 'Guides et Ressources',
      heroDesc: 'Documentation détaillée sur les soins pré et postopératoires, les protocoles de récupération et les recommandations pour optimiser les résultats de votre traitement.',
      blepharoplasty: 'Blépharoplastie',
      careGuide: 'Guide de Soins',
      preAndPost: 'Pré et Postopératoire',
      careIntro: 'Instructions complètes avant et après la chirurgie des paupières.',
      downloadGuide: 'Télécharger le Guide Complet (PDF)',
      acc1Title: 'Avant la blépharoplastie avec anesthésie locale et sédation',
      fastingTitle: 'Jeûne obligatoire',
      fastingDesc: 'Ne mangez ni ne buvez rien pendant les 8–10 heures précédant l\'intervention.',
      fastingWater: 'Vous pouvez prendre un demi-verre d\'eau ou une infusion claire (sans lait, sucre ni épaississants) au moins 4 heures avant.',
      mustAccompanied: 'Vous devez venir accompagné(e) et ne pourrez pas conduire après la chirurgie.',
      avoid24h: 'Pendant les 24 heures suivantes, évitez d\'utiliser des machines, de prendre des décisions importantes ou de signer des documents.',
      someoneNearby: 'Assurez-vous que quelqu\'un reste avec vous et puisse être joint par téléphone.',
      personalPrep: 'Préparation personnelle',
      comfyClothes: 'Portez des vêtements confortables avec boutons ou fermeture éclair (évitez les vêtements qui passent par la tête).',
      cleanFace: 'Venez avec le visage propre, sans maquillage, crèmes ni bijoux.',
      medications: 'Médicaments',
      avoidNSAIDs: 'Évitez les anti-inflammatoires (AINS) comme l\'ibuprofène, l\'aspirine ou le naproxène pendant les 10 jours précédents.',
      paracetamolOk: 'Si vous avez besoin de soulager des douleurs, vous pouvez prendre du paracétamol en toute sécurité.',
      itemsAtHome: 'Articles nécessaires à la maison',
      items: ['Larmes artificielles sans conservateurs', 'Compresses ou lunettes de gel froid', 'Sérum physiologique stérile', 'Infusion de camomille', 'Compresses stériles', 'Paracétamol 500 mg', 'Povidone iodée (solution)', 'Cicapost® ISDIN ou similaire'],
      acc2Title: 'Avant la blépharoplastie avec anesthésie locale sans sédation',
      noFastingTitle: 'Pas de jeûne requis',
      noFastingDesc: 'L\'intervention étant réalisée sous anesthésie locale uniquement, vous pouvez déjeuner ou manger normalement.',
      arriveOnTime: 'Arrivez ponctuellement à la clinique en tenant compte des retards possibles.',
      informDoctor: 'Informez le médecin de tout médicament habituel.',
      acc3Title: 'Après la procédure de blépharoplastie',
      firstDays: 'Premiers jours à la maison',
      coldCompress: 'Appliquez des compresses ou lunettes de gel froid 10–15 min toutes les 2 heures les 3 premiers jours.',
      sleepElevated: 'Dormez avec la tête légèrement surélevée pendant 3–4 nuits.',
      useTears: 'Utilisez des larmes artificielles sans conservateurs plusieurs fois par jour.',
      cleanGently: 'Nettoyez doucement avec des compresses imbibées de sérum physiologique ou de camomille froide.',
      slightBleeding: 'Un léger saignement le premier jour est normal.',
      medication: 'Médication',
      paracetamol8h: 'Paracétamol 500 mg toutes les 8 heures en cas de gêne.',
      antibioticsIfPrescribed: 'Prenez des antibiotiques uniquement s\'ils ont été prescrits.',
      contactImmediately: 'Contactez immédiatement si vous remarquez :',
      urgentSymptoms: ['Douleur persistante ou intense', 'Saignement qui ne s\'arrête pas', 'Vision floue persistante'],
      followUp: 'Suivi',
      dailyPhoto: 'Envoyez une photo quotidienne par WhatsApp les premiers jours.',
      stitchesRemoval: 'Les points sont retirés environ le neuvième jour.',
      avoidOneWeek: 'Évitez pendant au moins une semaine :',
      avoidItems: ['Efforts physiques ou exercice', 'Se pencher ou dormir face contre terre', 'Poussière, fumée ou pollution', 'Utilisation prolongée d\'écrans'],
      scarCare: 'Soin de la cicatrice',
      scarCream: 'Après le retrait des points, appliquez Cicapost® ISDIN 1–2 fois par jour pendant 2 mois.',
      avoidSun: 'Évitez l\'exposition directe au soleil sur la cicatrice.',
      acc4Title: 'Soins et Traitement de l\'Œil Sec',
      dryEyeIntro1: 'L\'œil sec est très fréquent à partir d\'un certain âge (50–60 ans), touchant près de la moitié de la population et plus fréquent chez les femmes.',
      dryEyeIntro2: 'Après une chirurgie de blépharoplastie, il peut s\'aggraver, donc en plus des soins habituels, ces mesures spécifiques peuvent être incorporées.',
      dryEyeSymptoms: 'Après une blépharoplastie, il est fréquent de noter une sécheresse oculaire, des picotements, une sensation de sable, un larmoiement réflexe ou une vision floue intermittente. Ces symptômes sont généralement temporaires et s\'améliorent en suivant correctement ces indications.',
      whyOccurs: 'Pourquoi cela se produit-il ?',
      whyReasons: ['Évaporation accrue des larmes', 'Clignement incomplet temporaire', 'Inflammation légère de la surface oculaire'],
      notSerious: 'Ce n\'est pas grave, mais nécessite un traitement et des soins appropriés.',
      recommendedTreatment: 'Traitement Recommandé',
      tears: 'Larmes artificielles (traitement principal)',
      tearsDesc: 'Utiliser des larmes artificielles SANS conservateurs.',
      tearsDuringDay: 'Pendant la journée : Appliquer 1 goutte dans chaque œil toutes les 2–3 heures, même sans gêne.',
      tearsOptions: 'Options recommandées (en choisir une) :',
      tearsTip: 'Si la sécheresse s\'aggrave avec les écrans ou les environnements secs, les formules avec tréhalose ou composant lipidique sont préférables, comme Thealoz Duo®.',
      nightGel: 'Gel ou pommade ophtalmique nocturne',
      nightGelDesc: 'Appliquer avant le coucher :',
      nightGelNote: 'Après l\'application, la vision peut être floue pendant quelques minutes (normal).',
      rednessTitle: 'Rougeur ou picotement intense',
      rednessDesc: 'Dans certains cas, le médecin peut prescrire un collyre anti-inflammatoire pendant quelques jours.',
      rednessWarning: 'Ne pas utiliser de collyres à base de corticostéroïdes sans indication médicale.',
      complementary: 'Mesures Complémentaires Importantes',
      complementaryItems: ['Cligner fréquemment des yeux', 'Éviter le vent, la climatisation directe et la fumée', 'Limiter l\'utilisation prolongée d\'écrans', 'Utiliser un humidificateur d\'air si possible', 'Lunettes de soleil enveloppantes en extérieur'],
      avoidEyeDrops: 'Éviter les collyres pour les yeux rouges, ne pas utiliser de lentilles de contact et ne pas se frotter les yeux.',
      expectedEvolution: 'Évolution Attendue',
      progressiveImprovement: 'Amélioration progressive',
      resolution8weeks: 'Résolution habituelle en 8 semaines',
      consultUrgent: 'Consultez en priorité si apparaît :',
      urgentEyeSymptoms: ['Douleur oculaire', 'Vision floue persistante', 'Photophobie intense', 'Sécrétion jaune ou verdâtre', 'Sensation intense de corps étranger qui ne s\'améliore pas'],
      dryEyeReminder: 'N\'oubliez pas : l\'œil sec après blépharoplastie est fréquent et réversible si ces indications sont correctement suivies.',
      anyQuestion: 'Avez-vous des questions ?',
      atYourService: 'Nous sommes à votre disposition.',
      disclaimerNote: 'Note :',
      disclaimerText: 'Ces instructions générales seront confirmées et adaptées selon chaque cas particulier.',
      inDevelopment: 'En Développement',
      upcomingGuides: 'Prochains Guides',
      comingSoon: 'Prochainement',
      upcomingList: ['Rhinoplastie', 'Lifting Facial', 'Chirurgie Mammaire'],
      needMoreInfo: 'Besoin de plus d\'informations ?',
      dontHesitate: 'N\'hésitez pas à nous contacter.',
      contact: 'Contacter',
    },
    pt: {
      heroEyebrow: 'Informação para Pacientes',
      title: 'Guias e Recursos',
      heroDesc: 'Documentação detalhada sobre cuidados pré e pós-operatórios, protocolos de recuperação e recomendações para otimizar os resultados do seu tratamento.',
      blepharoplasty: 'Blefaroplastia',
      careGuide: 'Guia de Cuidados',
      preAndPost: 'Pré e Pós-operatório',
      careIntro: 'Instruções completas para antes e depois da cirurgia de pálpebras.',
      downloadGuide: 'Baixar Guia Completo (PDF)',
      acc1Title: 'Antes da blefaroplastia com anestesia local e sedação',
      fastingTitle: 'Jejum obrigatório',
      fastingDesc: 'Não coma nem beba nada durante as 8–10 horas antes da intervenção.',
      fastingWater: 'Pode tomar meio copo de água ou infusão clara (sem leite, açúcar nem espessantes) pelo menos 4 horas antes.',
      mustAccompanied: 'Deverá vir acompanhado(a) e não poderá dirigir após a cirurgia.',
      avoid24h: 'Durante as 24 horas seguintes, evite operar máquinas, tomar decisões importantes ou assinar documentos.',
      someoneNearby: 'Certifique-se de que alguém permaneça consigo e possa ser contactado por telefone.',
      personalPrep: 'Preparação pessoal',
      comfyClothes: 'Use roupa confortável com botões ou fecho (evite peças que passem pela cabeça).',
      cleanFace: 'Venha com o rosto limpo, sem maquiagem, cremes nem joias.',
      medications: 'Medicamentos',
      avoidNSAIDs: 'Evite anti-inflamatórios (AINEs) como ibuprofeno, aspirina ou naproxeno durante os 10 dias anteriores.',
      paracetamolOk: 'Se precisar aliviar desconforto, pode tomar paracetamol com segurança.',
      itemsAtHome: 'Artigos necessários em casa',
      items: ['Lágrimas artificiais sem conservantes', 'Compressas ou óculos de gel frio', 'Soro fisiológico estéril', 'Infusão de camomila', 'Gazes estéreis', 'Paracetamol 500 mg', 'Povidona iodada (solução)', 'Cicapost® ISDIN ou similar'],
      acc2Title: 'Antes da blefaroplastia com anestesia local sem sedação',
      noFastingTitle: 'Não requer jejum',
      noFastingDesc: 'Sendo realizada apenas com anestesia local, pode tomar café da manhã ou comer normalmente.',
      arriveOnTime: 'Chegue pontualmente à clínica tendo em conta possíveis atrasos.',
      informDoctor: 'Informe o médico sobre qualquer medicação habitual.',
      acc3Title: 'Depois do procedimento de blefaroplastia',
      firstDays: 'Primeiros dias em casa',
      coldCompress: 'Aplique compressas ou óculos de gel frio 10–15 min a cada 2 horas nos primeiros 3 dias.',
      sleepElevated: 'Durma com a cabeça ligeiramente elevada durante 3–4 noites.',
      useTears: 'Use lágrimas artificiais sem conservantes várias vezes ao dia.',
      cleanGently: 'Limpe suavemente com gazes embebidas em soro fisiológico ou camomila fria.',
      slightBleeding: 'Um leve sangramento no primeiro dia é normal.',
      medication: 'Medicação',
      paracetamol8h: 'Paracetamol 500 mg a cada 8 horas se tiver desconforto.',
      antibioticsIfPrescribed: 'Tome antibióticos apenas se prescritos.',
      contactImmediately: 'Contacte imediatamente se notar:',
      urgentSymptoms: ['Dor persistente ou intensa', 'Sangramento que não para', 'Visão turva persistente'],
      followUp: 'Acompanhamento',
      dailyPhoto: 'Envie foto diária por WhatsApp nos primeiros dias.',
      stitchesRemoval: 'Os pontos são removidos aproximadamente no nono dia.',
      avoidOneWeek: 'Evite durante pelo menos uma semana:',
      avoidItems: ['Esforços físicos ou exercício', 'Inclinar-se ou dormir de bruços', 'Poeira, fumo ou poluição', 'Uso prolongado de ecrãs'],
      scarCare: 'Cuidado da cicatriz',
      scarCream: 'Após remoção dos pontos, aplique Cicapost® ISDIN 1–2 vezes por dia durante 2 meses.',
      avoidSun: 'Evite exposição direta ao sol sobre a cicatriz.',
      acc4Title: 'Cuidados e Tratamento do Olho Seco',
      dryEyeIntro1: 'O olho seco é muito frequente a partir de certa idade (50–60 anos), afetando quase metade da população e é mais frequente em mulheres.',
      dryEyeIntro2: 'Após cirurgia de blefaroplastia, pode piorar, pelo que além dos cuidados habituais pode incorporar estes específicos.',
      dryEyeSymptoms: 'Após uma blefaroplastia é frequente notar secura ocular, ardor, sensação de areia, lacrimejo reflexo ou visão turva intermitente. Estes sintomas são geralmente temporários e melhoram seguindo corretamente estas indicações.',
      whyOccurs: 'Por que ocorre?',
      whyReasons: ['Maior evaporação da lágrima', 'Pestanejo incompleto temporário', 'Inflamação leve da superfície ocular'],
      notSerious: 'Não é grave, mas requer tratamento e cuidados adequados.',
      recommendedTreatment: 'Tratamento Recomendado',
      tears: 'Lágrimas artificiais (tratamento principal)',
      tearsDesc: 'Utilizar lágrimas artificiais SEM conservantes.',
      tearsDuringDay: 'Durante o dia: Aplicar 1 gota em cada olho a cada 2–3 horas, mesmo sem desconforto.',
      tearsOptions: 'Opções recomendadas (escolher uma):',
      tearsTip: 'Se a secura piorar com ecrãs ou ambientes secos, são preferíveis as fórmulas com trealose ou componente lipídico, como Thealoz Duo®.',
      nightGel: 'Gel ou pomada oftálmica noturna',
      nightGelDesc: 'Aplicar antes de deitar:',
      nightGelNote: 'Após a aplicação a visão pode ficar turva durante alguns minutos (normal).',
      rednessTitle: 'Vermelhidão ou ardor intenso',
      rednessDesc: 'Em alguns casos o médico pode prescrever colírio anti-inflamatório durante poucos dias.',
      rednessWarning: 'Não utilizar colírios com corticosteroides sem indicação médica.',
      complementary: 'Medidas Complementares Importantes',
      complementaryItems: ['Pestanejar com frequência', 'Evitar vento, ar condicionado direto e fumo', 'Limitar o uso prolongado de ecrãs', 'Usar humidificador ambiental se possível', 'Óculos de sol envolventes no exterior'],
      avoidEyeDrops: 'Evitar colírios para olhos vermelhos, não usar lentes de contacto e não esfregar os olhos.',
      expectedEvolution: 'Evolução Esperada',
      progressiveImprovement: 'Melhoria progressiva',
      resolution8weeks: 'Resolução habitual em 8 semanas',
      consultUrgent: 'Consulte preferencialmente se surgir:',
      urgentEyeSymptoms: ['Dor ocular', 'Visão turva persistente', 'Fotofobia intensa', 'Secreção amarela ou esverdeada', 'Sensação intensa de corpo estranho que não melhora'],
      dryEyeReminder: 'Lembre-se: o olho seco após blefaroplastia é frequente e reversível se estas indicações forem seguidas corretamente.',
      anyQuestion: 'Tem alguma dúvida?',
      atYourService: 'Estamos à sua disposição.',
      disclaimerNote: 'Nota:',
      disclaimerText: 'Estas instruções gerais serão confirmadas e adaptadas segundo cada caso particular.',
      inDevelopment: 'Em Desenvolvimento',
      upcomingGuides: 'Próximos Guias',
      comingSoon: 'Em breve',
      upcomingList: ['Rinoplastia', 'Lifting Facial', 'Cirurgia de Mamas'],
      needMoreInfo: 'Precisa de mais informação?',
      dontHesitate: 'Não hesite em nos contactar.',
      contact: 'Contactar',
    },
  },

  // ============================================
  // RINOMODELACIÓN SUBPAGES
  // ============================================

  rinoContacto: {
    es: {
      back: 'Volver a Rinomodelación',
      title: 'Contacto',
      subtitle: 'Solicite una consulta de valoración',
      phone: 'Teléfono',
      whatsapp: 'WhatsApp',
      email: 'Email',
      formTitle: 'Solicite su Estudio Personalizado',
      formSubtitle: 'Rellena el formulario y te contactaremos para agendar tu consulta',
      scheduleTitle: 'Horario de Atención',
      weekdays: 'Lunes a Viernes',
      weekdaysHours: '10:00 - 14:00 y 16:00 - 20:00',
      saturday: 'Sábados',
      saturdayHours: 'Con cita previa',
      ctaTitle: '¿Prefieres contactar directamente?',
      ctaDesc: 'Llámanos o escríbenos por WhatsApp para resolver tus dudas al momento',
      callNow: 'Llamar Ahora',
    },
    en: {
      back: 'Back to Rhinomodeling',
      title: 'Contact',
      subtitle: 'Request an assessment consultation',
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      email: 'Email',
      formTitle: 'Request Your Personalized Study',
      formSubtitle: 'Fill out the form and we will contact you to schedule your consultation',
      scheduleTitle: 'Office Hours',
      weekdays: 'Monday to Friday',
      weekdaysHours: '10:00 AM - 2:00 PM and 4:00 PM - 8:00 PM',
      saturday: 'Saturdays',
      saturdayHours: 'By appointment',
      ctaTitle: 'Prefer to contact us directly?',
      ctaDesc: 'Call us or write us on WhatsApp to resolve your questions immediately',
      callNow: 'Call Now',
    },
    fr: {
      back: 'Retour au Rhinomodelage',
      title: 'Contact',
      subtitle: 'Demandez une consultation d\'évaluation',
      phone: 'Téléphone',
      whatsapp: 'WhatsApp',
      email: 'Email',
      formTitle: 'Demandez Votre Étude Personnalisée',
      formSubtitle: 'Remplissez le formulaire et nous vous contacterons pour planifier votre consultation',
      scheduleTitle: 'Heures d\'Ouverture',
      weekdays: 'Lundi au Vendredi',
      weekdaysHours: '10h00 - 14h00 et 16h00 - 20h00',
      saturday: 'Samedis',
      saturdayHours: 'Sur rendez-vous',
      ctaTitle: 'Préférez-vous nous contacter directement?',
      ctaDesc: 'Appelez-nous ou écrivez-nous sur WhatsApp pour résoudre vos questions immédiatement',
      callNow: 'Appeler Maintenant',
    },
    pt: {
      back: 'Voltar à Rinomodelação',
      title: 'Contato',
      subtitle: 'Solicite uma consulta de avaliação',
      phone: 'Telefone',
      whatsapp: 'WhatsApp',
      email: 'Email',
      formTitle: 'Solicite Seu Estudo Personalizado',
      formSubtitle: 'Preencha o formulário e entraremos em contato para agendar sua consulta',
      scheduleTitle: 'Horário de Atendimento',
      weekdays: 'Segunda a Sexta',
      weekdaysHours: '10:00 - 14:00 e 16:00 - 20:00',
      saturday: 'Sábados',
      saturdayHours: 'Com agendamento',
      ctaTitle: 'Prefere entrar em contato diretamente?',
      ctaDesc: 'Ligue ou escreva no WhatsApp para resolver suas dúvidas imediatamente',
      callNow: 'Ligar Agora',
    },
  },

  rinoQueEs: {
    es: {
      back: 'Volver a Rinomodelación',
      title: 'RINOMODELACIÓN ¿Qué es?',
      subtitle: 'Por el Dr. Ángel Ruiz Norro',
      desc1: 'La <strong>rinomodelación</strong> es un procedimiento estético no quirúrgico revolucionario que permite corregir imperfecciones de la nariz mediante la aplicación estratégica de rellenos dérmicos de última generación. Es una alternativa segura, rápida y eficaz a la rinoplastia tradicional quirúrgica.',
      desc2: 'Este procedimiento, también conocido como <strong>rinoplastia sin cirugía</strong> o <strong>bioplastia nasal</strong>, permite modificar la forma de la nariz sin necesidad de quirófano, anestesia general ni tiempo de recuperación prolongado.',
      desc3: 'El Dr. Ángel Ruiz Norro es pionero en España en la técnica de rinomodelación, realizando este procedimiento desde 2007 con resultados excepcionales y miles de pacientes satisfechos.',
      advantagesTitle: 'Ventajas de la Rinomodelación',
      adv1Title: 'Resultados Inmediatos',
      adv1Desc: 'Los cambios son visibles al instante, sin necesidad de esperar a que baje la inflamación como en la cirugía tradicional.',
      adv2Title: 'Sin Cirugía',
      adv2Desc: 'Procedimiento ambulatorio sin anestesia general, sin quirófano y sin los riesgos asociados a una intervención quirúrgica.',
      adv3Title: 'Recuperación Inmediata',
      adv3Desc: 'Puedes volver a tu rutina el mismo día. No hay hematomas, vendajes ni baja laboral necesaria.',
      adv4Title: 'Resultados Duraderos',
      adv4Desc: 'Ofrecemos opciones temporales (12-18 meses) o permanentes según las necesidades de cada paciente.',
      correctionsTitle: '¿Qué puede corregir la Rinomodelación?',
      corrections: ['Giba o caballete nasal (dorso prominente)', 'Punta nasal caída o poco definida', 'Desviaciones leves del tabique (visual)', 'Asimetrías nasales', 'Irregularidades post-rinoplastia', 'Nariz ancha o aplanada'],
      ctaTitle: '¿Quieres saber si eres candidato?',
      ctaDesc: 'Solicita una consulta de valoración gratuita',
      ctaButton: 'Solicitar Consulta',
    },
    en: {
      back: 'Back to Rhinomodeling',
      title: 'RHINOMODELING: What is it?',
      subtitle: 'By Dr. Ángel Ruiz Norro',
      desc1: '<strong>Rhinomodeling</strong> is a revolutionary non-surgical aesthetic procedure that allows correcting nose imperfections through the strategic application of state-of-the-art dermal fillers. It is a safe, fast and effective alternative to traditional surgical rhinoplasty.',
      desc2: 'This procedure, also known as <strong>non-surgical rhinoplasty</strong> or <strong>nasal bioplasty</strong>, allows modifying the shape of the nose without the need for an operating room, general anesthesia or prolonged recovery time.',
      desc3: 'Dr. Ángel Ruiz Norro is a pioneer in Spain in rhinomodeling technique, performing this procedure since 2007 with exceptional results and thousands of satisfied patients.',
      advantagesTitle: 'Advantages of Rhinomodeling',
      adv1Title: 'Immediate Results',
      adv1Desc: 'Changes are visible instantly, without waiting for swelling to subside as in traditional surgery.',
      adv2Title: 'No Surgery',
      adv2Desc: 'Outpatient procedure without general anesthesia, without operating room and without the risks associated with surgical intervention.',
      adv3Title: 'Immediate Recovery',
      adv3Desc: 'You can return to your routine the same day. No bruising, bandages or sick leave required.',
      adv4Title: 'Long-lasting Results',
      adv4Desc: 'We offer temporary (12-18 months) or permanent options according to each patient\'s needs.',
      correctionsTitle: 'What can Rhinomodeling correct?',
      corrections: ['Nasal hump (prominent dorsum)', 'Drooping or poorly defined nasal tip', 'Slight septum deviations (visual)', 'Nasal asymmetries', 'Post-rhinoplasty irregularities', 'Wide or flattened nose'],
      ctaTitle: 'Want to know if you\'re a candidate?',
      ctaDesc: 'Request a free assessment consultation',
      ctaButton: 'Request Consultation',
    },
    fr: {
      back: 'Retour au Rhinomodelage',
      title: 'RHINOMODELAGE: Qu\'est-ce que c\'est?',
      subtitle: 'Par le Dr. Ángel Ruiz Norro',
      desc1: 'Le <strong>rhinomodelage</strong> est une procédure esthétique non chirurgicale révolutionnaire qui permet de corriger les imperfections du nez par l\'application stratégique de comblement dermique de dernière génération. C\'est une alternative sûre, rapide et efficace à la rhinoplastie chirurgicale traditionnelle.',
      desc2: 'Cette procédure, également connue sous le nom de <strong>rhinoplastie sans chirurgie</strong> ou <strong>bioplastie nasale</strong>, permet de modifier la forme du nez sans bloc opératoire, anesthésie générale ni temps de récupération prolongé.',
      desc3: 'Le Dr. Ángel Ruiz Norro est pionnier en Espagne dans la technique du rhinomodelage, réalisant cette procédure depuis 2007 avec des résultats exceptionnels et des milliers de patients satisfaits.',
      advantagesTitle: 'Avantages du Rhinomodelage',
      adv1Title: 'Résultats Immédiats',
      adv1Desc: 'Les changements sont visibles instantanément, sans attendre que le gonflement diminue comme en chirurgie traditionnelle.',
      adv2Title: 'Sans Chirurgie',
      adv2Desc: 'Procédure ambulatoire sans anesthésie générale, sans bloc opératoire et sans les risques associés à une intervention chirurgicale.',
      adv3Title: 'Récupération Immédiate',
      adv3Desc: 'Vous pouvez reprendre votre routine le jour même. Pas d\'ecchymoses, de bandages ni d\'arrêt maladie nécessaire.',
      adv4Title: 'Résultats Durables',
      adv4Desc: 'Nous proposons des options temporaires (12-18 mois) ou permanentes selon les besoins de chaque patient.',
      correctionsTitle: 'Que peut corriger le Rhinomodelage?',
      corrections: ['Bosse nasale (dos proéminent)', 'Pointe nasale tombante ou mal définie', 'Légères déviations de la cloison (visuel)', 'Asymétries nasales', 'Irrégularités post-rhinoplastie', 'Nez large ou aplati'],
      ctaTitle: 'Voulez-vous savoir si vous êtes candidat?',
      ctaDesc: 'Demandez une consultation d\'évaluation gratuite',
      ctaButton: 'Demander une Consultation',
    },
    pt: {
      back: 'Voltar à Rinomodelação',
      title: 'RINOMODELAÇÃO: O que é?',
      subtitle: 'Pelo Dr. Ángel Ruiz Norro',
      desc1: 'A <strong>rinomodelação</strong> é um procedimento estético não cirúrgico revolucionário que permite corrigir imperfeições do nariz através da aplicação estratégica de preenchimentos dérmicos de última geração. É uma alternativa segura, rápida e eficaz à rinoplastia cirúrgica tradicional.',
      desc2: 'Este procedimento, também conhecido como <strong>rinoplastia sem cirurgia</strong> ou <strong>bioplastia nasal</strong>, permite modificar a forma do nariz sem necessidade de centro cirúrgico, anestesia geral nem tempo de recuperação prolongado.',
      desc3: 'O Dr. Ángel Ruiz Norro é pioneiro na Espanha na técnica de rinomodelação, realizando este procedimento desde 2007 com resultados excepcionais e milhares de pacientes satisfeitos.',
      advantagesTitle: 'Vantagens da Rinomodelação',
      adv1Title: 'Resultados Imediatos',
      adv1Desc: 'As mudanças são visíveis instantaneamente, sem esperar que o inchaço diminua como na cirurgia tradicional.',
      adv2Title: 'Sem Cirurgia',
      adv2Desc: 'Procedimento ambulatorial sem anestesia geral, sem centro cirúrgico e sem os riscos associados a uma intervenção cirúrgica.',
      adv3Title: 'Recuperação Imediata',
      adv3Desc: 'Você pode voltar à sua rotina no mesmo dia. Sem hematomas, curativos nem licença médica necessária.',
      adv4Title: 'Resultados Duradouros',
      adv4Desc: 'Oferecemos opções temporárias (12-18 meses) ou permanentes conforme as necessidades de cada paciente.',
      correctionsTitle: 'O que a Rinomodelação pode corrigir?',
      corrections: ['Giba nasal (dorso proeminente)', 'Ponta nasal caída ou mal definida', 'Leves desvios do septo (visual)', 'Assimetrias nasais', 'Irregularidades pós-rinoplastia', 'Nariz largo ou achatado'],
      ctaTitle: 'Quer saber se você é candidato?',
      ctaDesc: 'Solicite uma consulta de avaliação gratuita',
      ctaButton: 'Solicitar Consulta',
    },
  },

  rinoResultados: {
    es: {
      back: 'Volver a Rinomodelación',
      title: 'Resultados Antes y Después',
      subtitle: 'Galería de casos reales de rinomodelación realizados por el Dr. Ángel Ruiz Norro',
      casesLabel: 'Casos realizados',
      cases: '+2.500',
      expLabel: 'Años de experiencia',
      exp: '+17',
      satLabel: 'Satisfacción pacientes',
      sat: '98%',
      galleryTitle: 'Galería de Casos',
      gallerySubtitle: 'Selecciona un caso para ver más detalles',
      ctaTitle: '¿Te gustaría obtener resultados similares?',
      ctaDesc: 'Solicita una consulta de valoración personalizada',
      ctaButton: 'Solicitar Consulta',
    },
    en: {
      back: 'Back to Rhinomodeling',
      title: 'Before and After Results',
      subtitle: 'Gallery of real rhinomodeling cases performed by Dr. Ángel Ruiz Norro',
      casesLabel: 'Cases performed',
      cases: '+2,500',
      expLabel: 'Years of experience',
      exp: '+17',
      satLabel: 'Patient satisfaction',
      sat: '98%',
      galleryTitle: 'Case Gallery',
      gallerySubtitle: 'Select a case to see more details',
      ctaTitle: 'Would you like to get similar results?',
      ctaDesc: 'Request a personalized assessment consultation',
      ctaButton: 'Request Consultation',
    },
    fr: {
      back: 'Retour au Rhinomodelage',
      title: 'Résultats Avant et Après',
      subtitle: 'Galerie de cas réels de rhinomodelage réalisés par le Dr. Ángel Ruiz Norro',
      casesLabel: 'Cas réalisés',
      cases: '+2 500',
      expLabel: 'Années d\'expérience',
      exp: '+17',
      satLabel: 'Satisfaction patients',
      sat: '98%',
      galleryTitle: 'Galerie de Cas',
      gallerySubtitle: 'Sélectionnez un cas pour voir plus de détails',
      ctaTitle: 'Aimeriez-vous obtenir des résultats similaires?',
      ctaDesc: 'Demandez une consultation d\'évaluation personnalisée',
      ctaButton: 'Demander une Consultation',
    },
    pt: {
      back: 'Voltar à Rinomodelação',
      title: 'Resultados Antes e Depois',
      subtitle: 'Galeria de casos reais de rinomodelação realizados pelo Dr. Ángel Ruiz Norro',
      casesLabel: 'Casos realizados',
      cases: '+2.500',
      expLabel: 'Anos de experiência',
      exp: '+17',
      satLabel: 'Satisfação pacientes',
      sat: '98%',
      galleryTitle: 'Galeria de Casos',
      gallerySubtitle: 'Selecione um caso para ver mais detalhes',
      ctaTitle: 'Gostaria de obter resultados semelhantes?',
      ctaDesc: 'Solicite uma consulta de avaliação personalizada',
      ctaButton: 'Solicitar Consulta',
    },
  },

  rinoDoctor: {
    es: {
      back: 'Volver a Rinomodelación',
      title: 'Dr. Ángel Ruiz Norro',
      subtitle: 'Especialista en Rinomodelación',
      description: 'Pionero en España en la técnica de rinomodelación desde 2007. Más de 30 años de experiencia en cirugía plástica y medicina estética.',
      quote: '"Considero esta técnica de las más extraordinarias entre las que he ido conociendo y practicando a lo largo de más de 25 años. Un gran avance."',
      subpages: {
        curriculum: 'Currículum',
        press: 'Artículos de Prensa',
        presentations: 'Ponencias Congresos',
        clinic: 'Clínica Marbella',
      },
      ctaTitle: '¿Desea una consulta?',
      ctaButton: 'Solicitar Consulta',
    },
    en: {
      back: 'Back to Rhinomodeling',
      title: 'Dr. Ángel Ruiz Norro',
      subtitle: 'Rhinomodeling Specialist',
      description: 'Pioneer in Spain in rhinomodeling technique since 2007. Over 30 years of experience in plastic surgery and aesthetic medicine.',
      quote: '"I consider this technique one of the most extraordinary among those I have learned and practiced over more than 25 years. A great advancement."',
      subpages: {
        curriculum: 'Curriculum',
        press: 'Press Articles',
        presentations: 'Conference Presentations',
        clinic: 'Marbella Clinic',
      },
      ctaTitle: 'Would you like a consultation?',
      ctaButton: 'Request Consultation',
    },
    fr: {
      back: 'Retour au Rhinomodelage',
      title: 'Dr. Ángel Ruiz Norro',
      subtitle: 'Spécialiste en Rhinomodelage',
      description: 'Pionnier en Espagne dans la technique du rhinomodelage depuis 2007. Plus de 30 ans d\'expérience en chirurgie plastique et médecine esthétique.',
      quote: '"Je considère cette technique comme l\'une des plus extraordinaires parmi celles que j\'ai apprises et pratiquées au cours de plus de 25 ans. Une grande avancée."',
      subpages: {
        curriculum: 'Curriculum',
        press: 'Articles de Presse',
        presentations: 'Présentations Congrès',
        clinic: 'Clinique Marbella',
      },
      ctaTitle: 'Souhaitez-vous une consultation?',
      ctaButton: 'Demander une Consultation',
    },
    pt: {
      back: 'Voltar à Rinomodelação',
      title: 'Dr. Ángel Ruiz Norro',
      subtitle: 'Especialista em Rinomodelação',
      description: 'Pioneiro na Espanha na técnica de rinomodelação desde 2007. Mais de 30 anos de experiência em cirurgia plástica e medicina estética.',
      quote: '"Considero esta técnica uma das mais extraordinárias entre as que conheci e pratiquei ao longo de mais de 25 anos. Um grande avanço."',
      subpages: {
        curriculum: 'Currículo',
        press: 'Artigos de Imprensa',
        presentations: 'Apresentações em Congressos',
        clinic: 'Clínica Marbella',
      },
      ctaTitle: 'Deseja uma consulta?',
      ctaButton: 'Solicitar Consulta',
    },
  },

  rinoFAQ: {
    es: {
      back: 'Volver a Rinomodelación',
      title: 'Preguntas Frecuentes',
      subtitle: 'Resolvemos tus dudas sobre la rinomodelación',
      ctaTitle: '¿Tienes más preguntas?',
      ctaDesc: 'Contacta con nosotros para resolver todas tus dudas',
      ctaButton: 'Contactar',
    },
    en: {
      back: 'Back to Rhinomodeling',
      title: 'Frequently Asked Questions',
      subtitle: 'We answer your questions about rhinomodeling',
      ctaTitle: 'Do you have more questions?',
      ctaDesc: 'Contact us to resolve all your doubts',
      ctaButton: 'Contact',
    },
    fr: {
      back: 'Retour au Rhinomodelage',
      title: 'Questions Fréquentes',
      subtitle: 'Nous répondons à vos questions sur le rhinomodelage',
      ctaTitle: 'Avez-vous d\'autres questions?',
      ctaDesc: 'Contactez-nous pour résoudre tous vos doutes',
      ctaButton: 'Contacter',
    },
    pt: {
      back: 'Voltar à Rinomodelação',
      title: 'Perguntas Frequentes',
      subtitle: 'Respondemos suas dúvidas sobre a rinomodelação',
      ctaTitle: 'Tem mais perguntas?',
      ctaDesc: 'Entre em contato para resolver todas as suas dúvidas',
      ctaButton: 'Contatar',
    },
  },
  preparacion: {
    es: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Preparación',
      title2: 'antes de tu cirugía',
      heroDesc: 'Una buena preparación marca la diferencia en el resultado. Protocolos personalizados para optimizar tu piel y tu cuerpo antes de la intervención.',
      requestAssessment: 'Solicitar valoración',
      callNow: 'Llamar ahora',
      conceptLabel: 'El concepto',
      whyTitle: '¿Por qué es importante prepararse?',
      reason1Title: 'Mejores resultados',
      reason1Desc: 'Una piel preparada cicatriza mejor y responde de forma óptima a la cirugía.',
      reason2Title: 'Recuperación más rápida',
      reason2Desc: 'Un organismo bien preparado reduce el tiempo de recuperación y las molestias postoperatorias.',
      reason3Title: 'Menor riesgo',
      reason3Desc: 'La preparación adecuada minimiza riesgos y complicaciones durante y después de la intervención.',
      protocolLabel: 'Protocolo personalizado',
      phasesTitle: 'Fases de preparación',
      phase1Title: 'Evaluación inicial',
      phase1Items: ['Valoración del estado de la piel', 'Análisis de factores de riesgo', 'Diseño del protocolo personalizado'],
      phase2Title: 'Preparación de la piel',
      phase2Items: ['Tratamientos de hidratación profunda', 'Estimulación del colágeno', 'Fortalecimiento de la barrera cutánea'],
      phase3Title: 'Preparación general',
      phase3Items: ['Suplementación y nutrición', 'Pautas preoperatorias', 'Apoyo integral al paciente'],
      specificLabel: 'Protocolos específicos',
      adaptedTitle: 'Adaptado a cada intervención',
      cat1Title: 'Cirugía facial',
      cat1Items: ['Blefaroplastia', 'Lifting facial', 'Rinoplastia', 'Otoplastia'],
      cat2Title: 'Cirugía corporal',
      cat2Items: ['Liposucción', 'Abdominoplastia', 'Post-bariátrica', 'Cirugía mamaria'],
      cat3Title: 'Medicina estética',
      cat3Items: ['Rinomodelación', 'Endolifting', 'Armonización facial', 'Tratamiento de ojeras'],
      cat4Title: 'Bienestar',
      cat4Items: ['Ginecología estética', 'Medicina integrativa', 'Cirugía dermatológica'],
      eachProtocol: 'Cada protocolo comienza con una evaluación personalizada',
      ctaTitle: 'Prepara tu cuerpo para el mejor resultado',
      ctaDesc: 'Solicita una evaluación personalizada y diseñaremos el protocolo de preparación más adecuado para tu intervención.',
    },
    en: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Preparation',
      title2: 'before your surgery',
      heroDesc: 'Good preparation makes the difference in results. Personalized protocols to optimize your skin and body before the procedure.',
      requestAssessment: 'Request assessment',
      callNow: 'Call now',
      conceptLabel: 'The concept',
      whyTitle: 'Why is preparation important?',
      reason1Title: 'Better results',
      reason1Desc: 'Prepared skin heals better and responds optimally to surgery.',
      reason2Title: 'Faster recovery',
      reason2Desc: 'A well-prepared body reduces recovery time and post-operative discomfort.',
      reason3Title: 'Lower risk',
      reason3Desc: 'Proper preparation minimizes risks and complications during and after the procedure.',
      protocolLabel: 'Personalized protocol',
      phasesTitle: 'Preparation phases',
      phase1Title: 'Initial assessment',
      phase1Items: ['Skin condition evaluation', 'Risk factor analysis', 'Personalized protocol design'],
      phase2Title: 'Skin preparation',
      phase2Items: ['Deep hydration treatments', 'Collagen stimulation', 'Skin barrier strengthening'],
      phase3Title: 'General preparation',
      phase3Items: ['Supplementation and nutrition', 'Pre-operative guidelines', 'Comprehensive patient support'],
      specificLabel: 'Specific protocols',
      adaptedTitle: 'Adapted to each procedure',
      cat1Title: 'Facial surgery',
      cat1Items: ['Blepharoplasty', 'Facelift', 'Rhinoplasty', 'Otoplasty'],
      cat2Title: 'Body surgery',
      cat2Items: ['Liposuction', 'Abdominoplasty', 'Post-bariatric', 'Breast surgery'],
      cat3Title: 'Aesthetic medicine',
      cat3Items: ['Rhinomodeling', 'Endolifting', 'Facial harmonization', 'Dark circles treatment'],
      cat4Title: 'Wellness',
      cat4Items: ['Gynecological aesthetics', 'Integrative medicine', 'Dermatological surgery'],
      eachProtocol: 'Each protocol begins with a personalized assessment',
      ctaTitle: 'Prepare your body for the best result',
      ctaDesc: 'Request a personalized assessment and we will design the most suitable preparation protocol for your procedure.',
    },
    fr: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Préparation',
      title2: 'avant votre chirurgie',
      heroDesc: 'Une bonne préparation fait la différence dans le résultat. Protocoles personnalisés pour optimiser votre peau et votre corps avant l\'intervention.',
      requestAssessment: 'Demander une évaluation',
      callNow: 'Appeler maintenant',
      conceptLabel: 'Le concept',
      whyTitle: 'Pourquoi est-il important de se préparer ?',
      reason1Title: 'Meilleurs résultats',
      reason1Desc: 'Une peau préparée cicatrise mieux et répond de manière optimale à la chirurgie.',
      reason2Title: 'Récupération plus rapide',
      reason2Desc: 'Un organisme bien préparé réduit le temps de récupération et les désagréments postopératoires.',
      reason3Title: 'Risque réduit',
      reason3Desc: 'Une préparation adéquate minimise les risques et complications pendant et après l\'intervention.',
      protocolLabel: 'Protocole personnalisé',
      phasesTitle: 'Phases de préparation',
      phase1Title: 'Évaluation initiale',
      phase1Items: ['Évaluation de l\'état de la peau', 'Analyse des facteurs de risque', 'Conception du protocole personnalisé'],
      phase2Title: 'Préparation de la peau',
      phase2Items: ['Traitements d\'hydratation profonde', 'Stimulation du collagène', 'Renforcement de la barrière cutanée'],
      phase3Title: 'Préparation générale',
      phase3Items: ['Supplémentation et nutrition', 'Directives préopératoires', 'Accompagnement global du patient'],
      specificLabel: 'Protocoles spécifiques',
      adaptedTitle: 'Adapté à chaque intervention',
      cat1Title: 'Chirurgie faciale',
      cat1Items: ['Blépharoplastie', 'Lifting facial', 'Rhinoplastie', 'Otoplastie'],
      cat2Title: 'Chirurgie corporelle',
      cat2Items: ['Liposuccion', 'Abdominoplastie', 'Post-bariatrique', 'Chirurgie mammaire'],
      cat3Title: 'Médecine esthétique',
      cat3Items: ['Rhinomodélation', 'Endolifting', 'Harmonisation faciale', 'Traitement des cernes'],
      cat4Title: 'Bien-être',
      cat4Items: ['Gynécologie esthétique', 'Médecine intégrative', 'Chirurgie dermatologique'],
      eachProtocol: 'Chaque protocole commence par une évaluation personnalisée',
      ctaTitle: 'Préparez votre corps pour le meilleur résultat',
      ctaDesc: 'Demandez une évaluation personnalisée et nous concevrons le protocole de préparation le plus adapté à votre intervention.',
    },
    pt: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Preparação',
      title2: 'antes da sua cirurgia',
      heroDesc: 'Uma boa preparação faz a diferença no resultado. Protocolos personalizados para otimizar a sua pele e o seu corpo antes da intervenção.',
      requestAssessment: 'Solicitar avaliação',
      callNow: 'Ligar agora',
      conceptLabel: 'O conceito',
      whyTitle: 'Por que é importante preparar-se?',
      reason1Title: 'Melhores resultados',
      reason1Desc: 'Uma pele preparada cicatriza melhor e responde de forma ótima à cirurgia.',
      reason2Title: 'Recuperação mais rápida',
      reason2Desc: 'Um organismo bem preparado reduz o tempo de recuperação e o desconforto pós-operatório.',
      reason3Title: 'Menor risco',
      reason3Desc: 'A preparação adequada minimiza riscos e complicações durante e após a intervenção.',
      protocolLabel: 'Protocolo personalizado',
      phasesTitle: 'Fases de preparação',
      phase1Title: 'Avaliação inicial',
      phase1Items: ['Avaliação do estado da pele', 'Análise de fatores de risco', 'Desenho do protocolo personalizado'],
      phase2Title: 'Preparação da pele',
      phase2Items: ['Tratamentos de hidratação profunda', 'Estimulação do colágeno', 'Fortalecimento da barreira cutânea'],
      phase3Title: 'Preparação geral',
      phase3Items: ['Suplementação e nutrição', 'Orientações pré-operatórias', 'Apoio integral ao paciente'],
      specificLabel: 'Protocolos específicos',
      adaptedTitle: 'Adaptado a cada intervenção',
      cat1Title: 'Cirurgia facial',
      cat1Items: ['Blefaroplastia', 'Lifting facial', 'Rinoplastia', 'Otoplastia'],
      cat2Title: 'Cirurgia corporal',
      cat2Items: ['Lipoaspiração', 'Abdominoplastia', 'Pós-bariátrica', 'Cirurgia mamária'],
      cat3Title: 'Medicina estética',
      cat3Items: ['Rinomodelação', 'Endolifting', 'Harmonização facial', 'Tratamento de olheiras'],
      cat4Title: 'Bem-estar',
      cat4Items: ['Ginecologia estética', 'Medicina integrativa', 'Cirurgia dermatológica'],
      eachProtocol: 'Cada protocolo começa com uma avaliação personalizada',
      ctaTitle: 'Prepare o seu corpo para o melhor resultado',
      ctaDesc: 'Solicite uma avaliação personalizada e desenharemos o protocolo de preparação mais adequado para a sua intervenção.',
    },
  },
  recuperacion: {
    es: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Recuperación',
      title2: 'después de cirugía',
      heroDesc1: 'Optimiza tu recuperación. Mejora tus resultados.',
      heroDesc2: 'Después de una intervención estética, la recuperación es clave. Inflamación, edema, tensión de los tejidos… todo influye directamente en el resultado final.',
      bookEval: 'Reservar evaluación',
      callNow: 'Llamar ahora',
      conceptLabel: 'El concepto',
      conceptTitle1: 'No vienes a hacerte un tratamiento.',
      conceptTitle2: 'Sigues un protocolo estructurado.',
      obj1Title: 'Activar la circulación',
      obj1Desc: 'Mejora el flujo sanguíneo para una recuperación acelerada.',
      obj2Title: 'Eliminar líquidos',
      obj2Desc: 'Drenaje de edema y líquidos retenidos post-cirugía.',
      obj3Title: 'Estimular los tejidos',
      obj3Desc: 'Regeneración tisular para resultados óptimos.',
      obj4Title: 'Mejorar cicatrización',
      obj4Desc: 'Protocolos específicos para cicatrices imperceptibles.',
      methodLabel: 'Metodología',
      phasesTitle: 'Protocolos en 3 fases',
      p1Title: 'Recuperación',
      p1Sub: 'Reducir inflamación y edema',
      p1Items: ['Drenaje linfático', 'Terapia LED cicatrizante'],
      p1Note: 'Recuperación más rápida y cómoda',
      p2Title: 'Estimulación tisular',
      p2Sub: 'Mejorar la calidad de los tejidos',
      p2Items: ['Radiofrecuencia', 'Estimulación mecánica (Vacuum / LPG)'],
      p2Note: 'Mejor circulación · Previene fibrosis',
      p3Title: 'Optimización estética',
      p3Sub: 'Mejorar el resultado final',
      p3Items: ['Tratamientos de la piel', 'Microneedling', 'Peeling'],
      p3Note: 'Resultados visibles y duraderos',
      customLabel: 'Protocolos personalizados',
      adaptedTitle: 'Adaptados a cada intervención',
      cat1Title: 'Cirugía facial',
      cat1Items: ['Blefaroplastia', 'Lifting facial y cervical', 'Rinoplastia', 'Otoplastia'],
      cat1Desc: 'Protocolos para reducir edema y mejorar la calidad de la piel.',
      cat2Title: 'Cirugía corporal',
      cat2Items: ['Liposucción / lipoescultura', 'Abdominoplastia', 'Post-bariátrica', 'Cirugía mamaria', 'Ginecomastia'],
      cat2Desc: 'Protocolos para optimizar la recuperación corporal.',
      cat3Title: 'Medicina estética',
      cat3Items: ['Rinomodelación', 'Endolifting', 'Doble mentón', 'Armonización facial', 'Tratamiento de ojeras'],
      cat3Desc: 'Protocolos para potenciar los resultados.',
      cat4Title: 'Bienestar',
      cat4Items: ['Ginecología estética', 'Medicina integrativa', 'Cirugía dermatológica'],
      cat4Desc: 'Protocolos para recuperación global.',
      eachProtocol: 'Cada protocolo comienza con una evaluación personalizada',
      techLabel: 'Tecnología',
      techTitle: 'Tecnologías avanzadas integradas en cada protocolo',
      tech1Title: 'Radiofrecuencia',
      tech1Desc: 'Estimula el colágeno · Reafirma la piel · Mejora la calidad cutánea',
      tech2Title: 'Estimulación tisular (Vacuum / LPG)',
      tech2Desc: 'Activa la circulación · Mejora los tejidos · Favorece la recuperación',
      tech3Title: 'Terapia LED',
      tech3Desc: 'Acelera la cicatrización · Reduce inflamación · Regeneración celular',
      ctaTitle: 'Reserva tu protocolo personalizado',
      ctaDesc: 'Te ofrecemos una evaluación personalizada para definir el protocolo más adecuado para tu recuperación.',
      ctaBtn: 'Reservar evaluación',
    },
    en: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Recovery',
      title2: 'after surgery',
      heroDesc1: 'Optimize your recovery. Improve your results.',
      heroDesc2: 'After an aesthetic procedure, recovery is key. Inflammation, edema, tissue tension… everything directly influences the final result.',
      bookEval: 'Book evaluation',
      callNow: 'Call now',
      conceptLabel: 'The concept',
      conceptTitle1: 'You don\'t come for a treatment.',
      conceptTitle2: 'You follow a structured protocol.',
      obj1Title: 'Activate circulation',
      obj1Desc: 'Improves blood flow for accelerated recovery.',
      obj2Title: 'Eliminate fluids',
      obj2Desc: 'Drainage of edema and post-surgery retained fluids.',
      obj3Title: 'Stimulate tissues',
      obj3Desc: 'Tissue regeneration for optimal results.',
      obj4Title: 'Improve healing',
      obj4Desc: 'Specific protocols for imperceptible scars.',
      methodLabel: 'Methodology',
      phasesTitle: 'Protocols in 3 phases',
      p1Title: 'Recovery',
      p1Sub: 'Reduce inflammation and edema',
      p1Items: ['Lymphatic drainage', 'LED healing therapy'],
      p1Note: 'Faster and more comfortable recovery',
      p2Title: 'Tissue stimulation',
      p2Sub: 'Improve tissue quality',
      p2Items: ['Radiofrequency', 'Mechanical stimulation (Vacuum / LPG)'],
      p2Note: 'Better circulation · Prevents fibrosis',
      p3Title: 'Aesthetic optimization',
      p3Sub: 'Improve the final result',
      p3Items: ['Skin treatments', 'Microneedling', 'Peeling'],
      p3Note: 'Visible and lasting results',
      customLabel: 'Personalized protocols',
      adaptedTitle: 'Adapted to each procedure',
      cat1Title: 'Facial surgery',
      cat1Items: ['Blepharoplasty', 'Face and neck lift', 'Rhinoplasty', 'Otoplasty'],
      cat1Desc: 'Protocols to reduce edema and improve skin quality.',
      cat2Title: 'Body surgery',
      cat2Items: ['Liposuction / liposculpture', 'Abdominoplasty', 'Post-bariatric', 'Breast surgery', 'Gynecomastia'],
      cat2Desc: 'Protocols to optimize body recovery.',
      cat3Title: 'Aesthetic medicine',
      cat3Items: ['Rhinomodeling', 'Endolifting', 'Double chin', 'Facial harmonization', 'Dark circles treatment'],
      cat3Desc: 'Protocols to enhance results.',
      cat4Title: 'Wellness',
      cat4Items: ['Gynecological aesthetics', 'Integrative medicine', 'Dermatological surgery'],
      cat4Desc: 'Protocols for global recovery.',
      eachProtocol: 'Each protocol begins with a personalized assessment',
      techLabel: 'Technology',
      techTitle: 'Advanced technologies integrated into each protocol',
      tech1Title: 'Radiofrequency',
      tech1Desc: 'Stimulates collagen · Firms the skin · Improves skin quality',
      tech2Title: 'Tissue stimulation (Vacuum / LPG)',
      tech2Desc: 'Activates circulation · Improves tissues · Promotes recovery',
      tech3Title: 'LED Therapy',
      tech3Desc: 'Accelerates healing · Reduces inflammation · Cell regeneration',
      ctaTitle: 'Book your personalized protocol',
      ctaDesc: 'We offer a personalized evaluation to define the most suitable protocol for your recovery.',
      ctaBtn: 'Book evaluation',
    },
    fr: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Récupération',
      title2: 'après chirurgie',
      heroDesc1: 'Optimisez votre récupération. Améliorez vos résultats.',
      heroDesc2: 'Après une intervention esthétique, la récupération est essentielle. Inflammation, œdème, tension des tissus… tout influence directement le résultat final.',
      bookEval: 'Réserver une évaluation',
      callNow: 'Appeler maintenant',
      conceptLabel: 'Le concept',
      conceptTitle1: 'Vous ne venez pas pour un traitement.',
      conceptTitle2: 'Vous suivez un protocole structuré.',
      obj1Title: 'Activer la circulation',
      obj1Desc: 'Améliore le flux sanguin pour une récupération accélérée.',
      obj2Title: 'Éliminer les liquides',
      obj2Desc: 'Drainage de l\'œdème et des liquides retenus après la chirurgie.',
      obj3Title: 'Stimuler les tissus',
      obj3Desc: 'Régénération tissulaire pour des résultats optimaux.',
      obj4Title: 'Améliorer la cicatrisation',
      obj4Desc: 'Protocoles spécifiques pour des cicatrices imperceptibles.',
      methodLabel: 'Méthodologie',
      phasesTitle: 'Protocoles en 3 phases',
      p1Title: 'Récupération',
      p1Sub: 'Réduire l\'inflammation et l\'œdème',
      p1Items: ['Drainage lymphatique', 'Thérapie LED cicatrisante'],
      p1Note: 'Récupération plus rapide et confortable',
      p2Title: 'Stimulation tissulaire',
      p2Sub: 'Améliorer la qualité des tissus',
      p2Items: ['Radiofréquence', 'Stimulation mécanique (Vacuum / LPG)'],
      p2Note: 'Meilleure circulation · Prévient la fibrose',
      p3Title: 'Optimisation esthétique',
      p3Sub: 'Améliorer le résultat final',
      p3Items: ['Traitements de la peau', 'Microneedling', 'Peeling'],
      p3Note: 'Résultats visibles et durables',
      customLabel: 'Protocoles personnalisés',
      adaptedTitle: 'Adaptés à chaque intervention',
      cat1Title: 'Chirurgie faciale',
      cat1Items: ['Blépharoplastie', 'Lifting facial et cervical', 'Rhinoplastie', 'Otoplastie'],
      cat1Desc: 'Protocoles pour réduire l\'œdème et améliorer la qualité de la peau.',
      cat2Title: 'Chirurgie corporelle',
      cat2Items: ['Liposuccion / liposculpture', 'Abdominoplastie', 'Post-bariatrique', 'Chirurgie mammaire', 'Gynécomastie'],
      cat2Desc: 'Protocoles pour optimiser la récupération corporelle.',
      cat3Title: 'Médecine esthétique',
      cat3Items: ['Rhinomodélation', 'Endolifting', 'Double menton', 'Harmonisation faciale', 'Traitement des cernes'],
      cat3Desc: 'Protocoles pour renforcer les résultats.',
      cat4Title: 'Bien-être',
      cat4Items: ['Gynécologie esthétique', 'Médecine intégrative', 'Chirurgie dermatologique'],
      cat4Desc: 'Protocoles pour une récupération globale.',
      eachProtocol: 'Chaque protocole commence par une évaluation personnalisée',
      techLabel: 'Technologie',
      techTitle: 'Technologies avancées intégrées dans chaque protocole',
      tech1Title: 'Radiofréquence',
      tech1Desc: 'Stimule le collagène · Raffermit la peau · Améliore la qualité cutanée',
      tech2Title: 'Stimulation tissulaire (Vacuum / LPG)',
      tech2Desc: 'Active la circulation · Améliore les tissus · Favorise la récupération',
      tech3Title: 'Thérapie LED',
      tech3Desc: 'Accélère la cicatrisation · Réduit l\'inflammation · Régénération cellulaire',
      ctaTitle: 'Réservez votre protocole personnalisé',
      ctaDesc: 'Nous vous proposons une évaluation personnalisée pour définir le protocole le plus adapté à votre récupération.',
      ctaBtn: 'Réserver une évaluation',
    },
    pt: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Recuperação',
      title2: 'após cirurgia',
      heroDesc1: 'Otimize a sua recuperação. Melhore os seus resultados.',
      heroDesc2: 'Após uma intervenção estética, a recuperação é fundamental. Inflamação, edema, tensão dos tecidos… tudo influencia diretamente o resultado final.',
      bookEval: 'Reservar avaliação',
      callNow: 'Ligar agora',
      conceptLabel: 'O conceito',
      conceptTitle1: 'Não vem fazer um tratamento.',
      conceptTitle2: 'Segue um protocolo estruturado.',
      obj1Title: 'Ativar a circulação',
      obj1Desc: 'Melhora o fluxo sanguíneo para uma recuperação acelerada.',
      obj2Title: 'Eliminar líquidos',
      obj2Desc: 'Drenagem de edema e líquidos retidos pós-cirurgia.',
      obj3Title: 'Estimular os tecidos',
      obj3Desc: 'Regeneração tecidual para resultados ótimos.',
      obj4Title: 'Melhorar cicatrização',
      obj4Desc: 'Protocolos específicos para cicatrizes imperceptíveis.',
      methodLabel: 'Metodologia',
      phasesTitle: 'Protocolos em 3 fases',
      p1Title: 'Recuperação',
      p1Sub: 'Reduzir inflamação e edema',
      p1Items: ['Drenagem linfática', 'Terapia LED cicatrizante'],
      p1Note: 'Recuperação mais rápida e confortável',
      p2Title: 'Estimulação tecidual',
      p2Sub: 'Melhorar a qualidade dos tecidos',
      p2Items: ['Radiofrequência', 'Estimulação mecânica (Vacuum / LPG)'],
      p2Note: 'Melhor circulação · Previne fibrose',
      p3Title: 'Otimização estética',
      p3Sub: 'Melhorar o resultado final',
      p3Items: ['Tratamentos da pele', 'Microneedling', 'Peeling'],
      p3Note: 'Resultados visíveis e duradouros',
      customLabel: 'Protocolos personalizados',
      adaptedTitle: 'Adaptados a cada intervenção',
      cat1Title: 'Cirurgia facial',
      cat1Items: ['Blefaroplastia', 'Lifting facial e cervical', 'Rinoplastia', 'Otoplastia'],
      cat1Desc: 'Protocolos para reduzir edema e melhorar a qualidade da pele.',
      cat2Title: 'Cirurgia corporal',
      cat2Items: ['Lipoaspiração / lipoescultura', 'Abdominoplastia', 'Pós-bariátrica', 'Cirurgia mamária', 'Ginecomastia'],
      cat2Desc: 'Protocolos para otimizar a recuperação corporal.',
      cat3Title: 'Medicina estética',
      cat3Items: ['Rinomodelação', 'Endolifting', 'Papada', 'Harmonização facial', 'Tratamento de olheiras'],
      cat3Desc: 'Protocolos para potenciar os resultados.',
      cat4Title: 'Bem-estar',
      cat4Items: ['Ginecologia estética', 'Medicina integrativa', 'Cirurgia dermatológica'],
      cat4Desc: 'Protocolos para recuperação global.',
      eachProtocol: 'Cada protocolo começa com uma avaliação personalizada',
      techLabel: 'Tecnologia',
      techTitle: 'Tecnologias avançadas integradas em cada protocolo',
      tech1Title: 'Radiofrequência',
      tech1Desc: 'Estimula o colágeno · Reafirma a pele · Melhora a qualidade cutânea',
      tech2Title: 'Estimulação tecidual (Vacuum / LPG)',
      tech2Desc: 'Ativa a circulação · Melhora os tecidos · Favorece a recuperação',
      tech3Title: 'Terapia LED',
      tech3Desc: 'Acelera a cicatrização · Reduz inflamação · Regeneração celular',
      ctaTitle: 'Reserve o seu protocolo personalizado',
      ctaDesc: 'Oferecemos uma avaliação personalizada para definir o protocolo mais adequado para a sua recuperação.',
      ctaBtn: 'Reservar avaliação',
    },
  },
  skinHealth: {
    es: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Skin',
      title2: 'Health',
      heroDesc1: 'Tratamientos avanzados para mejorar la calidad de la piel, estimular el colágeno, corregir imperfecciones y devolver luminosidad.',
      heroDesc2: 'Ideales tanto para pacientes de la clínica como para nuevos clientes que buscan una piel más sana y radiante.',
      requestAppt: 'Solicitar cita',
      callNow: 'Llamar ahora',
      treatLabel: 'Tratamientos principales',
      treatTitle: 'Cuidado experto para tu piel',
      t1Name: 'Skin Reset', t1Sub: 'Limpieza profunda',
      t1Desc: 'Protocolo de limpieza y renovación completa de la piel. Elimina impurezas, desobstruye poros y prepara la piel para recibir tratamientos posteriores con máxima eficacia.',
      t2Name: 'Marbella Glow', t2Sub: 'Tratamiento iluminador',
      t2Desc: 'Tratamiento exclusivo para devolver la luminosidad y el esplendor a tu piel. Combina tecnologías avanzadas con activos de última generación para un efecto glow visible desde la primera sesión.',
      t3Name: 'Collagen Boost', t3Sub: 'Microneedling',
      t3Desc: 'Estimulación intensiva del colágeno mediante microneedling de precisión. Mejora la textura, reduce poros, atenúa cicatrices y devuelve firmeza a la piel de forma natural.',
      t4Name: 'Peeling Químico', t4Sub: 'Renovación cutánea',
      t4Desc: 'Renovación profunda de la piel mediante peelings químicos personalizados. Corrige manchas, mejora la textura y estimula la regeneración celular para una piel más uniforme y joven.',
      compLabel: 'Servicios complementarios',
      compTitle: 'Tratamientos estéticos adicionales',
      compSubtitle: 'Disponibles como complemento a los protocolos médicos, bajo solicitud.',
      comp1Title: 'Masajes y recuperación',
      comp1Items: ['Drenaje linfático', 'Masaje terapéutico', 'Masaje deportivo', 'Reflexología', 'Masaje relajante'],
      comp2Title: 'Tratamientos faciales',
      comp2Items: ['Limpieza facial', 'Tratamientos hidratantes', 'Microneedling', 'Peeling'],
      comp3Title: 'Belleza y cuidado',
      comp3Items: ['Micropigmentación', 'Depilación facial', 'Cuidado de manos y pies'],
      whyLabel: '¿Por qué elegirnos?',
      whyTitle: 'Una experiencia de cuidado integral',
      whyItems: ['Centro integrado en clínica estética', 'Protocolos personalizados', 'Tecnología avanzada', 'Enfoque médico y resultados visibles', 'Acompañamiento completo'],
      ctaTitle: 'Tu piel merece el mejor cuidado',
      ctaDesc: 'Solicita tu cita y diseñaremos un plan de tratamiento personalizado para tu piel.',
      ctaBtn: 'Solicitar cita',
    },
    en: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Skin',
      title2: 'Health',
      heroDesc1: 'Advanced treatments to improve skin quality, stimulate collagen, correct imperfections, and restore radiance.',
      heroDesc2: 'Ideal for both clinic patients and new clients seeking healthier, more radiant skin.',
      requestAppt: 'Request appointment',
      callNow: 'Call now',
      treatLabel: 'Main treatments',
      treatTitle: 'Expert care for your skin',
      t1Name: 'Skin Reset', t1Sub: 'Deep cleansing',
      t1Desc: 'Complete skin cleansing and renewal protocol. Removes impurities, unclogs pores, and prepares the skin to receive subsequent treatments with maximum efficacy.',
      t2Name: 'Marbella Glow', t2Sub: 'Illuminating treatment',
      t2Desc: 'Exclusive treatment to restore radiance and splendor to your skin. Combines advanced technologies with cutting-edge active ingredients for a visible glow effect from the first session.',
      t3Name: 'Collagen Boost', t3Sub: 'Microneedling',
      t3Desc: 'Intensive collagen stimulation through precision microneedling. Improves texture, reduces pores, diminishes scars, and restores firmness to the skin naturally.',
      t4Name: 'Chemical Peeling', t4Sub: 'Skin renewal',
      t4Desc: 'Deep skin renewal through personalized chemical peels. Corrects blemishes, improves texture, and stimulates cell regeneration for more uniform and youthful skin.',
      compLabel: 'Complementary services',
      compTitle: 'Additional aesthetic treatments',
      compSubtitle: 'Available as a complement to medical protocols, upon request.',
      comp1Title: 'Massages and recovery',
      comp1Items: ['Lymphatic drainage', 'Therapeutic massage', 'Sports massage', 'Reflexology', 'Relaxation massage'],
      comp2Title: 'Facial treatments',
      comp2Items: ['Facial cleansing', 'Hydrating treatments', 'Microneedling', 'Peeling'],
      comp3Title: 'Beauty and care',
      comp3Items: ['Micropigmentation', 'Facial hair removal', 'Hand and foot care'],
      whyLabel: 'Why choose us?',
      whyTitle: 'A comprehensive care experience',
      whyItems: ['Center integrated in aesthetic clinic', 'Personalized protocols', 'Advanced technology', 'Medical approach and visible results', 'Complete support'],
      ctaTitle: 'Your skin deserves the best care',
      ctaDesc: 'Request your appointment and we will design a personalized treatment plan for your skin.',
      ctaBtn: 'Request appointment',
    },
    fr: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Skin',
      title2: 'Health',
      heroDesc1: 'Traitements avancés pour améliorer la qualité de la peau, stimuler le collagène, corriger les imperfections et redonner de la luminosité.',
      heroDesc2: 'Idéaux tant pour les patients de la clinique que pour les nouveaux clients à la recherche d\'une peau plus saine et éclatante.',
      requestAppt: 'Demander un rendez-vous',
      callNow: 'Appeler maintenant',
      treatLabel: 'Traitements principaux',
      treatTitle: 'Soins experts pour votre peau',
      t1Name: 'Skin Reset', t1Sub: 'Nettoyage en profondeur',
      t1Desc: 'Protocole de nettoyage et de renouvellement complet de la peau. Élimine les impuretés, désobstrue les pores et prépare la peau à recevoir les traitements suivants avec une efficacité maximale.',
      t2Name: 'Marbella Glow', t2Sub: 'Traitement illuminateur',
      t2Desc: 'Traitement exclusif pour redonner luminosité et éclat à votre peau. Combine des technologies avancées avec des actifs de dernière génération pour un effet glow visible dès la première séance.',
      t3Name: 'Collagen Boost', t3Sub: 'Microneedling',
      t3Desc: 'Stimulation intensive du collagène par microneedling de précision. Améliore la texture, réduit les pores, atténue les cicatrices et redonne de la fermeté à la peau naturellement.',
      t4Name: 'Peeling Chimique', t4Sub: 'Renouvellement cutané',
      t4Desc: 'Renouvellement profond de la peau par peelings chimiques personnalisés. Corrige les taches, améliore la texture et stimule la régénération cellulaire pour une peau plus uniforme et jeune.',
      compLabel: 'Services complémentaires',
      compTitle: 'Traitements esthétiques additionnels',
      compSubtitle: 'Disponibles en complément des protocoles médicaux, sur demande.',
      comp1Title: 'Massages et récupération',
      comp1Items: ['Drainage lymphatique', 'Massage thérapeutique', 'Massage sportif', 'Réflexologie', 'Massage relaxant'],
      comp2Title: 'Traitements faciaux',
      comp2Items: ['Nettoyage facial', 'Traitements hydratants', 'Microneedling', 'Peeling'],
      comp3Title: 'Beauté et soins',
      comp3Items: ['Micropigmentation', 'Épilation faciale', 'Soins des mains et des pieds'],
      whyLabel: 'Pourquoi nous choisir ?',
      whyTitle: 'Une expérience de soins complète',
      whyItems: ['Centre intégré en clinique esthétique', 'Protocoles personnalisés', 'Technologie avancée', 'Approche médicale et résultats visibles', 'Accompagnement complet'],
      ctaTitle: 'Votre peau mérite les meilleurs soins',
      ctaDesc: 'Demandez votre rendez-vous et nous concevrons un plan de traitement personnalisé pour votre peau.',
      ctaBtn: 'Demander un rendez-vous',
    },
    pt: {
      badge: 'Skin Health & Recovery Center',
      title1: 'Skin',
      title2: 'Health',
      heroDesc1: 'Tratamentos avançados para melhorar a qualidade da pele, estimular o colágeno, corrigir imperfeições e devolver luminosidade.',
      heroDesc2: 'Ideais tanto para pacientes da clínica como para novos clientes que procuram uma pele mais saudável e radiante.',
      requestAppt: 'Solicitar consulta',
      callNow: 'Ligar agora',
      treatLabel: 'Tratamentos principais',
      treatTitle: 'Cuidado especializado para a sua pele',
      t1Name: 'Skin Reset', t1Sub: 'Limpeza profunda',
      t1Desc: 'Protocolo de limpeza e renovação completa da pele. Elimina impurezas, desobstrui poros e prepara a pele para receber tratamentos posteriores com máxima eficácia.',
      t2Name: 'Marbella Glow', t2Sub: 'Tratamento iluminador',
      t2Desc: 'Tratamento exclusivo para devolver a luminosidade e o esplendor à sua pele. Combina tecnologias avançadas com ativos de última geração para um efeito glow visível desde a primeira sessão.',
      t3Name: 'Collagen Boost', t3Sub: 'Microneedling',
      t3Desc: 'Estimulação intensiva do colágeno através de microneedling de precisão. Melhora a textura, reduz poros, atenua cicatrizes e devolve firmeza à pele de forma natural.',
      t4Name: 'Peeling Químico', t4Sub: 'Renovação cutânea',
      t4Desc: 'Renovação profunda da pele através de peelings químicos personalizados. Corrige manchas, melhora a textura e estimula a regeneração celular para uma pele mais uniforme e jovem.',
      compLabel: 'Serviços complementares',
      compTitle: 'Tratamentos estéticos adicionais',
      compSubtitle: 'Disponíveis como complemento aos protocolos médicos, mediante solicitação.',
      comp1Title: 'Massagens e recuperação',
      comp1Items: ['Drenagem linfática', 'Massagem terapêutica', 'Massagem desportiva', 'Reflexologia', 'Massagem relaxante'],
      comp2Title: 'Tratamentos faciais',
      comp2Items: ['Limpeza facial', 'Tratamentos hidratantes', 'Microneedling', 'Peeling'],
      comp3Title: 'Beleza e cuidado',
      comp3Items: ['Micropigmentação', 'Depilação facial', 'Cuidado de mãos e pés'],
      whyLabel: 'Por que nos escolher?',
      whyTitle: 'Uma experiência de cuidado integral',
      whyItems: ['Centro integrado em clínica estética', 'Protocolos personalizados', 'Tecnologia avançada', 'Abordagem médica e resultados visíveis', 'Acompanhamento completo'],
      ctaTitle: 'A sua pele merece o melhor cuidado',
      ctaDesc: 'Solicite a sua consulta e desenharemos um plano de tratamento personalizado para a sua pele.',
      ctaBtn: 'Solicitar consulta',
    },
  },
};
